var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _g, _g2, _g3, _rect, _g4, _rect2, _g5, _rect3, _g6, _rect4, _g7, _g8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBunnyEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 131,
    viewBox: "0 0 132 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 64,
    width: 34,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 85.4083C98.5 85.4922 98.5447 85.5699 98.6174 85.612L114.633 94.8963C114.706 94.9386 114.796 94.9386 114.869 94.8963L130.884 85.612C130.957 85.5699 131.002 85.4922 131.002 85.4083V74.3753C131.002 74.2913 130.957 74.2137 130.884 74.1715L114.869 64.8873C114.796 64.8449 114.706 64.8449 114.633 64.8873L98.6174 74.1715C98.5447 74.2137 98.5 74.2913 98.5 74.3753V85.4083Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_258_570)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.75 64.8178L98.499 74.2386L98.499 85.543L114.75 94.9638L131.001 85.543V74.2386L114.75 64.8178Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 11.3043,
    transform: "matrix(0.86514 -0.501531 2.19408e-08 1 114.75 83.6594)",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 11.3043,
    transform: "matrix(-0.86514 -0.501531 -2.19408e-08 1 114.75 83.6594)",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 18.7841,
    transform: "matrix(-0.86514 -0.50153 0.86514 -0.501531 114.75 83.6594)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M131 85.5435L114.75 94.9638",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M114.75 94.9638L98.5 85.5435",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M131 74.2391L131 85.5435",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M98.5 74.2391L98.5 85.5435",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.75 83.6594V94.9637",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131 74.2391L114.75 83.6594",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.75 83.6594L98.5 74.2391",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.75 83.6594V94.9637",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 74.2391L114.75 83.6594",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.75 83.6594L98.5 74.2391",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 65,
    width: 8,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.967 70.2902C118.142 70.0459 118.229 69.7856 118.229 69.5254V67.6413C118.229 67.381 118.142 67.1207 117.967 66.8764C117.799 66.6407 117.55 66.4199 117.219 66.2284C116.889 66.0368 116.508 65.8922 116.101 65.7947C115.68 65.6936 115.231 65.6431 114.782 65.6431C114.333 65.6431 113.884 65.6936 113.462 65.7947C113.056 65.8922 112.675 66.0368 112.345 66.2284C112.014 66.4199 111.765 66.6407 111.597 66.8764C111.422 67.1207 111.335 67.381 111.335 67.6413V69.5254C111.335 69.7856 111.422 70.0459 111.597 70.2902C111.765 70.5259 112.014 70.7467 112.345 70.9383C112.675 71.1299 113.056 71.2744 113.462 71.3719C113.884 71.473 114.333 71.5236 114.782 71.5236C115.231 71.5236 115.68 71.473 116.101 71.3719C116.508 71.2744 116.889 71.1299 117.219 70.9383C117.55 70.7467 117.799 70.5259 117.967 70.2902Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_258_570)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.967 70.2902C118.142 70.0459 118.229 69.7856 118.229 69.5254V67.6413C118.229 67.381 118.142 67.1207 117.967 66.8764C117.799 66.6407 117.55 66.4199 117.219 66.2284C116.889 66.0368 116.508 65.8922 116.101 65.7947C115.68 65.6936 115.231 65.6431 114.782 65.6431C114.333 65.6431 113.884 65.6936 113.462 65.7947C113.056 65.8922 112.675 66.0368 112.345 66.2284C112.014 66.4199 111.765 66.6407 111.597 66.8764C111.422 67.1207 111.335 67.381 111.335 67.6413V69.5254C111.335 69.7856 111.422 70.0459 111.597 70.2902C111.765 70.5259 112.014 70.7467 112.345 70.9383C112.675 71.1299 113.056 71.2744 113.462 71.3719C113.884 71.473 114.333 71.5236 114.782 71.5236C115.231 71.5236 115.68 71.473 116.101 71.3719C116.508 71.2744 116.889 71.1299 117.219 70.9383C117.55 70.7467 117.799 70.5259 117.967 70.2902Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.967 70.2938C118.142 70.0495 118.229 69.7893 118.229 69.529V67.6449C118.229 67.9052 118.142 68.1655 117.967 68.4098C117.799 68.6455 117.55 68.8663 117.219 69.0578C116.889 69.2494 116.508 69.394 116.101 69.4915C115.68 69.5926 115.231 69.6431 114.782 69.6431C114.333 69.6431 113.884 69.5926 113.462 69.4915C113.056 69.394 112.675 69.2494 112.345 69.0578C112.014 68.8663 111.765 68.6455 111.597 68.4098C111.422 68.1655 111.335 67.9052 111.335 67.6449V69.529C111.335 69.7893 111.422 70.0495 111.597 70.2938C111.765 70.5295 112.014 70.7503 112.345 70.9419C112.675 71.1335 113.056 71.278 113.462 71.3755C113.884 71.4766 114.333 71.5272 114.782 71.5272C115.231 71.5272 115.68 71.4766 116.101 71.3755C116.508 71.278 116.889 71.1335 117.219 70.9419C117.55 70.7503 117.799 70.5295 117.967 70.2938Z",
    fill: "url(#paint0_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.597 66.8764C111.422 67.1207 111.335 67.381 111.335 67.6413C111.335 67.9016 111.422 68.1619 111.597 68.4062C111.765 68.6419 112.014 68.8627 112.345 69.0542C112.675 69.2458 113.056 69.3904 113.462 69.4879C113.884 69.589 114.333 69.6395 114.782 69.6395C115.231 69.6395 115.68 69.589 116.101 69.4879C116.508 69.3904 116.889 69.2458 117.219 69.0542C117.55 68.8627 117.799 68.6419 117.967 68.4062C118.142 68.1619 118.229 67.9016 118.229 67.6413C118.229 67.381 118.142 67.1207 117.967 66.8764C117.799 66.6407 117.55 66.4199 117.219 66.2284C116.889 66.0368 116.508 65.8922 116.101 65.7947C115.68 65.6936 115.231 65.6431 114.782 65.6431C114.333 65.6431 113.884 65.6936 113.462 65.7947C113.056 65.8922 112.675 66.0368 112.345 66.2284C112.014 66.4199 111.765 66.6407 111.597 66.8764Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.522 66.8206C111.348 67.0649 111.335 67.4325 111.335 67.6927C111.335 67.953 111.422 68.2133 111.597 68.4576C111.765 68.6933 112.014 68.9141 112.345 69.1057C112.675 69.2973 113.056 69.4418 113.462 69.5393C113.884 69.6404 114.333 69.6909 114.782 69.6909C115.231 69.6909 115.68 69.6404 116.101 69.5393C116.508 69.4418 116.889 69.2973 117.219 69.1057C117.55 68.9141 117.799 68.6933 117.967 68.4576C118.142 68.2133 118.229 67.953 118.229 67.6927C118.229 67.4325 118.217 67.076 118.042 66.8317",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.522 66.8206C111.348 67.0649 111.335 67.4325 111.335 67.6927C111.335 67.953 111.422 68.2133 111.597 68.4576C111.765 68.6933 112.014 68.9141 112.345 69.1057C112.675 69.2973 113.056 69.4418 113.462 69.5393C113.884 69.6404 114.333 69.6909 114.782 69.6909C115.231 69.6909 115.68 69.6404 116.101 69.5393C116.508 69.4418 116.889 69.2973 117.219 69.1057C117.55 68.9141 117.799 68.6933 117.967 68.4576C118.142 68.2133 118.229 67.953 118.229 67.6927C118.229 67.4325 118.217 67.076 118.042 66.8317",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 70,
    width: 8,
    height: 7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.842 75.0004C110.017 74.7561 110.104 74.4958 110.104 74.2355V72.3515C110.104 72.0912 110.017 71.8309 109.842 71.5866C109.674 71.3509 109.425 71.1301 109.094 70.9385C108.764 70.7469 108.383 70.6024 107.976 70.5049C107.555 70.4038 107.106 70.3533 106.657 70.3533C106.208 70.3533 105.759 70.4038 105.337 70.5049C104.931 70.6024 104.55 70.7469 104.22 70.9385C103.889 71.1301 103.64 71.3509 103.472 71.5866C103.297 71.8309 103.21 72.0912 103.21 72.3515V74.2355C103.21 74.4958 103.297 74.7561 103.472 75.0004C103.64 75.2361 103.889 75.4569 104.22 75.6484C104.55 75.84 104.931 75.9846 105.337 76.0821C105.759 76.1832 106.208 76.2337 106.657 76.2337C107.106 76.2337 107.555 76.1832 107.976 76.0821C108.383 75.9846 108.764 75.84 109.094 75.6484C109.425 75.4569 109.674 75.2361 109.842 75.0004Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_258_570)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.842 75.0004C110.017 74.7561 110.104 74.4958 110.104 74.2355V72.3515C110.104 72.0912 110.017 71.8309 109.842 71.5866C109.674 71.3509 109.425 71.1301 109.094 70.9385C108.764 70.7469 108.383 70.6024 107.976 70.5049C107.555 70.4038 107.106 70.3533 106.657 70.3533C106.208 70.3533 105.759 70.4038 105.337 70.5049C104.931 70.6024 104.55 70.7469 104.22 70.9385C103.889 71.1301 103.64 71.3509 103.472 71.5866C103.297 71.8309 103.21 72.0912 103.21 72.3515V74.2355C103.21 74.4958 103.297 74.7561 103.472 75.0004C103.64 75.2361 103.889 75.4569 104.22 75.6484C104.55 75.84 104.931 75.9846 105.337 76.0821C105.759 76.1832 106.208 76.2337 106.657 76.2337C107.106 76.2337 107.555 76.1832 107.976 76.0821C108.383 75.9846 108.764 75.84 109.094 75.6484C109.425 75.4569 109.674 75.2361 109.842 75.0004Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.842 75.004C110.017 74.7597 110.104 74.4994 110.104 74.2391V72.3551C110.104 72.6154 110.017 72.8756 109.842 73.1199C109.674 73.3556 109.425 73.5764 109.094 73.768C108.764 73.9596 108.383 74.1041 107.976 74.2016C107.555 74.3027 107.106 74.3533 106.657 74.3533C106.208 74.3533 105.759 74.3027 105.337 74.2016C104.931 74.1041 104.55 73.9596 104.22 73.768C103.889 73.5764 103.64 73.3556 103.472 73.1199C103.297 72.8756 103.21 72.6154 103.21 72.3551V74.2391C103.21 74.4994 103.297 74.7597 103.472 75.004C103.64 75.2397 103.889 75.4605 104.22 75.6521C104.55 75.8436 104.931 75.9882 105.337 76.0857C105.759 76.1868 106.208 76.2373 106.657 76.2373C107.106 76.2373 107.555 76.1868 107.976 76.0857C108.383 75.9882 108.764 75.8436 109.094 75.6521C109.425 75.4605 109.674 75.2397 109.842 75.004Z",
    fill: "url(#paint1_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.472 71.5866C103.297 71.8309 103.21 72.0912 103.21 72.3515C103.21 72.6117 103.297 72.872 103.472 73.1163C103.64 73.352 103.889 73.5728 104.22 73.7644C104.55 73.956 104.931 74.1005 105.337 74.198C105.759 74.2991 106.208 74.3496 106.657 74.3496C107.106 74.3496 107.555 74.2991 107.976 74.198C108.383 74.1005 108.764 73.956 109.094 73.7644C109.425 73.5728 109.674 73.352 109.842 73.1163C110.017 72.872 110.104 72.6117 110.104 72.3515C110.104 72.0912 110.017 71.8309 109.842 71.5866C109.674 71.3509 109.425 71.1301 109.094 70.9385C108.764 70.7469 108.383 70.6024 107.976 70.5049C107.555 70.4038 107.106 70.3533 106.657 70.3533C106.208 70.3533 105.759 70.4038 105.337 70.5049C104.931 70.6024 104.55 70.7469 104.22 70.9385C103.889 71.1301 103.64 71.3509 103.472 71.5866Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.397 71.5308C103.223 71.7751 103.21 72.1426 103.21 72.4029C103.21 72.6632 103.297 72.9235 103.472 73.1678C103.64 73.4035 103.889 73.6243 104.22 73.8158C104.55 74.0074 104.931 74.152 105.337 74.2495C105.759 74.3506 106.208 74.4011 106.657 74.4011C107.106 74.4011 107.555 74.3506 107.976 74.2495C108.383 74.152 108.764 74.0074 109.094 73.8158C109.425 73.6243 109.674 73.4035 109.842 73.1678C110.017 72.9235 110.104 72.6632 110.104 72.4029C110.104 72.1426 110.092 71.7861 109.917 71.5418",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.397 71.5308C103.223 71.7751 103.21 72.1426 103.21 72.4029C103.21 72.6632 103.297 72.9235 103.472 73.1678C103.64 73.4035 103.889 73.6243 104.22 73.8158C104.55 74.0074 104.931 74.152 105.337 74.2495C105.759 74.3506 106.208 74.4011 106.657 74.4011C107.106 74.4011 107.555 74.3506 107.976 74.2495C108.383 74.152 108.764 74.0074 109.094 73.8158C109.425 73.6243 109.674 73.4035 109.842 73.1678C110.017 72.9235 110.104 72.6632 110.104 72.4029C110.104 72.1426 110.092 71.7861 109.917 71.5418",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 70,
    width: 8,
    height: 7
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.092 75.0004C126.267 74.7561 126.354 74.4958 126.354 74.2355V72.3515C126.354 72.0912 126.267 71.8309 126.092 71.5866C125.924 71.3509 125.675 71.1301 125.344 70.9385C125.014 70.7469 124.633 70.6024 124.226 70.5049C123.805 70.4038 123.356 70.3533 122.907 70.3533C122.458 70.3533 122.009 70.4038 121.587 70.5049C121.181 70.6024 120.8 70.7469 120.47 70.9385C120.139 71.1301 119.89 71.3509 119.722 71.5866C119.547 71.8309 119.46 72.0912 119.46 72.3515V74.2355C119.46 74.4958 119.547 74.7561 119.722 75.0004C119.89 75.2361 120.139 75.4569 120.47 75.6485C120.8 75.84 121.181 75.9846 121.587 76.0821C122.009 76.1832 122.458 76.2337 122.907 76.2337C123.356 76.2337 123.805 76.1832 124.226 76.0821C124.633 75.9846 125.014 75.84 125.344 75.6485C125.675 75.4569 125.924 75.2361 126.092 75.0004Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_258_570)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.092 75.0004C126.267 74.7561 126.354 74.4958 126.354 74.2355V72.3515C126.354 72.0912 126.267 71.8309 126.092 71.5866C125.924 71.3509 125.675 71.1301 125.344 70.9385C125.014 70.7469 124.633 70.6024 124.226 70.5049C123.805 70.4038 123.356 70.3533 122.907 70.3533C122.458 70.3533 122.009 70.4038 121.587 70.5049C121.181 70.6024 120.8 70.7469 120.47 70.9385C120.139 71.1301 119.89 71.3509 119.722 71.5866C119.547 71.8309 119.46 72.0912 119.46 72.3515V74.2355C119.46 74.4958 119.547 74.7561 119.722 75.0004C119.89 75.2361 120.139 75.4569 120.47 75.6485C120.8 75.84 121.181 75.9846 121.587 76.0821C122.009 76.1832 122.458 76.2337 122.907 76.2337C123.356 76.2337 123.805 76.1832 124.226 76.0821C124.633 75.9846 125.014 75.84 125.344 75.6485C125.675 75.4569 125.924 75.2361 126.092 75.0004Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.092 75.004C126.267 74.7597 126.354 74.4994 126.354 74.2391V72.3551C126.354 72.6154 126.267 72.8756 126.092 73.1199C125.924 73.3556 125.675 73.5764 125.344 73.768C125.014 73.9596 124.633 74.1041 124.226 74.2016C123.805 74.3027 123.356 74.3533 122.907 74.3533C122.458 74.3533 122.009 74.3027 121.587 74.2016C121.181 74.1041 120.8 73.9596 120.47 73.768C120.139 73.5764 119.89 73.3556 119.722 73.1199C119.547 72.8756 119.46 72.6154 119.46 72.3551V74.2391C119.46 74.4994 119.547 74.7597 119.722 75.004C119.89 75.2397 120.139 75.4605 120.47 75.6521C120.8 75.8436 121.181 75.9882 121.587 76.0857C122.009 76.1868 122.458 76.2373 122.907 76.2373C123.356 76.2373 123.805 76.1868 124.226 76.0857C124.633 75.9882 125.014 75.8436 125.344 75.6521C125.675 75.4605 125.924 75.2397 126.092 75.004Z",
    fill: "url(#paint2_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.722 71.5866C119.547 71.8309 119.46 72.0912 119.46 72.3515C119.46 72.6117 119.547 72.872 119.722 73.1163C119.89 73.352 120.139 73.5728 120.47 73.7644C120.8 73.956 121.181 74.1005 121.587 74.198C122.009 74.2991 122.458 74.3497 122.907 74.3497C123.356 74.3497 123.805 74.2991 124.226 74.198C124.633 74.1005 125.014 73.956 125.344 73.7644C125.675 73.5728 125.924 73.352 126.092 73.1163C126.267 72.872 126.354 72.6117 126.354 72.3515C126.354 72.0912 126.267 71.8309 126.092 71.5866C125.924 71.3509 125.675 71.1301 125.344 70.9385C125.014 70.7469 124.633 70.6024 124.226 70.5049C123.805 70.4038 123.356 70.3533 122.907 70.3533C122.458 70.3533 122.009 70.4038 121.587 70.5049C121.181 70.6024 120.8 70.7469 120.47 70.9385C120.139 71.1301 119.89 71.3509 119.722 71.5866Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.647 71.5308C119.473 71.7751 119.46 72.1426 119.46 72.4029C119.46 72.6632 119.547 72.9235 119.722 73.1678C119.89 73.4035 120.139 73.6243 120.47 73.8158C120.8 74.0074 121.181 74.152 121.587 74.2495C122.009 74.3506 122.458 74.4011 122.907 74.4011C123.356 74.4011 123.805 74.3506 124.226 74.2495C124.633 74.152 125.014 74.0074 125.344 73.8158C125.675 73.6243 125.924 73.4035 126.092 73.1678C126.267 72.9235 126.354 72.6632 126.354 72.4029C126.354 72.1426 126.342 71.7861 126.167 71.5418",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.647 71.5308C119.473 71.7751 119.46 72.1426 119.46 72.4029C119.46 72.6632 119.547 72.9235 119.722 73.1678C119.89 73.4035 120.139 73.6243 120.47 73.8158C120.8 74.0074 121.181 74.152 121.587 74.2495C122.009 74.3506 122.458 74.4011 122.907 74.4011C123.356 74.4011 123.805 74.3506 124.226 74.2495C124.633 74.152 125.014 74.0074 125.344 73.8158C125.675 73.6243 125.924 73.4035 126.092 73.1678C126.267 72.9235 126.354 72.6632 126.354 72.4029C126.354 72.1426 126.342 71.7861 126.167 71.5418",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 75,
    width: 8,
    height: 6
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M117.967 79.7105C118.142 79.4662 118.229 79.2059 118.229 78.9456V77.0616C118.229 76.8013 118.142 76.541 117.967 76.2967C117.799 76.061 117.55 75.8402 117.219 75.6487C116.889 75.4571 116.508 75.3125 116.101 75.215C115.68 75.1139 115.231 75.0634 114.782 75.0634C114.333 75.0634 113.884 75.1139 113.462 75.215C113.056 75.3125 112.675 75.4571 112.345 75.6487C112.014 75.8402 111.765 76.061 111.597 76.2967C111.422 76.541 111.335 76.8013 111.335 77.0616V78.9456C111.335 79.2059 111.422 79.4662 111.597 79.7105C111.765 79.9462 112.014 80.167 112.345 80.3586C112.675 80.5502 113.056 80.6947 113.462 80.7922C113.884 80.8933 114.333 80.9438 114.782 80.9438C115.231 80.9438 115.68 80.8933 116.101 80.7922C116.508 80.6947 116.889 80.5502 117.219 80.3586C117.55 80.167 117.799 79.9462 117.967 79.7105Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_258_570)"
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.967 79.7105C118.142 79.4662 118.229 79.2059 118.229 78.9456V77.0616C118.229 76.8013 118.142 76.541 117.967 76.2967C117.799 76.061 117.55 75.8402 117.219 75.6487C116.889 75.4571 116.508 75.3125 116.101 75.215C115.68 75.1139 115.231 75.0634 114.782 75.0634C114.333 75.0634 113.884 75.1139 113.462 75.215C113.056 75.3125 112.675 75.4571 112.345 75.6487C112.014 75.8402 111.765 76.061 111.597 76.2967C111.422 76.541 111.335 76.8013 111.335 77.0616V78.9456C111.335 79.2059 111.422 79.4662 111.597 79.7105C111.765 79.9462 112.014 80.167 112.345 80.3586C112.675 80.5502 113.056 80.6947 113.462 80.7922C113.884 80.8933 114.333 80.9438 114.782 80.9438C115.231 80.9438 115.68 80.8933 116.101 80.7922C116.508 80.6947 116.889 80.5502 117.219 80.3586C117.55 80.167 117.799 79.9462 117.967 79.7105Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.967 79.7141C118.142 79.4698 118.229 79.2095 118.229 78.9493V77.0652C118.229 77.3255 118.142 77.5858 117.967 77.8301C117.799 78.0658 117.55 78.2866 117.219 78.4781C116.889 78.6697 116.508 78.8143 116.101 78.9118C115.68 79.0129 115.231 79.0634 114.782 79.0634C114.333 79.0634 113.884 79.0129 113.462 78.9118C113.056 78.8143 112.675 78.6697 112.345 78.4781C112.014 78.2866 111.765 78.0658 111.597 77.8301C111.422 77.5858 111.335 77.3255 111.335 77.0652V78.9493C111.335 79.2095 111.422 79.4698 111.597 79.7141C111.765 79.9498 112.014 80.1706 112.345 80.3622C112.675 80.5538 113.056 80.6983 113.462 80.7958C113.884 80.8969 114.333 80.9475 114.782 80.9475C115.231 80.9475 115.68 80.8969 116.101 80.7958C116.508 80.6983 116.889 80.5538 117.219 80.3622C117.55 80.1706 117.799 79.9498 117.967 79.7141Z",
    fill: "url(#paint3_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.597 76.2967C111.422 76.541 111.335 76.8013 111.335 77.0616C111.335 77.3219 111.422 77.5822 111.597 77.8265C111.765 78.0621 112.014 78.283 112.345 78.4745C112.675 78.6661 113.056 78.8107 113.462 78.9082C113.884 79.0092 114.333 79.0598 114.782 79.0598C115.231 79.0598 115.68 79.0092 116.101 78.9082C116.508 78.8107 116.889 78.6661 117.219 78.4745C117.55 78.283 117.799 78.0621 117.967 77.8265C118.142 77.5822 118.229 77.3219 118.229 77.0616C118.229 76.8013 118.142 76.541 117.967 76.2967C117.799 76.061 117.55 75.8402 117.219 75.6487C116.889 75.4571 116.508 75.3125 116.101 75.215C115.68 75.1139 115.231 75.0634 114.782 75.0634C114.333 75.0634 113.884 75.1139 113.462 75.215C113.056 75.3125 112.675 75.4571 112.345 75.6487C112.014 75.8402 111.765 76.061 111.597 76.2967Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.522 76.2409C111.348 76.4852 111.335 76.8528 111.335 77.113C111.335 77.3733 111.422 77.6336 111.597 77.8779C111.765 78.1136 112.014 78.3344 112.345 78.526C112.675 78.7176 113.056 78.8621 113.462 78.9596C113.884 79.0607 114.333 79.1112 114.782 79.1112C115.231 79.1112 115.68 79.0607 116.101 78.9596C116.508 78.8621 116.889 78.7176 117.219 78.526C117.55 78.3344 117.799 78.1136 117.967 77.8779C118.142 77.6336 118.229 77.3733 118.229 77.113C118.229 76.8528 118.217 76.4963 118.042 76.252",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.522 76.2409C111.348 76.4852 111.335 76.8528 111.335 77.113C111.335 77.3733 111.422 77.6336 111.597 77.8779C111.765 78.1136 112.014 78.3344 112.345 78.526C112.675 78.7176 113.056 78.8621 113.462 78.9596C113.884 79.0607 114.333 79.1112 114.782 79.1112C115.231 79.1112 115.68 79.0607 116.101 78.9596C116.508 78.8621 116.889 78.7176 117.219 78.526C117.55 78.3344 117.799 78.1136 117.967 77.8779C118.142 77.6336 118.229 77.3733 118.229 77.113C118.229 76.8528 118.217 76.4963 118.042 76.252",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 98,
    y: 53,
    width: 33,
    height: 31
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M131 73.9861C131 74.0701 130.955 74.1478 130.883 74.1899L114.867 83.4741C114.794 83.5165 114.704 83.5165 114.631 83.4741L98.6157 74.1899C98.5431 74.1478 98.4983 74.0701 98.4983 73.9861V72.3007C98.4983 72.2595 98.5091 72.219 98.5297 72.1833L106.592 58.1618C106.613 58.126 106.643 58.0962 106.678 58.0755L114.631 53.4652C114.704 53.4228 114.794 53.4228 114.867 53.4652L130.883 62.7494C130.955 62.7916 131 62.8692 131 62.9532V73.9861Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_258_570)"
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.876 67.5269L122.875 67.5272L114.75 81.6576L122.876 67.5269ZM131.001 62.8168L114.75 53.396L106.624 58.1064L106.625 58.1069L98.5001 72.2373L98.4993 72.2368V74.1209L114.75 83.5416L131.001 74.1209L131.001 62.8165L131.001 62.8168Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 1.88406,
    transform: "matrix(-0.86514 -0.501531 -2.19408e-08 1 114.75 81.6576)",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.875 67.5269L131.001 62.8165L131.001 74.1209L114.75 83.5416L114.75 81.6576L122.875 67.5269Z",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.39203,
    height: 18.7841,
    transform: "matrix(0.86514 -0.50153 -0.86514 -0.501531 122.875 67.5272)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M98.5 72.2373L98.5 74.1214",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M131 62.817L131 74.1214",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.75 81.6576L114.75 83.5416",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 72.2373L114.75 81.6576",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.625 58.1069L122.875 67.5272",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.75 81.6576L122.875 67.5272",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.861 67.5353L131 62.817",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114.75 81.6576L114.75 83.5416",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5 72.2373L114.75 81.6576",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M98.5 74.1214L114.75 83.5417",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.625 58.1069L122.875 67.5272",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.75 81.6576L122.875 67.5272",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.861 67.5353L131 62.817",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M114.75 83.5417L131 74.1214",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 54,
    width: 8,
    height: 7
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M117.967 58.8681C118.142 58.6238 118.229 58.3635 118.229 58.1032V56.2192C118.229 55.9589 118.142 55.6986 117.967 55.4543C117.799 55.2186 117.55 54.9978 117.219 54.8063C116.889 54.6147 116.508 54.4701 116.101 54.3726C115.68 54.2715 115.231 54.221 114.782 54.221C114.333 54.221 113.884 54.2715 113.462 54.3726C113.056 54.4701 112.675 54.6147 112.345 54.8063C112.014 54.9978 111.765 55.2186 111.597 55.4543C111.422 55.6986 111.335 55.9589 111.335 56.2192V58.1032C111.335 58.3635 111.422 58.6238 111.597 58.8681C111.765 59.1038 112.014 59.3246 112.345 59.5162C112.675 59.7078 113.056 59.8523 113.462 59.9498C113.884 60.0509 114.333 60.1014 114.782 60.1014C115.231 60.1014 115.68 60.0509 116.101 59.9498C116.508 59.8523 116.889 59.7078 117.219 59.5162C117.55 59.3246 117.799 59.1038 117.967 58.8681Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_258_570)"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M117.967 58.8681C118.142 58.6238 118.229 58.3635 118.229 58.1032V56.2192C118.229 55.9589 118.142 55.6986 117.967 55.4543C117.799 55.2186 117.55 54.9978 117.219 54.8063C116.889 54.6147 116.508 54.4701 116.101 54.3726C115.68 54.2715 115.231 54.221 114.782 54.221C114.333 54.221 113.884 54.2715 113.462 54.3726C113.056 54.4701 112.675 54.6147 112.345 54.8063C112.014 54.9978 111.765 55.2186 111.597 55.4543C111.422 55.6986 111.335 55.9589 111.335 56.2192V58.1032C111.335 58.3635 111.422 58.6238 111.597 58.8681C111.765 59.1038 112.014 59.3246 112.345 59.5162C112.675 59.7078 113.056 59.8523 113.462 59.9498C113.884 60.0509 114.333 60.1014 114.782 60.1014C115.231 60.1014 115.68 60.0509 116.101 59.9498C116.508 59.8523 116.889 59.7078 117.219 59.5162C117.55 59.3246 117.799 59.1038 117.967 58.8681Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.967 58.8717C118.142 58.6274 118.229 58.3672 118.229 58.1069V56.2228C118.229 56.4831 118.142 56.7434 117.967 56.9877C117.799 57.2234 117.55 57.4442 117.219 57.6357C116.889 57.8273 116.508 57.9719 116.101 58.0694C115.68 58.1705 115.231 58.221 114.782 58.221C114.333 58.221 113.884 58.1705 113.462 58.0694C113.056 57.9719 112.675 57.8273 112.345 57.6357C112.014 57.4442 111.765 57.2234 111.597 56.9877C111.422 56.7434 111.335 56.4831 111.335 56.2228V58.1069C111.335 58.3672 111.422 58.6274 111.597 58.8717C111.765 59.1074 112.014 59.3282 112.345 59.5198C112.675 59.7114 113.056 59.8559 113.462 59.9534C113.884 60.0545 114.333 60.1051 114.782 60.1051C115.231 60.1051 115.68 60.0545 116.101 59.9534C116.508 59.8559 116.889 59.7114 117.219 59.5198C117.55 59.3282 117.799 59.1074 117.967 58.8717Z",
    fill: "url(#paint4_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.597 55.4543C111.422 55.6986 111.335 55.9589 111.335 56.2192C111.335 56.4795 111.422 56.7398 111.597 56.9841C111.765 57.2197 112.014 57.4406 112.345 57.6321C112.675 57.8237 113.056 57.9683 113.462 58.0658C113.884 58.1668 114.333 58.2174 114.782 58.2174C115.231 58.2174 115.68 58.1668 116.101 58.0658C116.508 57.9683 116.889 57.8237 117.219 57.6321C117.55 57.4406 117.799 57.2197 117.967 56.9841C118.142 56.7398 118.229 56.4795 118.229 56.2192C118.229 55.9589 118.142 55.6986 117.967 55.4543C117.799 55.2186 117.55 54.9978 117.219 54.8063C116.889 54.6147 116.508 54.4701 116.101 54.3726C115.68 54.2715 115.231 54.221 114.782 54.221C114.333 54.221 113.884 54.2715 113.462 54.3726C113.056 54.4701 112.675 54.6147 112.345 54.8063C112.014 54.9978 111.765 55.2186 111.597 55.4543Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M111.522 55.3985C111.348 55.6428 111.335 56.0104 111.335 56.2706C111.335 56.5309 111.422 56.7912 111.597 57.0355C111.765 57.2712 112.014 57.492 112.345 57.6836C112.675 57.8752 113.056 58.0197 113.462 58.1172C113.884 58.2183 114.333 58.2688 114.782 58.2688C115.231 58.2688 115.68 58.2183 116.101 58.1172C116.508 58.0197 116.889 57.8752 117.219 57.6836C117.55 57.492 117.799 57.2712 117.967 57.0355C118.142 56.7912 118.229 56.5309 118.229 56.2706C118.229 56.0104 118.217 55.6539 118.042 55.4096",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.522 55.3985C111.348 55.6428 111.335 56.0104 111.335 56.2706C111.335 56.5309 111.422 56.7912 111.597 57.0355C111.765 57.2712 112.014 57.492 112.345 57.6836C112.675 57.8752 113.056 58.0197 113.462 58.1172C113.884 58.2183 114.333 58.2688 114.782 58.2688C115.231 58.2688 115.68 58.2183 116.101 58.1172C116.508 58.0197 116.889 57.8752 117.219 57.6836C117.55 57.492 117.799 57.2712 117.967 57.0355C118.142 56.7912 118.229 56.5309 118.229 56.2706C118.229 56.0104 118.217 55.6539 118.042 55.4096",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 58,
    width: 8,
    height: 7
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M126.092 63.5783C126.267 63.334 126.354 63.0737 126.354 62.8134V60.9293C126.354 60.6691 126.267 60.4088 126.092 60.1645C125.924 59.9288 125.675 59.708 125.344 59.5164C125.014 59.3248 124.633 59.1803 124.226 59.0828C123.805 58.9817 123.356 58.9311 122.907 58.9311C122.458 58.9311 122.009 58.9817 121.587 59.0828C121.181 59.1803 120.8 59.3248 120.47 59.5164C120.139 59.708 119.89 59.9288 119.722 60.1645C119.547 60.4088 119.46 60.6691 119.46 60.9293V62.8134C119.46 63.0737 119.547 63.334 119.722 63.5783C119.89 63.814 120.139 64.0348 120.47 64.2263C120.8 64.4179 121.181 64.5625 121.587 64.66C122.009 64.7611 122.458 64.8116 122.907 64.8116C123.356 64.8116 123.805 64.7611 124.226 64.66C124.633 64.5625 125.014 64.4179 125.344 64.2263C125.675 64.0348 125.924 63.814 126.092 63.5783Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_258_570)"
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M126.092 63.5783C126.267 63.334 126.354 63.0737 126.354 62.8134V60.9293C126.354 60.6691 126.267 60.4088 126.092 60.1645C125.924 59.9288 125.675 59.708 125.344 59.5164C125.014 59.3248 124.633 59.1803 124.226 59.0828C123.805 58.9817 123.356 58.9311 122.907 58.9311C122.458 58.9311 122.009 58.9817 121.587 59.0828C121.181 59.1803 120.8 59.3248 120.47 59.5164C120.139 59.708 119.89 59.9288 119.722 60.1645C119.547 60.4088 119.46 60.6691 119.46 60.9293V62.8134C119.46 63.0737 119.547 63.334 119.722 63.5783C119.89 63.814 120.139 64.0348 120.47 64.2263C120.8 64.4179 121.181 64.5625 121.587 64.66C122.009 64.7611 122.458 64.8116 122.907 64.8116C123.356 64.8116 123.805 64.7611 124.226 64.66C124.633 64.5625 125.014 64.4179 125.344 64.2263C125.675 64.0348 125.924 63.814 126.092 63.5783Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.092 63.5819C126.267 63.3376 126.354 63.0773 126.354 62.817V60.933C126.354 61.1932 126.267 61.4535 126.092 61.6978C125.924 61.9335 125.675 62.1543 125.344 62.3459C125.014 62.5375 124.633 62.682 124.226 62.7795C123.805 62.8806 123.356 62.9312 122.907 62.9312C122.458 62.9312 122.009 62.8806 121.587 62.7795C121.181 62.682 120.8 62.5375 120.47 62.3459C120.139 62.1543 119.89 61.9335 119.722 61.6978C119.547 61.4535 119.46 61.1932 119.46 60.933V62.817C119.46 63.0773 119.547 63.3376 119.722 63.5819C119.89 63.8176 120.139 64.0384 120.47 64.23C120.8 64.4215 121.181 64.5661 121.587 64.6636C122.009 64.7647 122.458 64.8152 122.907 64.8152C123.356 64.8152 123.805 64.7647 124.226 64.6636C124.633 64.5661 125.014 64.4215 125.344 64.23C125.675 64.0384 125.924 63.8176 126.092 63.5819Z",
    fill: "url(#paint5_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.722 60.1645C119.547 60.4088 119.46 60.6691 119.46 60.9293C119.46 61.1896 119.547 61.4499 119.722 61.6942C119.89 61.9299 120.139 62.1507 120.47 62.3423C120.8 62.5339 121.181 62.6784 121.587 62.7759C122.009 62.877 122.458 62.9275 122.907 62.9275C123.356 62.9275 123.805 62.877 124.226 62.7759C124.633 62.6784 125.014 62.5339 125.344 62.3423C125.675 62.1507 125.924 61.9299 126.092 61.6942C126.267 61.4499 126.354 61.1896 126.354 60.9293C126.354 60.6691 126.267 60.4088 126.092 60.1645C125.924 59.9288 125.675 59.708 125.344 59.5164C125.014 59.3248 124.633 59.1803 124.226 59.0828C123.805 58.9817 123.356 58.9311 122.907 58.9311C122.458 58.9311 122.009 58.9817 121.587 59.0828C121.181 59.1803 120.8 59.3248 120.47 59.5164C120.139 59.708 119.89 59.9288 119.722 60.1645Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.647 60.1087C119.473 60.353 119.46 60.7205 119.46 60.9808C119.46 61.2411 119.547 61.5014 119.722 61.7457C119.89 61.9813 120.139 62.2022 120.47 62.3937C120.8 62.5853 121.181 62.7299 121.587 62.8274C122.009 62.9285 122.458 62.979 122.907 62.979C123.356 62.979 123.805 62.9285 124.226 62.8274C124.633 62.7299 125.014 62.5853 125.344 62.3937C125.675 62.2022 125.924 61.9813 126.092 61.7457C126.267 61.5014 126.354 61.2411 126.354 60.9808C126.354 60.7205 126.342 60.364 126.167 60.1197",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.647 60.1087C119.473 60.353 119.46 60.7205 119.46 60.9808C119.46 61.2411 119.547 61.5014 119.722 61.7457C119.89 61.9813 120.139 62.2022 120.47 62.3937C120.8 62.5853 121.181 62.7299 121.587 62.8274C122.009 62.9285 122.458 62.979 122.907 62.979C123.356 62.979 123.805 62.9285 124.226 62.8274C124.633 62.7299 125.014 62.5853 125.344 62.3937C125.675 62.2022 125.924 61.9813 126.092 61.7457C126.267 61.5014 126.354 61.2411 126.354 60.9808C126.354 60.7205 126.342 60.364 126.167 60.1197",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 64,
    width: 42,
    height: 36
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0076 90.3224L57.9923 99.6067C57.9192 99.649 57.8291 99.649 57.756 99.6067L33.6153 85.612C33.5426 85.5699 33.4979 85.4923 33.4979 85.4083V74.3753C33.4979 74.2913 33.5426 74.2137 33.6153 74.1716L49.6306 64.8873C49.7037 64.845 49.7938 64.845 49.8669 64.8873L74.0076 78.8819C74.0803 78.9241 74.125 79.0017 74.125 79.0857V90.1187C74.125 90.2026 74.0803 90.2803 74.0076 90.3224Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_258_570)"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7497 64.8176L74.126 78.9488L74.126 90.2531L57.8751 99.6739L33.4989 85.5427V74.2384L49.7497 64.8176Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 28.1761,
    height: 11.3043,
    transform: "matrix(-0.86514 -0.501531 -2.19408e-08 1 57.875 88.3696)",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 11.3043,
    transform: "matrix(0.86514 -0.501531 2.19408e-08 1 57.875 88.3696)",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 28.1761,
    transform: "matrix(0.86514 -0.50153 -0.86514 -0.501531 57.875 88.3696)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.4987 85.5435L57.875 99.6746",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M57.875 99.6739L74.125 90.2536",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5 74.2391L33.5 85.5435",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M74.125 78.9493L74.125 90.2536",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M57.875 88.3696V99.6739",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4987 74.2391L57.875 88.3703",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57.875 88.3695L74.125 78.9493",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.875 88.3696V99.6739",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4987 74.2391L57.875 88.3703",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.875 88.3695L74.125 78.9493",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 65,
    width: 8,
    height: 7
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 70.2902C53.1416 70.0459 53.2287 69.7856 53.2287 69.5254V67.6413C53.2287 67.381 53.1416 67.1207 52.9672 66.8764C52.799 66.6407 52.5496 66.4199 52.2192 66.2284C51.8887 66.0368 51.5078 65.8922 51.1013 65.7947C50.6798 65.6936 50.2308 65.6431 49.7819 65.6431C49.3329 65.6431 48.8839 65.6936 48.4624 65.7947C48.0559 65.8922 47.675 66.0368 47.3445 66.2284C47.0141 66.4199 46.7647 66.6407 46.5965 66.8764C46.4221 67.1207 46.335 67.381 46.335 67.6413V69.5254C46.335 69.7856 46.4221 70.0459 46.5965 70.2902C46.7647 70.5259 47.0141 70.7467 47.3445 70.9383C47.675 71.1299 48.0559 71.2744 48.4624 71.3719C48.8839 71.473 49.3329 71.5236 49.7819 71.5236C50.2308 71.5236 50.6798 71.473 51.1013 71.3719C51.5078 71.2744 51.8887 71.1299 52.2192 70.9383C52.5496 70.7467 52.799 70.5259 52.9672 70.2902Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_258_570)"
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 70.2902C53.1416 70.0459 53.2287 69.7856 53.2287 69.5254V67.6413C53.2287 67.381 53.1416 67.1207 52.9672 66.8764C52.799 66.6407 52.5496 66.4199 52.2192 66.2284C51.8887 66.0368 51.5078 65.8922 51.1013 65.7947C50.6798 65.6936 50.2308 65.6431 49.7819 65.6431C49.3329 65.6431 48.8839 65.6936 48.4624 65.7947C48.0559 65.8922 47.675 66.0368 47.3445 66.2284C47.0141 66.4199 46.7647 66.6407 46.5965 66.8764C46.4221 67.1207 46.335 67.381 46.335 67.6413V69.5254C46.335 69.7856 46.4221 70.0459 46.5965 70.2902C46.7647 70.5259 47.0141 70.7467 47.3445 70.9383C47.675 71.1299 48.0559 71.2744 48.4624 71.3719C48.8839 71.473 49.3329 71.5236 49.7819 71.5236C50.2308 71.5236 50.6798 71.473 51.1013 71.3719C51.5078 71.2744 51.8887 71.1299 52.2192 70.9383C52.5496 70.7467 52.799 70.5259 52.9672 70.2902Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 70.2938C53.1416 70.0495 53.2287 69.7893 53.2287 69.529V67.6449C53.2287 67.9052 53.1416 68.1655 52.9672 68.4098C52.799 68.6455 52.5496 68.8663 52.2192 69.0578C51.8887 69.2494 51.5078 69.394 51.1013 69.4915C50.6798 69.5926 50.2308 69.6431 49.7819 69.6431C49.3329 69.6431 48.8839 69.5926 48.4624 69.4915C48.0559 69.394 47.675 69.2494 47.3445 69.0578C47.0141 68.8663 46.7647 68.6455 46.5965 68.4098C46.4221 68.1655 46.335 67.9052 46.335 67.6449V69.529C46.335 69.7893 46.4221 70.0495 46.5965 70.2938C46.7647 70.5295 47.0141 70.7503 47.3445 70.9419C47.675 71.1335 48.0559 71.278 48.4624 71.3755C48.8839 71.4766 49.3329 71.5272 49.7819 71.5272C50.2308 71.5272 50.6798 71.4766 51.1013 71.3755C51.5078 71.278 51.8887 71.1335 52.2192 70.9419C52.5496 70.7503 52.799 70.5295 52.9672 70.2938Z",
    fill: "url(#paint6_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5965 66.8764C46.4221 67.1207 46.335 67.381 46.335 67.6413C46.335 67.9016 46.4221 68.1619 46.5965 68.4062C46.7647 68.6419 47.0141 68.8627 47.3445 69.0542C47.675 69.2458 48.0559 69.3904 48.4624 69.4879C48.8839 69.589 49.3329 69.6395 49.7819 69.6395C50.2308 69.6395 50.6798 69.589 51.1013 69.4879C51.5078 69.3904 51.8887 69.2458 52.2192 69.0542C52.5496 68.8627 52.799 68.6419 52.9672 68.4062C53.1416 68.1619 53.2287 67.9016 53.2287 67.6413C53.2287 67.381 53.1416 67.1207 52.9672 66.8764C52.799 66.6407 52.5496 66.4199 52.2192 66.2284C51.8887 66.0368 51.5078 65.8922 51.1013 65.7947C50.6798 65.6936 50.2308 65.6431 49.7819 65.6431C49.3329 65.6431 48.8839 65.6936 48.4624 65.7947C48.0559 65.8922 47.675 66.0368 47.3445 66.2284C47.0141 66.4199 46.7647 66.6407 46.5965 66.8764Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 66.8206C46.3481 67.0649 46.335 67.4325 46.335 67.6927C46.335 67.953 46.4221 68.2133 46.5965 68.4576C46.7647 68.6933 47.0141 68.9141 47.3445 69.1057C47.675 69.2973 48.0559 69.4418 48.4624 69.5393C48.8839 69.6404 49.3329 69.6909 49.7819 69.6909C50.2308 69.6909 50.6798 69.6404 51.1013 69.5393C51.5078 69.4418 51.8887 69.2973 52.2192 69.1057C52.5496 68.9141 52.799 68.6933 52.9672 68.4576C53.1416 68.2133 53.2287 67.953 53.2287 67.6927C53.2287 67.4325 53.2165 67.076 53.0422 66.8317",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 66.8206C46.3481 67.0649 46.335 67.4325 46.335 67.6927C46.335 67.953 46.4221 68.2133 46.5965 68.4576C46.7647 68.6933 47.0141 68.9141 47.3445 69.1057C47.675 69.2973 48.0559 69.4418 48.4624 69.5393C48.8839 69.6404 49.3329 69.6909 49.7819 69.6909C50.2308 69.6909 50.6798 69.6404 51.1013 69.5393C51.5078 69.4418 51.8887 69.2973 52.2192 69.1057C52.5496 68.9141 52.799 68.6933 52.9672 68.4576C53.1416 68.2133 53.2287 67.953 53.2287 67.6927C53.2287 67.4325 53.2165 67.076 53.0422 66.8317",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 70,
    width: 8,
    height: 7
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0922 75.0004C61.2666 74.7561 61.3537 74.4958 61.3537 74.2355V72.3514C61.3537 72.0912 61.2666 71.8309 61.0922 71.5866C60.924 71.3509 60.6746 71.1301 60.3442 70.9385C60.0137 70.7469 59.6328 70.6024 59.2263 70.5049C58.8048 70.4038 58.3558 70.3532 57.9069 70.3532C57.4579 70.3532 57.0089 70.4038 56.5874 70.5049C56.1809 70.6024 55.8 70.7469 55.4695 70.9385C55.1391 71.1301 54.8897 71.3509 54.7215 71.5866C54.5471 71.8309 54.46 72.0912 54.46 72.3514V74.2355C54.46 74.4958 54.5471 74.7561 54.7215 75.0004C54.8897 75.2361 55.1391 75.4569 55.4695 75.6484C55.8 75.84 56.1809 75.9846 56.5874 76.0821C57.0089 76.1832 57.4579 76.2337 57.9069 76.2337C58.3558 76.2337 58.8048 76.1832 59.2263 76.0821C59.6328 75.9846 60.0137 75.84 60.3442 75.6484C60.6746 75.4569 60.924 75.2361 61.0922 75.0004Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_258_570)"
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0922 75.0004C61.2666 74.7561 61.3537 74.4958 61.3537 74.2355V72.3514C61.3537 72.0912 61.2666 71.8309 61.0922 71.5866C60.924 71.3509 60.6746 71.1301 60.3442 70.9385C60.0137 70.7469 59.6328 70.6024 59.2263 70.5049C58.8048 70.4038 58.3558 70.3532 57.9069 70.3532C57.4579 70.3532 57.0089 70.4038 56.5874 70.5049C56.1809 70.6024 55.8 70.7469 55.4695 70.9385C55.1391 71.1301 54.8897 71.3509 54.7215 71.5866C54.5471 71.8309 54.46 72.0912 54.46 72.3514V74.2355C54.46 74.4958 54.5471 74.7561 54.7215 75.0004C54.8897 75.2361 55.1391 75.4569 55.4695 75.6484C55.8 75.84 56.1809 75.9846 56.5874 76.0821C57.0089 76.1832 57.4579 76.2337 57.9069 76.2337C58.3558 76.2337 58.8048 76.1832 59.2263 76.0821C59.6328 75.9846 60.0137 75.84 60.3442 75.6484C60.6746 75.4569 60.924 75.2361 61.0922 75.0004Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.0922 75.004C61.2666 74.7597 61.3537 74.4994 61.3537 74.2391V72.3551C61.3537 72.6153 61.2666 72.8756 61.0922 73.1199C60.924 73.3556 60.6746 73.5764 60.3442 73.768C60.0137 73.9596 59.6328 74.1041 59.2263 74.2016C58.8048 74.3027 58.3558 74.3533 57.9069 74.3533C57.4579 74.3533 57.0089 74.3027 56.5874 74.2016C56.1809 74.1041 55.8 73.9596 55.4695 73.768C55.1391 73.5764 54.8897 73.3556 54.7215 73.1199C54.5471 72.8756 54.46 72.6153 54.46 72.3551V74.2391C54.46 74.4994 54.5471 74.7597 54.7215 75.004C54.8897 75.2397 55.1391 75.4605 55.4695 75.6521C55.8 75.8436 56.1809 75.9882 56.5874 76.0857C57.0089 76.1868 57.4579 76.2373 57.9069 76.2373C58.3558 76.2373 58.8048 76.1868 59.2263 76.0857C59.6328 75.9882 60.0137 75.8436 60.3442 75.6521C60.6746 75.4605 60.924 75.2397 61.0922 75.004Z",
    fill: "url(#paint7_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7215 71.5866C54.5471 71.8309 54.46 72.0912 54.46 72.3514C54.46 72.6117 54.5471 72.872 54.7215 73.1163C54.8897 73.352 55.1391 73.5728 55.4695 73.7644C55.8 73.956 56.1809 74.1005 56.5874 74.198C57.0089 74.2991 57.4579 74.3496 57.9069 74.3496C58.3558 74.3496 58.8048 74.2991 59.2263 74.198C59.6328 74.1005 60.0137 73.956 60.3442 73.7644C60.6746 73.5728 60.924 73.352 61.0922 73.1163C61.2666 72.872 61.3537 72.6117 61.3537 72.3514C61.3537 72.0912 61.2666 71.8309 61.0922 71.5866C60.924 71.3509 60.6746 71.1301 60.3442 70.9385C60.0137 70.7469 59.6328 70.6024 59.2263 70.5049C58.8048 70.4038 58.3558 70.3532 57.9069 70.3532C57.4579 70.3532 57.0089 70.4038 56.5874 70.5049C56.1809 70.6024 55.8 70.7469 55.4695 70.9385C55.1391 71.1301 54.8897 71.3509 54.7215 71.5866Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6475 71.5308C54.4731 71.7751 54.46 72.1426 54.46 72.4029C54.46 72.6632 54.5471 72.9235 54.7215 73.1678C54.8897 73.4034 55.1391 73.6243 55.4695 73.8158C55.8 74.0074 56.1809 74.152 56.5874 74.2495C57.0089 74.3505 57.4579 74.4011 57.9069 74.4011C58.3558 74.4011 58.8048 74.3505 59.2263 74.2495C59.6328 74.152 60.0137 74.0074 60.3442 73.8158C60.6746 73.6243 60.924 73.4034 61.0922 73.1678C61.2666 72.9235 61.3537 72.6632 61.3537 72.4029C61.3537 72.1426 61.3415 71.7861 61.1672 71.5418",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.6475 71.5308C54.4731 71.7751 54.46 72.1426 54.46 72.4029C54.46 72.6632 54.5471 72.9235 54.7215 73.1678C54.8897 73.4034 55.1391 73.6243 55.4695 73.8158C55.8 74.0074 56.1809 74.152 56.5874 74.2495C57.0089 74.3505 57.4579 74.4011 57.9069 74.4011C58.3558 74.4011 58.8048 74.3505 59.2263 74.2495C59.6328 74.152 60.0137 74.0074 60.3442 73.8158C60.6746 73.6243 60.924 73.4034 61.0922 73.1678C61.2666 72.9235 61.3537 72.6632 61.3537 72.4029C61.3537 72.1426 61.3415 71.7861 61.1672 71.5418",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 75,
    width: 8,
    height: 6
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2172 79.7105C69.3916 79.4662 69.4787 79.2059 69.4787 78.9457V77.0616C69.4787 76.8013 69.3916 76.541 69.2172 76.2967C69.049 76.061 68.7996 75.8402 68.4692 75.6487C68.1387 75.4571 67.7578 75.3125 67.3513 75.215C66.9298 75.1139 66.4808 75.0634 66.0319 75.0634C65.5829 75.0634 65.1339 75.1139 64.7124 75.215C64.3059 75.3125 63.925 75.4571 63.5945 75.6487C63.2641 75.8402 63.0147 76.061 62.8465 76.2967C62.6721 76.541 62.585 76.8013 62.585 77.0616V78.9457C62.585 79.2059 62.6721 79.4662 62.8465 79.7105C63.0147 79.9462 63.2641 80.167 63.5945 80.3586C63.925 80.5502 64.3059 80.6947 64.7124 80.7922C65.1339 80.8933 65.5829 80.9439 66.0319 80.9439C66.4808 80.9439 66.9298 80.8933 67.3513 80.7922C67.7578 80.6947 68.1387 80.5502 68.4692 80.3586C68.7996 80.167 69.049 79.9462 69.2172 79.7105Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_258_570)"
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2172 79.7105C69.3916 79.4662 69.4787 79.2059 69.4787 78.9457V77.0616C69.4787 76.8013 69.3916 76.541 69.2172 76.2967C69.049 76.061 68.7996 75.8402 68.4692 75.6487C68.1387 75.4571 67.7578 75.3125 67.3513 75.215C66.9298 75.1139 66.4808 75.0634 66.0319 75.0634C65.5829 75.0634 65.1339 75.1139 64.7124 75.215C64.3059 75.3125 63.925 75.4571 63.5945 75.6487C63.2641 75.8402 63.0147 76.061 62.8465 76.2967C62.6721 76.541 62.585 76.8013 62.585 77.0616V78.9457C62.585 79.2059 62.6721 79.4662 62.8465 79.7105C63.0147 79.9462 63.2641 80.167 63.5945 80.3586C63.925 80.5502 64.3059 80.6947 64.7124 80.7922C65.1339 80.8933 65.5829 80.9439 66.0319 80.9439C66.4808 80.9439 66.9298 80.8933 67.3513 80.7922C67.7578 80.6947 68.1387 80.5502 68.4692 80.3586C68.7996 80.167 69.049 79.9462 69.2172 79.7105Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.2172 79.7141C69.3916 79.4698 69.4787 79.2096 69.4787 78.9493V77.0652C69.4787 77.3255 69.3916 77.5858 69.2172 77.8301C69.049 78.0658 68.7996 78.2866 68.4692 78.4781C68.1387 78.6697 67.7578 78.8143 67.3513 78.9118C66.9298 79.0129 66.4808 79.0634 66.0319 79.0634C65.5829 79.0634 65.1339 79.0129 64.7124 78.9118C64.3059 78.8143 63.925 78.6697 63.5945 78.4781C63.2641 78.2866 63.0147 78.0658 62.8465 77.8301C62.6721 77.5858 62.585 77.3255 62.585 77.0652V78.9493C62.585 79.2096 62.6721 79.4698 62.8465 79.7141C63.0147 79.9498 63.2641 80.1706 63.5945 80.3622C63.925 80.5538 64.3059 80.6983 64.7124 80.7958C65.1339 80.8969 65.5829 80.9475 66.0319 80.9475C66.4808 80.9475 66.9298 80.8969 67.3513 80.7958C67.7578 80.6983 68.1387 80.5538 68.4692 80.3622C68.7996 80.1706 69.049 79.9498 69.2172 79.7141Z",
    fill: "url(#paint8_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8465 76.2967C62.6721 76.541 62.585 76.8013 62.585 77.0616C62.585 77.3219 62.6721 77.5822 62.8465 77.8265C63.0147 78.0622 63.2641 78.283 63.5945 78.4745C63.925 78.6661 64.3059 78.8107 64.7124 78.9082C65.1339 79.0093 65.5829 79.0598 66.0319 79.0598C66.4808 79.0598 66.9298 79.0093 67.3513 78.9082C67.7578 78.8107 68.1387 78.6661 68.4692 78.4745C68.7996 78.283 69.049 78.0622 69.2172 77.8265C69.3916 77.5822 69.4787 77.3219 69.4787 77.0616C69.4787 76.8013 69.3916 76.541 69.2172 76.2967C69.049 76.061 68.7996 75.8402 68.4692 75.6487C68.1387 75.4571 67.7578 75.3125 67.3513 75.215C66.9298 75.1139 66.4808 75.0634 66.0319 75.0634C65.5829 75.0634 65.1339 75.1139 64.7124 75.215C64.3059 75.3125 63.925 75.4571 63.5945 75.6487C63.2641 75.8402 63.0147 76.061 62.8465 76.2967Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7725 76.2409C62.5981 76.4852 62.585 76.8528 62.585 77.113C62.585 77.3733 62.6721 77.6336 62.8465 77.8779C63.0147 78.1136 63.2641 78.3344 63.5945 78.526C63.925 78.7176 64.3059 78.8621 64.7124 78.9596C65.1339 79.0607 65.5829 79.1112 66.0319 79.1112C66.4808 79.1112 66.9298 79.0607 67.3513 78.9596C67.7578 78.8621 68.1387 78.7176 68.4692 78.526C68.7996 78.3344 69.049 78.1136 69.2172 77.8779C69.3916 77.6336 69.4787 77.3733 69.4787 77.113C69.4787 76.8528 69.4665 76.4963 69.2922 76.252",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.7725 76.2409C62.5981 76.4852 62.585 76.8528 62.585 77.113C62.585 77.3733 62.6721 77.6336 62.8465 77.8779C63.0147 78.1136 63.2641 78.3344 63.5945 78.526C63.925 78.7176 64.3059 78.8621 64.7124 78.9596C65.1339 79.0607 65.5829 79.1112 66.0319 79.1112C66.4808 79.1112 66.9298 79.0607 67.3513 78.9596C67.7578 78.8621 68.1387 78.7176 68.4692 78.526C68.7996 78.3344 69.049 78.1136 69.2172 77.8779C69.3916 77.6336 69.4787 77.3733 69.4787 77.113C69.4787 76.8528 69.4665 76.4963 69.2922 76.252",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 70,
    width: 8,
    height: 7
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 75.0004C45.0166 74.7561 45.1037 74.4958 45.1037 74.2355V72.3514C45.1037 72.0912 45.0166 71.8309 44.8422 71.5866C44.674 71.3509 44.4246 71.1301 44.0942 70.9385C43.7637 70.7469 43.3828 70.6024 42.9763 70.5049C42.5548 70.4038 42.1058 70.3532 41.6569 70.3532C41.2079 70.3532 40.7589 70.4038 40.3374 70.5049C39.9309 70.6024 39.55 70.7469 39.2195 70.9385C38.8891 71.1301 38.6397 71.3509 38.4715 71.5866C38.2971 71.8309 38.21 72.0912 38.21 72.3514V74.2355C38.21 74.4958 38.2971 74.7561 38.4715 75.0004C38.6397 75.2361 38.8891 75.4569 39.2195 75.6484C39.55 75.84 39.9309 75.9846 40.3374 76.0821C40.7589 76.1832 41.2079 76.2337 41.6569 76.2337C42.1058 76.2337 42.5548 76.1832 42.9763 76.0821C43.3828 75.9846 43.7637 75.84 44.0942 75.6484C44.4246 75.4569 44.674 75.2361 44.8422 75.0004Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_258_570)"
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 75.0004C45.0166 74.7561 45.1037 74.4958 45.1037 74.2355V72.3514C45.1037 72.0912 45.0166 71.8309 44.8422 71.5866C44.674 71.3509 44.4246 71.1301 44.0942 70.9385C43.7637 70.7469 43.3828 70.6024 42.9763 70.5049C42.5548 70.4038 42.1058 70.3532 41.6569 70.3532C41.2079 70.3532 40.7589 70.4038 40.3374 70.5049C39.9309 70.6024 39.55 70.7469 39.2195 70.9385C38.8891 71.1301 38.6397 71.3509 38.4715 71.5866C38.2971 71.8309 38.21 72.0912 38.21 72.3514V74.2355C38.21 74.4958 38.2971 74.7561 38.4715 75.0004C38.6397 75.2361 38.8891 75.4569 39.2195 75.6484C39.55 75.84 39.9309 75.9846 40.3374 76.0821C40.7589 76.1832 41.2079 76.2337 41.6569 76.2337C42.1058 76.2337 42.5548 76.1832 42.9763 76.0821C43.3828 75.9846 43.7637 75.84 44.0942 75.6484C44.4246 75.4569 44.674 75.2361 44.8422 75.0004Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 75.004C45.0166 74.7597 45.1037 74.4994 45.1037 74.2391V72.3551C45.1037 72.6153 45.0166 72.8756 44.8422 73.1199C44.674 73.3556 44.4246 73.5764 44.0942 73.768C43.7637 73.9596 43.3828 74.1041 42.9763 74.2016C42.5548 74.3027 42.1058 74.3533 41.6569 74.3533C41.2079 74.3533 40.7589 74.3027 40.3374 74.2016C39.9309 74.1041 39.55 73.9596 39.2195 73.768C38.8891 73.5764 38.6397 73.3556 38.4715 73.1199C38.2971 72.8756 38.21 72.6153 38.21 72.3551V74.2391C38.21 74.4994 38.2971 74.7597 38.4715 75.004C38.6397 75.2397 38.8891 75.4605 39.2195 75.6521C39.55 75.8436 39.9309 75.9882 40.3374 76.0857C40.7589 76.1868 41.2079 76.2373 41.6569 76.2373C42.1058 76.2373 42.5548 76.1868 42.9763 76.0857C43.3828 75.9882 43.7637 75.8436 44.0942 75.6521C44.4246 75.4605 44.674 75.2397 44.8422 75.004Z",
    fill: "url(#paint9_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4715 71.5866C38.2971 71.8309 38.21 72.0912 38.21 72.3514C38.21 72.6117 38.2971 72.872 38.4715 73.1163C38.6397 73.352 38.8891 73.5728 39.2195 73.7644C39.55 73.956 39.9309 74.1005 40.3374 74.198C40.7589 74.2991 41.2079 74.3496 41.6569 74.3496C42.1058 74.3496 42.5548 74.2991 42.9763 74.198C43.3828 74.1005 43.7637 73.956 44.0942 73.7644C44.4246 73.5728 44.674 73.352 44.8422 73.1163C45.0166 72.872 45.1037 72.6117 45.1037 72.3514C45.1037 72.0912 45.0166 71.8309 44.8422 71.5866C44.674 71.3509 44.4246 71.1301 44.0942 70.9385C43.7637 70.7469 43.3828 70.6024 42.9763 70.5049C42.5548 70.4038 42.1058 70.3532 41.6569 70.3532C41.2079 70.3532 40.7589 70.4038 40.3374 70.5049C39.9309 70.6024 39.55 70.7469 39.2195 70.9385C38.8891 71.1301 38.6397 71.3509 38.4715 71.5866Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3975 71.5308C38.2231 71.7751 38.21 72.1426 38.21 72.4029C38.21 72.6632 38.2971 72.9235 38.4715 73.1678C38.6397 73.4034 38.8891 73.6243 39.2195 73.8158C39.55 74.0074 39.9309 74.152 40.3374 74.2495C40.7589 74.3505 41.2079 74.4011 41.6569 74.4011C42.1058 74.4011 42.5548 74.3505 42.9763 74.2495C43.3828 74.152 43.7637 74.0074 44.0942 73.8158C44.4246 73.6243 44.674 73.4034 44.8422 73.1678C45.0166 72.9235 45.1037 72.6632 45.1037 72.4029C45.1037 72.1426 45.0915 71.7861 44.9172 71.5418",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.3975 71.5308C38.2231 71.7751 38.21 72.1426 38.21 72.4029C38.21 72.6632 38.2971 72.9235 38.4715 73.1678C38.6397 73.4034 38.8891 73.6243 39.2195 73.8158C39.55 74.0074 39.9309 74.152 40.3374 74.2495C40.7589 74.3505 41.2079 74.4011 41.6569 74.4011C42.1058 74.4011 42.5548 74.3505 42.9763 74.2495C43.3828 74.152 43.7637 74.0074 44.0942 73.8158C44.4246 73.6243 44.674 73.4034 44.8422 73.1678C45.0166 72.9235 45.1037 72.6632 45.1037 72.4029C45.1037 72.1426 45.0915 71.7861 44.9172 71.5418",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 75,
    width: 8,
    height: 6
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 79.7105C53.1416 79.4662 53.2287 79.2059 53.2287 78.9457V77.0616C53.2287 76.8013 53.1416 76.541 52.9672 76.2967C52.799 76.061 52.5496 75.8402 52.2192 75.6487C51.8887 75.4571 51.5078 75.3125 51.1013 75.215C50.6798 75.1139 50.2308 75.0634 49.7819 75.0634C49.3329 75.0634 48.8839 75.1139 48.4624 75.215C48.0559 75.3125 47.675 75.4571 47.3445 75.6487C47.0141 75.8402 46.7647 76.061 46.5965 76.2967C46.4221 76.541 46.335 76.8013 46.335 77.0616V78.9457C46.335 79.2059 46.4221 79.4662 46.5965 79.7105C46.7647 79.9462 47.0141 80.167 47.3445 80.3586C47.675 80.5502 48.0559 80.6947 48.4624 80.7922C48.8839 80.8933 49.3329 80.9439 49.7819 80.9439C50.2308 80.9439 50.6798 80.8933 51.1013 80.7922C51.5078 80.6947 51.8887 80.5502 52.2192 80.3586C52.5496 80.167 52.799 79.9462 52.9672 79.7105Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_258_570)"
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 79.7105C53.1416 79.4662 53.2287 79.2059 53.2287 78.9457V77.0616C53.2287 76.8013 53.1416 76.541 52.9672 76.2967C52.799 76.061 52.5496 75.8402 52.2192 75.6487C51.8887 75.4571 51.5078 75.3125 51.1013 75.215C50.6798 75.1139 50.2308 75.0634 49.7819 75.0634C49.3329 75.0634 48.8839 75.1139 48.4624 75.215C48.0559 75.3125 47.675 75.4571 47.3445 75.6487C47.0141 75.8402 46.7647 76.061 46.5965 76.2967C46.4221 76.541 46.335 76.8013 46.335 77.0616V78.9457C46.335 79.2059 46.4221 79.4662 46.5965 79.7105C46.7647 79.9462 47.0141 80.167 47.3445 80.3586C47.675 80.5502 48.0559 80.6947 48.4624 80.7922C48.8839 80.8933 49.3329 80.9439 49.7819 80.9439C50.2308 80.9439 50.6798 80.8933 51.1013 80.7922C51.5078 80.6947 51.8887 80.5502 52.2192 80.3586C52.5496 80.167 52.799 79.9462 52.9672 79.7105Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 79.7141C53.1416 79.4698 53.2287 79.2096 53.2287 78.9493V77.0652C53.2287 77.3255 53.1416 77.5858 52.9672 77.8301C52.799 78.0658 52.5496 78.2866 52.2192 78.4781C51.8887 78.6697 51.5078 78.8143 51.1013 78.9118C50.6798 79.0129 50.2308 79.0634 49.7819 79.0634C49.3329 79.0634 48.8839 79.0129 48.4624 78.9118C48.0559 78.8143 47.675 78.6697 47.3445 78.4781C47.0141 78.2866 46.7647 78.0658 46.5965 77.8301C46.4221 77.5858 46.335 77.3255 46.335 77.0652V78.9493C46.335 79.2096 46.4221 79.4698 46.5965 79.7141C46.7647 79.9498 47.0141 80.1706 47.3445 80.3622C47.675 80.5538 48.0559 80.6983 48.4624 80.7958C48.8839 80.8969 49.3329 80.9475 49.7819 80.9475C50.2308 80.9475 50.6798 80.8969 51.1013 80.7958C51.5078 80.6983 51.8887 80.5538 52.2192 80.3622C52.5496 80.1706 52.799 79.9498 52.9672 79.7141Z",
    fill: "url(#paint10_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5965 76.2967C46.4221 76.541 46.335 76.8013 46.335 77.0616C46.335 77.3219 46.4221 77.5822 46.5965 77.8265C46.7647 78.0622 47.0141 78.283 47.3445 78.4745C47.675 78.6661 48.0559 78.8107 48.4624 78.9082C48.8839 79.0093 49.3329 79.0598 49.7819 79.0598C50.2308 79.0598 50.6798 79.0093 51.1013 78.9082C51.5078 78.8107 51.8887 78.6661 52.2192 78.4745C52.5496 78.283 52.799 78.0622 52.9672 77.8265C53.1416 77.5822 53.2287 77.3219 53.2287 77.0616C53.2287 76.8013 53.1416 76.541 52.9672 76.2967C52.799 76.061 52.5496 75.8402 52.2192 75.6487C51.8887 75.4571 51.5078 75.3125 51.1013 75.215C50.6798 75.1139 50.2308 75.0634 49.7819 75.0634C49.3329 75.0634 48.8839 75.1139 48.4624 75.215C48.0559 75.3125 47.675 75.4571 47.3445 75.6487C47.0141 75.8402 46.7647 76.061 46.5965 76.2967Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 76.2409C46.3481 76.4852 46.335 76.8528 46.335 77.113C46.335 77.3733 46.4221 77.6336 46.5965 77.8779C46.7647 78.1136 47.0141 78.3344 47.3445 78.526C47.675 78.7176 48.0559 78.8621 48.4624 78.9596C48.8839 79.0607 49.3329 79.1112 49.7819 79.1112C50.2308 79.1112 50.6798 79.0607 51.1013 78.9596C51.5078 78.8621 51.8887 78.7176 52.2192 78.526C52.5496 78.3344 52.799 78.1136 52.9672 77.8779C53.1416 77.6336 53.2287 77.3733 53.2287 77.113C53.2287 76.8528 53.2165 76.4963 53.0422 76.252",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 76.2409C46.3481 76.4852 46.335 76.8528 46.335 77.113C46.335 77.3733 46.4221 77.6336 46.5965 77.8779C46.7647 78.1136 47.0141 78.3344 47.3445 78.526C47.675 78.7176 48.0559 78.8621 48.4624 78.9596C48.8839 79.0607 49.3329 79.1112 49.7819 79.1112C50.2308 79.1112 50.6798 79.0607 51.1013 78.9596C51.5078 78.8621 51.8887 78.7176 52.2192 78.526C52.5496 78.3344 52.799 78.1136 52.9672 77.8779C53.1416 77.6336 53.2287 77.3733 53.2287 77.113C53.2287 76.8528 53.2165 76.4963 53.0422 76.252",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 79,
    width: 8,
    height: 7
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0922 84.4207C61.2666 84.1764 61.3537 83.9161 61.3537 83.6558V81.7717C61.3537 81.5114 61.2666 81.2512 61.0922 81.0069C60.924 80.7712 60.6746 80.5504 60.3442 80.3588C60.0137 80.1672 59.6328 80.0227 59.2263 79.9252C58.8048 79.8241 58.3558 79.7735 57.9069 79.7735C57.4579 79.7735 57.0089 79.8241 56.5874 79.9252C56.1809 80.0227 55.8 80.1672 55.4695 80.3588C55.1391 80.5504 54.8897 80.7712 54.7215 81.0069C54.5471 81.2512 54.46 81.5114 54.46 81.7717V83.6558C54.46 83.9161 54.5471 84.1764 54.7215 84.4207C54.8897 84.6563 55.1391 84.8771 55.4695 85.0687C55.8 85.2603 56.1809 85.4049 56.5874 85.5024C57.0089 85.6034 57.4579 85.654 57.9069 85.654C58.3558 85.654 58.8048 85.6034 59.2263 85.5024C59.6328 85.4049 60.0137 85.2603 60.3442 85.0687C60.6746 84.8771 60.924 84.6563 61.0922 84.4207Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_258_570)"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0922 84.4207C61.2666 84.1764 61.3537 83.9161 61.3537 83.6558V81.7717C61.3537 81.5114 61.2666 81.2512 61.0922 81.0069C60.924 80.7712 60.6746 80.5504 60.3442 80.3588C60.0137 80.1672 59.6328 80.0227 59.2263 79.9252C58.8048 79.8241 58.3558 79.7735 57.9069 79.7735C57.4579 79.7735 57.0089 79.8241 56.5874 79.9252C56.1809 80.0227 55.8 80.1672 55.4695 80.3588C55.1391 80.5504 54.8897 80.7712 54.7215 81.0069C54.5471 81.2512 54.46 81.5114 54.46 81.7717V83.6558C54.46 83.9161 54.5471 84.1764 54.7215 84.4207C54.8897 84.6563 55.1391 84.8771 55.4695 85.0687C55.8 85.2603 56.1809 85.4049 56.5874 85.5024C57.0089 85.6034 57.4579 85.654 57.9069 85.654C58.3558 85.654 58.8048 85.6034 59.2263 85.5024C59.6328 85.4049 60.0137 85.2603 60.3442 85.0687C60.6746 84.8771 60.924 84.6563 61.0922 84.4207Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.0922 84.4243C61.2666 84.18 61.3537 83.9197 61.3537 83.6594V81.7753C61.3537 82.0356 61.2666 82.2959 61.0922 82.5402C60.924 82.7759 60.6746 82.9967 60.3442 83.1883C60.0137 83.3799 59.6328 83.5244 59.2263 83.6219C58.8048 83.723 58.3558 83.7735 57.9069 83.7735C57.4579 83.7735 57.0089 83.723 56.5874 83.6219C56.1809 83.5244 55.8 83.3799 55.4695 83.1883C55.1391 82.9967 54.8897 82.7759 54.7215 82.5402C54.5471 82.2959 54.46 82.0356 54.46 81.7753V83.6594C54.46 83.9197 54.5471 84.18 54.7215 84.4243C54.8897 84.66 55.1391 84.8808 55.4695 85.0723C55.8 85.2639 56.1809 85.4085 56.5874 85.506C57.0089 85.6071 57.4579 85.6576 57.9069 85.6576C58.3558 85.6576 58.8048 85.6071 59.2263 85.506C59.6328 85.4085 60.0137 85.2639 60.3442 85.0723C60.6746 84.8808 60.924 84.66 61.0922 84.4243Z",
    fill: "url(#paint11_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7215 81.0069C54.5471 81.2512 54.46 81.5114 54.46 81.7717C54.46 82.032 54.5471 82.2923 54.7215 82.5366C54.8897 82.7723 55.1391 82.9931 55.4695 83.1847C55.8 83.3763 56.1809 83.5208 56.5874 83.6183C57.0089 83.7194 57.4579 83.7699 57.9069 83.7699C58.3558 83.7699 58.8048 83.7194 59.2263 83.6183C59.6328 83.5208 60.0137 83.3763 60.3442 83.1847C60.6746 82.9931 60.924 82.7723 61.0922 82.5366C61.2666 82.2923 61.3537 82.032 61.3537 81.7717C61.3537 81.5114 61.2666 81.2512 61.0922 81.0069C60.924 80.7712 60.6746 80.5504 60.3442 80.3588C60.0137 80.1672 59.6328 80.0227 59.2263 79.9252C58.8048 79.8241 58.3558 79.7735 57.9069 79.7735C57.4579 79.7735 57.0089 79.8241 56.5874 79.9252C56.1809 80.0227 55.8 80.1672 55.4695 80.3588C55.1391 80.5504 54.8897 80.7712 54.7215 81.0069Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6475 80.9511C54.4731 81.1954 54.46 81.5629 54.46 81.8232C54.46 82.0835 54.5471 82.3438 54.7215 82.5881C54.8897 82.8237 55.1391 83.0445 55.4695 83.2361C55.8 83.4277 56.1809 83.5722 56.5874 83.6698C57.0089 83.7708 57.4579 83.8214 57.9069 83.8214C58.3558 83.8214 58.8048 83.7708 59.2263 83.6698C59.6328 83.5722 60.0137 83.4277 60.3442 83.2361C60.6746 83.0445 60.924 82.8237 61.0922 82.5881C61.2666 82.3438 61.3537 82.0835 61.3537 81.8232C61.3537 81.5629 61.3415 81.2064 61.1672 80.9621",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.6475 80.9511C54.4731 81.1954 54.46 81.5629 54.46 81.8232C54.46 82.0835 54.5471 82.3438 54.7215 82.5881C54.8897 82.8237 55.1391 83.0445 55.4695 83.2361C55.8 83.4277 56.1809 83.5722 56.5874 83.6698C57.0089 83.7708 57.4579 83.8214 57.9069 83.8214C58.3558 83.8214 58.8048 83.7708 59.2263 83.6698C59.6328 83.5722 60.0137 83.4277 60.3442 83.2361C60.6746 83.0445 60.924 82.8237 61.0922 82.5881C61.2666 82.3438 61.3537 82.0835 61.3537 81.8232C61.3537 81.5629 61.3415 81.2064 61.1672 80.9621",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 53,
    width: 34,
    height: 31
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 73.9861C33.5 74.0701 33.5447 74.1478 33.6174 74.1899L49.6327 83.4741C49.7058 83.5165 49.7959 83.5165 49.869 83.4741L65.8843 74.1899C65.9569 74.1478 66.0017 74.0701 66.0017 73.9861V72.3007C66.0017 72.2595 65.9909 72.219 65.9703 72.1833L57.9077 58.1618C57.8871 58.126 57.8574 58.0962 57.8217 58.0755L49.869 53.4652C49.7959 53.4228 49.7058 53.4228 49.6327 53.4652L33.6174 62.7494C33.5447 62.7916 33.5 62.8692 33.5 62.9532V73.9861Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_258_570)"
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6244 67.5269L41.6249 67.5272L49.7499 81.6576L41.6244 67.5269ZM33.4994 62.8168L49.7503 53.396L57.8757 58.1064L57.8749 58.1069L65.9999 72.2373L66.0007 72.2368V74.1209L49.7499 83.5416L33.499 74.1209L33.499 62.8165L33.4994 62.8168Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 1.88406,
    transform: "matrix(0.86514 -0.501531 2.19408e-08 1 49.75 81.6576)",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.875 58.1069L41.625 67.5272L49.75 81.6576L66 72.2373L57.875 58.1069Z",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.6246 67.5269L33.4992 62.8165L33.4992 74.1209L49.75 83.5416L49.75 81.6576L41.6246 67.5269Z",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.39203,
    height: 18.7841,
    transform: "matrix(-0.86514 -0.50153 0.86514 -0.501531 41.625 67.5272)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M66 72.2373L66 74.1214",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5 62.817L33.5 74.1214",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M49.75 81.6576L49.75 83.5416",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72.2373L49.75 81.6576",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M57.875 58.1069L41.625 67.5272",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M49.75 81.6576L41.625 67.5272",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6391 67.5353L33.5 62.817",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.75 81.6576L49.75 83.5416",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 72.2373L49.75 81.6576",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M66 74.1214L49.75 83.5417",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.875 58.1069L41.625 67.5272",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.75 81.6576L41.625 67.5272",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6391 67.5353L33.5 62.817",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M49.7511 83.5423L33.5 74.1214",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 54,
    width: 8,
    height: 7
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 58.8681C53.1416 58.6238 53.2287 58.3635 53.2287 58.1033V56.2192C53.2287 55.9589 53.1416 55.6986 52.9672 55.4543C52.799 55.2186 52.5496 54.9978 52.2192 54.8063C51.8887 54.6147 51.5078 54.4701 51.1013 54.3726C50.6798 54.2715 50.2308 54.221 49.7819 54.221C49.3329 54.221 48.8839 54.2715 48.4624 54.3726C48.0559 54.4701 47.675 54.6147 47.3445 54.8063C47.0141 54.9978 46.7647 55.2186 46.5965 55.4543C46.4221 55.6986 46.335 55.9589 46.335 56.2192V58.1033C46.335 58.3635 46.4221 58.6238 46.5965 58.8681C46.7647 59.1038 47.0141 59.3246 47.3445 59.5162C47.675 59.7078 48.0559 59.8523 48.4624 59.9498C48.8839 60.0509 49.3329 60.1015 49.7819 60.1015C50.2308 60.1015 50.6798 60.0509 51.1013 59.9498C51.5078 59.8523 51.8887 59.7078 52.2192 59.5162C52.5496 59.3246 52.799 59.1038 52.9672 58.8681Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_258_570)"
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 58.8681C53.1416 58.6238 53.2287 58.3635 53.2287 58.1033V56.2192C53.2287 55.9589 53.1416 55.6986 52.9672 55.4543C52.799 55.2186 52.5496 54.9978 52.2192 54.8063C51.8887 54.6147 51.5078 54.4701 51.1013 54.3726C50.6798 54.2715 50.2308 54.221 49.7819 54.221C49.3329 54.221 48.8839 54.2715 48.4624 54.3726C48.0559 54.4701 47.675 54.6147 47.3445 54.8063C47.0141 54.9978 46.7647 55.2186 46.5965 55.4543C46.4221 55.6986 46.335 55.9589 46.335 56.2192V58.1033C46.335 58.3635 46.4221 58.6238 46.5965 58.8681C46.7647 59.1038 47.0141 59.3246 47.3445 59.5162C47.675 59.7078 48.0559 59.8523 48.4624 59.9498C48.8839 60.0509 49.3329 60.1015 49.7819 60.1015C50.2308 60.1015 50.6798 60.0509 51.1013 59.9498C51.5078 59.8523 51.8887 59.7078 52.2192 59.5162C52.5496 59.3246 52.799 59.1038 52.9672 58.8681Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 58.8717C53.1416 58.6274 53.2287 58.3672 53.2287 58.1069V56.2228C53.2287 56.4831 53.1416 56.7434 52.9672 56.9877C52.799 57.2234 52.5496 57.4442 52.2192 57.6357C51.8887 57.8273 51.5078 57.9719 51.1013 58.0694C50.6798 58.1705 50.2308 58.221 49.7819 58.221C49.3329 58.221 48.8839 58.1705 48.4624 58.0694C48.0559 57.9719 47.675 57.8273 47.3445 57.6357C47.0141 57.4442 46.7647 57.2234 46.5965 56.9877C46.4221 56.7434 46.335 56.4831 46.335 56.2228V58.1069C46.335 58.3672 46.4221 58.6274 46.5965 58.8717C46.7647 59.1074 47.0141 59.3282 47.3445 59.5198C47.675 59.7114 48.0559 59.8559 48.4624 59.9534C48.8839 60.0545 49.3329 60.1051 49.7819 60.1051C50.2308 60.1051 50.6798 60.0545 51.1013 59.9534C51.5078 59.8559 51.8887 59.7114 52.2192 59.5198C52.5496 59.3282 52.799 59.1074 52.9672 58.8717Z",
    fill: "url(#paint12_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5965 55.4543C46.4221 55.6986 46.335 55.9589 46.335 56.2192C46.335 56.4795 46.4221 56.7398 46.5965 56.9841C46.7647 57.2198 47.0141 57.4406 47.3445 57.6321C47.675 57.8237 48.0559 57.9683 48.4624 58.0658C48.8839 58.1669 49.3329 58.2174 49.7819 58.2174C50.2308 58.2174 50.6798 58.1669 51.1013 58.0658C51.5078 57.9683 51.8887 57.8237 52.2192 57.6321C52.5496 57.4406 52.799 57.2198 52.9672 56.9841C53.1416 56.7398 53.2287 56.4795 53.2287 56.2192C53.2287 55.9589 53.1416 55.6986 52.9672 55.4543C52.799 55.2186 52.5496 54.9978 52.2192 54.8063C51.8887 54.6147 51.5078 54.4701 51.1013 54.3726C50.6798 54.2715 50.2308 54.221 49.7819 54.221C49.3329 54.221 48.8839 54.2715 48.4624 54.3726C48.0559 54.4701 47.675 54.6147 47.3445 54.8063C47.0141 54.9978 46.7647 55.2186 46.5965 55.4543Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 55.3985C46.3481 55.6428 46.335 56.0104 46.335 56.2707C46.335 56.5309 46.4221 56.7912 46.5965 57.0355C46.7647 57.2712 47.0141 57.492 47.3445 57.6836C47.675 57.8752 48.0559 58.0197 48.4624 58.1172C48.8839 58.2183 49.3329 58.2688 49.7819 58.2688C50.2308 58.2688 50.6798 58.2183 51.1013 58.1172C51.5078 58.0197 51.8887 57.8752 52.2192 57.6836C52.5496 57.492 52.799 57.2712 52.9672 57.0355C53.1416 56.7912 53.2287 56.5309 53.2287 56.2707C53.2287 56.0104 53.2165 55.6539 53.0422 55.4096",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 55.3985C46.3481 55.6428 46.335 56.0104 46.335 56.2707C46.335 56.5309 46.4221 56.7912 46.5965 57.0355C46.7647 57.2712 47.0141 57.492 47.3445 57.6836C47.675 57.8752 48.0559 58.0197 48.4624 58.1172C48.8839 58.2183 49.3329 58.2688 49.7819 58.2688C50.2308 58.2688 50.6798 58.2183 51.1013 58.1172C51.5078 58.0197 51.8887 57.8752 52.2192 57.6836C52.5496 57.492 52.799 57.2712 52.9672 57.0355C53.1416 56.7912 53.2287 56.5309 53.2287 56.2707C53.2287 56.0104 53.2165 55.6539 53.0422 55.4096",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 58,
    width: 8,
    height: 7
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 63.5783C45.0166 63.334 45.1037 63.0737 45.1037 62.8134V60.9293C45.1037 60.6691 45.0166 60.4088 44.8422 60.1645C44.674 59.9288 44.4246 59.708 44.0942 59.5164C43.7637 59.3248 43.3828 59.1803 42.9763 59.0828C42.5548 58.9817 42.1058 58.9311 41.6569 58.9311C41.2079 58.9311 40.7589 58.9817 40.3374 59.0828C39.9309 59.1803 39.55 59.3248 39.2195 59.5164C38.8891 59.708 38.6397 59.9288 38.4715 60.1645C38.2971 60.4088 38.21 60.6691 38.21 60.9293V62.8134C38.21 63.0737 38.2971 63.334 38.4715 63.5783C38.6397 63.814 38.8891 64.0348 39.2195 64.2263C39.55 64.4179 39.9309 64.5625 40.3374 64.66C40.7589 64.7611 41.2079 64.8116 41.6569 64.8116C42.1058 64.8116 42.5548 64.7611 42.9763 64.66C43.3828 64.5625 43.7637 64.4179 44.0942 64.2263C44.4246 64.0348 44.674 63.814 44.8422 63.5783Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_258_570)"
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 63.5783C45.0166 63.334 45.1037 63.0737 45.1037 62.8134V60.9293C45.1037 60.6691 45.0166 60.4088 44.8422 60.1645C44.674 59.9288 44.4246 59.708 44.0942 59.5164C43.7637 59.3248 43.3828 59.1803 42.9763 59.0828C42.5548 58.9817 42.1058 58.9311 41.6569 58.9311C41.2079 58.9311 40.7589 58.9817 40.3374 59.0828C39.9309 59.1803 39.55 59.3248 39.2195 59.5164C38.8891 59.708 38.6397 59.9288 38.4715 60.1645C38.2971 60.4088 38.21 60.6691 38.21 60.9293V62.8134C38.21 63.0737 38.2971 63.334 38.4715 63.5783C38.6397 63.814 38.8891 64.0348 39.2195 64.2263C39.55 64.4179 39.9309 64.5625 40.3374 64.66C40.7589 64.7611 41.2079 64.8116 41.6569 64.8116C42.1058 64.8116 42.5548 64.7611 42.9763 64.66C43.3828 64.5625 43.7637 64.4179 44.0942 64.2263C44.4246 64.0348 44.674 63.814 44.8422 63.5783Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 63.5819C45.0166 63.3376 45.1037 63.0773 45.1037 62.817V60.933C45.1037 61.1932 45.0166 61.4535 44.8422 61.6978C44.674 61.9335 44.4246 62.1543 44.0942 62.3459C43.7637 62.5375 43.3828 62.682 42.9763 62.7795C42.5548 62.8806 42.1058 62.9312 41.6569 62.9312C41.2079 62.9312 40.7589 62.8806 40.3374 62.7795C39.9309 62.682 39.55 62.5375 39.2195 62.3459C38.8891 62.1543 38.6397 61.9335 38.4715 61.6978C38.2971 61.4535 38.21 61.1932 38.21 60.933V62.817C38.21 63.0773 38.2971 63.3376 38.4715 63.5819C38.6397 63.8176 38.8891 64.0384 39.2195 64.23C39.55 64.4215 39.9309 64.5661 40.3374 64.6636C40.7589 64.7647 41.2079 64.8152 41.6569 64.8152C42.1058 64.8152 42.5548 64.7647 42.9763 64.6636C43.3828 64.5661 43.7637 64.4215 44.0942 64.23C44.4246 64.0384 44.674 63.8176 44.8422 63.5819Z",
    fill: "url(#paint13_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4715 60.1645C38.2971 60.4088 38.21 60.6691 38.21 60.9293C38.21 61.1896 38.2971 61.4499 38.4715 61.6942C38.6397 61.9299 38.8891 62.1507 39.2195 62.3423C39.55 62.5339 39.9309 62.6784 40.3374 62.7759C40.7589 62.877 41.2079 62.9275 41.6569 62.9275C42.1058 62.9275 42.5548 62.877 42.9763 62.7759C43.3828 62.6784 43.7637 62.5339 44.0942 62.3423C44.4246 62.1507 44.674 61.9299 44.8422 61.6942C45.0166 61.4499 45.1037 61.1896 45.1037 60.9293C45.1037 60.6691 45.0166 60.4088 44.8422 60.1645C44.674 59.9288 44.4246 59.708 44.0942 59.5164C43.7637 59.3248 43.3828 59.1803 42.9763 59.0828C42.5548 58.9817 42.1058 58.9311 41.6569 58.9311C41.2079 58.9311 40.7589 58.9817 40.3374 59.0828C39.9309 59.1803 39.55 59.3248 39.2195 59.5164C38.8891 59.708 38.6397 59.9288 38.4715 60.1645Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3975 60.1087C38.2231 60.353 38.21 60.7205 38.21 60.9808C38.21 61.2411 38.2971 61.5014 38.4715 61.7457C38.6397 61.9813 38.8891 62.2022 39.2195 62.3937C39.55 62.5853 39.9309 62.7299 40.3374 62.8274C40.7589 62.9285 41.2079 62.979 41.6569 62.979C42.1058 62.979 42.5548 62.9285 42.9763 62.8274C43.3828 62.7299 43.7637 62.5853 44.0942 62.3937C44.4246 62.2022 44.674 61.9813 44.8422 61.7457C45.0166 61.5014 45.1037 61.2411 45.1037 60.9808C45.1037 60.7205 45.0915 60.364 44.9172 60.1197",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.3975 60.1087C38.2231 60.353 38.21 60.7205 38.21 60.9808C38.21 61.2411 38.2971 61.5014 38.4715 61.7457C38.6397 61.9813 38.8891 62.2022 39.2195 62.3937C39.55 62.5853 39.9309 62.7299 40.3374 62.8274C40.7589 62.9285 41.2079 62.979 41.6569 62.979C42.1058 62.979 42.5548 62.9285 42.9763 62.8274C43.3828 62.7299 43.7637 62.5853 44.0942 62.3937C44.4246 62.2022 44.674 61.9813 44.8422 61.7457C45.0166 61.5014 45.1037 61.2411 45.1037 60.9808C45.1037 60.7205 45.0915 60.364 44.9172 60.1197",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 53,
    width: 10,
    height: 8
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2754 56.3311C45.2754 55.9949 45.388 55.6587 45.6132 55.3431C45.8305 55.0387 46.1526 54.7535 46.5795 54.506C47.0064 54.2585 47.4984 54.0718 48.0235 53.9458C48.5679 53.8153 49.1479 53.75 49.7279 53.75C50.3079 53.75 50.8879 53.8153 51.4322 53.9458C51.9574 54.0718 52.4494 54.2585 52.8763 54.506C53.3032 54.7535 53.6253 55.0387 53.8426 55.3431C54.0678 55.6587 54.1804 55.9949 54.1804 56.3311C54.1804 57.0369 54.1804 57.5095 54.1804 58.2153C54.1804 58.5515 54.0678 58.8877 53.8426 59.2033C53.6253 59.5077 53.3032 59.7929 52.8763 60.0404C52.4494 60.2879 51.9574 60.4746 51.4322 60.6006C50.8879 60.7311 50.3079 60.7964 49.7279 60.7964C49.1479 60.7964 48.5679 60.7311 48.0235 60.6006C47.4984 60.4746 47.0064 60.2879 46.5795 60.0404C46.1526 59.7929 45.8305 59.5077 45.6132 59.2033C45.388 58.8877 45.2754 58.5515 45.2754 58.2153C45.2754 57.5095 45.2754 57.0369 45.2754 56.3311Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_258_570)"
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2754 56.3313C45.2754 55.995 45.388 55.6588 45.6132 55.3432C45.8305 55.0388 46.1526 54.7536 46.5795 54.5061C47.0064 54.2586 47.4984 54.0719 48.0235 53.9459C48.5679 53.8154 49.1479 53.7501 49.7279 53.7501C50.3079 53.7501 50.8879 53.8154 51.4322 53.9459C51.9574 54.0719 52.4494 54.2586 52.8763 54.5061C53.3032 54.7536 53.6253 55.0388 53.8426 55.3432C54.0678 55.6588 54.1804 55.995 54.1804 56.3313C54.1804 57.037 54.1804 57.5096 54.1804 58.2154C54.1804 58.5516 54.0678 58.8878 53.8426 59.2034C53.6253 59.5078 53.3032 59.7931 52.8763 60.0405C52.4494 60.288 51.9574 60.4747 51.4322 60.6007C50.8879 60.7312 50.3079 60.7965 49.7279 60.7965C49.1479 60.7965 48.5679 60.7312 48.0235 60.6007C47.4984 60.4747 47.0064 60.288 46.5795 60.0405C46.1526 59.7931 45.8305 59.5078 45.6132 59.2034C45.388 58.8878 45.2754 58.5516 45.2754 58.2154C45.2754 57.5096 45.2754 57.037 45.2754 56.3313Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.2754 56.3311C45.2754 55.9949 45.388 55.6587 45.6132 55.3431C45.8305 55.0387 46.1526 54.7535 46.5795 54.506C47.0064 54.2585 47.4984 54.0718 48.0235 53.9458C48.5679 53.8153 49.1479 53.75 49.7279 53.75C50.3079 53.75 50.8879 53.8153 51.4322 53.9458C51.9574 54.0718 52.4494 54.2585 52.8763 54.506C53.3032 54.7535 53.6253 55.0387 53.8426 55.3431C54.0678 55.6587 54.1804 55.9949 54.1804 56.3311C54.1804 57.0369 54.1804 57.5095 54.1804 58.2153C54.1804 58.5515 54.0678 58.8877 53.8426 59.2033C53.6253 59.5077 53.3032 59.7929 52.8763 60.0404C52.4494 60.2879 51.9574 60.4746 51.4322 60.6006C50.8879 60.7311 50.3079 60.7964 49.7279 60.7964C49.1479 60.7964 48.5679 60.7311 48.0235 60.6006C47.4984 60.4746 47.0064 60.2879 46.5795 60.0404C46.1526 59.7929 45.8305 59.5077 45.6132 59.2033C45.388 58.8877 45.2754 58.5515 45.2754 58.2153C45.2754 57.5095 45.2754 57.0369 45.2754 56.3311Z",
    fill: "#141E28",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2754 56.3311C45.2754 55.9949 45.388 55.6587 45.6132 55.3431C45.8305 55.0387 46.1526 54.7535 46.5795 54.506C47.0064 54.2585 47.4984 54.0718 48.0235 53.9458C48.5679 53.8153 49.1479 53.75 49.7279 53.75C50.3079 53.75 50.8879 53.8153 51.4322 53.9458C51.9574 54.0718 52.4494 54.2585 52.8763 54.506C53.3032 54.7535 53.6253 55.0387 53.8426 55.3431C54.0678 55.6587 54.1804 55.9949 54.1804 56.3311C54.1804 57.0369 54.1804 57.5095 54.1804 58.2153C54.1804 58.5515 54.0678 58.8877 53.8426 59.2033C53.6253 59.5077 53.3032 59.7929 52.8763 60.0404C52.4494 60.2879 51.9574 60.4746 51.4322 60.6006C50.8879 60.7311 50.3079 60.7964 49.7279 60.7964C49.1479 60.7964 48.5679 60.7311 48.0235 60.6006C47.4984 60.4746 47.0064 60.2879 46.5795 60.0404C46.1526 59.7929 45.8305 59.5077 45.6132 59.2033C45.388 58.8877 45.2754 58.5515 45.2754 58.2153C45.2754 57.5095 45.2754 57.0369 45.2754 56.3311Z",
    fill: "url(#paint14_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M54.4161 58.2246C54.4161 58.5608 54.0679 58.8971 53.8427 59.2126C53.6254 59.5171 53.3033 59.8023 52.8764 60.0498C52.4496 60.2972 51.9575 60.484 51.4324 60.6099C50.888 60.7405 50.308 60.8058 49.7281 60.8058C49.1481 60.8058 48.5681 60.7405 48.0237 60.6099C47.4986 60.484 47.0065 60.2972 46.5797 60.0498C46.1528 59.8023 45.8307 59.5171 45.6134 59.2126C45.3882 58.8971 45.04 58.5608 45.04 58.2246",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 51,
    width: 13,
    height: 8
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9805 54.49C43.9805 54.0561 44.1258 53.6223 44.4164 53.2151C44.6968 52.8223 45.1124 52.4542 45.6632 52.1349C46.214 51.8156 46.8489 51.5747 47.5265 51.4121C48.229 51.2436 48.9773 51.1594 49.7257 51.1594C50.4741 51.1594 51.2225 51.2436 51.9249 51.4121C52.6025 51.5747 53.2374 51.8156 53.7882 52.1349C54.339 52.4542 54.7546 52.8223 55.035 53.2151C55.3256 53.6223 55.471 54.0561 55.471 54.49V55.432C55.471 55.8658 55.3256 56.2997 55.035 56.7069C54.7546 57.0997 54.339 57.4677 53.7882 57.7871C53.2374 58.1064 52.6025 58.3473 51.9249 58.5098C51.2225 58.6783 50.4741 58.7626 49.7257 58.7626C48.9773 58.7626 48.229 58.6783 47.5265 58.5098C46.8489 58.3473 46.214 58.1064 45.6632 57.7871C45.1124 57.4677 44.6968 57.0997 44.4164 56.7069C44.1258 56.2997 43.9805 55.8658 43.9805 55.432L43.9805 54.49Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_258_570)"
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9805 54.4899C43.9805 54.056 44.1258 53.6222 44.4164 53.215C44.6968 52.8222 45.1124 52.4541 45.6632 52.1348C46.214 51.8155 46.8489 51.5746 47.5265 51.412C48.229 51.2435 48.9773 51.1593 49.7257 51.1593C50.4741 51.1593 51.2225 51.2435 51.9249 51.412C52.6025 51.5746 53.2374 51.8155 53.7882 52.1348C54.339 52.4541 54.7546 52.8222 55.035 53.215C55.3256 53.6222 55.471 54.056 55.471 54.4899V55.4319C55.471 55.8657 55.3256 56.2996 55.035 56.7068C54.7546 57.0996 54.339 57.4677 53.7882 57.787C53.2374 58.1063 52.6025 58.3472 51.9249 58.5098C51.2225 58.6782 50.4741 58.7625 49.7257 58.7625C48.9773 58.7625 48.229 58.6782 47.5265 58.5098C46.8489 58.3472 46.214 58.1063 45.6632 57.787C45.1124 57.4677 44.6968 57.0996 44.4164 56.7068C44.1258 56.2996 43.9805 55.8657 43.9805 55.4319V54.4899Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.9805 54.49C43.9805 54.0561 44.1258 53.6223 44.4164 53.2151C44.6968 52.8223 45.1124 52.4542 45.6632 52.1349C46.214 51.8156 46.8489 51.5747 47.5265 51.4121C48.229 51.2436 48.9773 51.1594 49.7257 51.1594C50.4741 51.1594 51.2225 51.2436 51.9249 51.4121C52.6025 51.5747 53.2374 51.8156 53.7882 52.1349C54.339 52.4542 54.7546 52.8223 55.035 53.2151C55.3256 53.6223 55.471 54.0561 55.471 54.49V55.432C55.471 55.8658 55.3256 56.2997 55.035 56.7069C54.7546 57.0997 54.339 57.4677 53.7882 57.7871C53.2374 58.1064 52.6025 58.3473 51.9249 58.5098C51.2225 58.6783 50.4741 58.7626 49.7257 58.7626C48.9773 58.7626 48.229 58.6783 47.5265 58.5098C46.8489 58.3473 46.214 58.1064 45.6632 57.7871C45.1124 57.4677 44.6968 57.0997 44.4164 56.7069C44.1258 56.2997 43.9805 55.8658 43.9805 55.432V54.49Z",
    fill: "url(#paint15_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4407 53.1816C44.1501 53.5888 44.0048 54.0227 44.0048 54.4565C44.0048 54.8903 44.1501 55.3242 44.4407 55.7314C44.7211 56.1242 45.1367 56.4922 45.6875 56.8116C46.2383 57.1309 46.8732 57.3718 47.5508 57.5344C48.2532 57.7028 49.0016 57.7871 49.75 57.7871C50.4984 57.7871 51.2468 57.7028 51.9492 57.5344C52.6268 57.3718 53.2617 57.1309 53.8125 56.8116C54.3633 56.4922 54.7789 56.1242 55.0593 55.7314C55.3499 55.3242 55.4952 54.8903 55.4952 54.4565C55.4952 54.0227 55.3499 53.5888 55.0593 53.1816C54.7789 52.7888 54.3633 52.4207 53.8125 52.1014C53.2617 51.7821 52.6268 51.5412 51.9492 51.3786C51.2468 51.2102 50.4984 51.1259 49.75 51.1259C49.0016 51.1259 48.2532 51.2102 47.5508 51.3786C46.8732 51.5412 46.2383 51.7821 45.6875 52.1014C45.1367 52.4207 44.7211 52.7888 44.4407 53.1816Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4407 53.1816C44.1501 53.5888 44.0048 54.0227 44.0048 54.4565C44.0048 54.8903 44.1501 55.3242 44.4407 55.7314C44.7211 56.1242 45.1367 56.4922 45.6875 56.8116C46.2383 57.1309 46.8732 57.3718 47.5508 57.5344C48.2532 57.7028 49.0016 57.7871 49.75 57.7871C50.4984 57.7871 51.2468 57.7028 51.9492 57.5344C52.6268 57.3718 53.2617 57.1309 53.8125 56.8116C54.3633 56.4922 54.7789 56.1242 55.0593 55.7314C55.3499 55.3242 55.4952 54.8903 55.4952 54.4565C55.4952 54.0227 55.3499 53.5888 55.0593 53.1816C54.7789 52.7888 54.3633 52.4207 53.8125 52.1014C53.2617 51.7821 52.6268 51.5412 51.9492 51.3786C51.2468 51.2102 50.4984 51.1259 49.75 51.1259C49.0016 51.1259 48.2532 51.2102 47.5508 51.3786C46.8732 51.5412 46.2383 51.7821 45.6875 52.1014C45.1367 52.4207 44.7211 52.7888 44.4407 53.1816Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4164 52.8079C44.1258 53.2151 43.9805 54.0023 43.9805 54.4361C43.9805 54.8699 44.1258 55.3038 44.4164 55.711C44.6968 56.1038 45.1124 56.4718 45.6632 56.7912C46.214 57.1105 46.8489 57.3514 47.5265 57.514C48.229 57.6824 48.9773 57.7667 49.7257 57.7667C50.4741 57.7667 51.2225 57.6824 51.9249 57.514C52.6025 57.3514 53.2374 57.1105 53.7882 56.7912C54.339 56.4718 54.7546 56.1038 55.035 55.711C55.3256 55.3038 55.471 54.8699 55.471 54.4361C55.471 54.0023 55.3256 53.2151 55.035 52.8079",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.4164 52.8079C44.1258 53.2151 43.9805 54.0023 43.9805 54.4361C43.9805 54.8699 44.1258 55.3038 44.4164 55.711C44.6968 56.1038 45.1124 56.4718 45.6632 56.7912C46.214 57.1105 46.8489 57.3514 47.5265 57.514C48.229 57.6824 48.9773 57.7667 49.7257 57.7667C50.4741 57.7667 51.2225 57.6824 51.9249 57.514C52.6025 57.3514 53.2374 57.1105 53.7882 56.7912C54.339 56.4718 54.7546 56.1038 55.035 55.711C55.3256 55.3038 55.471 54.8699 55.471 54.4361C55.471 54.0023 55.3256 53.2151 55.035 52.8079",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 50,
    width: 8,
    height: 7
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 55.2178C53.1416 54.9735 53.2287 54.7132 53.2287 54.4529V52.5688C53.2287 52.3086 53.1416 52.0483 52.9672 51.804C52.799 51.5683 52.5496 51.3475 52.2192 51.1559C51.8887 50.9643 51.5078 50.8198 51.1013 50.7223C50.6798 50.6212 50.2308 50.5706 49.7819 50.5706C49.3329 50.5706 48.8839 50.6212 48.4624 50.7223C48.0559 50.8198 47.675 50.9643 47.3445 51.1559C47.0141 51.3475 46.7647 51.5683 46.5965 51.804C46.4221 52.0483 46.335 52.3086 46.335 52.5688V54.4529C46.335 54.7132 46.4221 54.9735 46.5965 55.2178C46.7647 55.4535 47.0141 55.6743 47.3445 55.8658C47.675 56.0574 48.0559 56.202 48.4624 56.2995C48.8839 56.4006 49.3329 56.4511 49.7819 56.4511C50.2308 56.4511 50.6798 56.4006 51.1013 56.2995C51.5078 56.202 51.8887 56.0574 52.2192 55.8658C52.5496 55.6743 52.799 55.4535 52.9672 55.2178Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_258_570)"
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 55.2178C53.1416 54.9735 53.2287 54.7132 53.2287 54.4529V52.5688C53.2287 52.3086 53.1416 52.0483 52.9672 51.804C52.799 51.5683 52.5496 51.3475 52.2192 51.1559C51.8887 50.9643 51.5078 50.8198 51.1013 50.7223C50.6798 50.6212 50.2308 50.5706 49.7819 50.5706C49.3329 50.5706 48.8839 50.6212 48.4624 50.7223C48.0559 50.8198 47.675 50.9643 47.3445 51.1559C47.0141 51.3475 46.7647 51.5683 46.5965 51.804C46.4221 52.0483 46.335 52.3086 46.335 52.5688V54.4529C46.335 54.7132 46.4221 54.9735 46.5965 55.2178C46.7647 55.4535 47.0141 55.6743 47.3445 55.8658C47.675 56.0574 48.0559 56.202 48.4624 56.2995C48.8839 56.4006 49.3329 56.4511 49.7819 56.4511C50.2308 56.4511 50.6798 56.4006 51.1013 56.2995C51.5078 56.202 51.8887 56.0574 52.2192 55.8658C52.5496 55.6743 52.799 55.4535 52.9672 55.2178Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 55.2214C53.1416 54.9771 53.2287 54.7168 53.2287 54.4565V52.5725C53.2287 52.8327 53.1416 53.093 52.9672 53.3373C52.799 53.573 52.5496 53.7938 52.2192 53.9854C51.8887 54.177 51.5078 54.3215 51.1013 54.419C50.6798 54.5201 50.2308 54.5707 49.7819 54.5707C49.3329 54.5707 48.8839 54.5201 48.4624 54.419C48.0559 54.3215 47.675 54.177 47.3445 53.9854C47.0141 53.7938 46.7647 53.573 46.5965 53.3373C46.4221 53.093 46.335 52.8327 46.335 52.5725V54.4565C46.335 54.7168 46.4221 54.9771 46.5965 55.2214C46.7647 55.4571 47.0141 55.6779 47.3445 55.8695C47.675 56.061 48.0559 56.2056 48.4624 56.3031C48.8839 56.4042 49.3329 56.4547 49.7819 56.4547C50.2308 56.4547 50.6798 56.4042 51.1013 56.3031C51.5078 56.2056 51.8887 56.061 52.2192 55.8695C52.5496 55.6779 52.799 55.4571 52.9672 55.2214Z",
    fill: "url(#paint16_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5965 51.804C46.4221 52.0483 46.335 52.3086 46.335 52.5688C46.335 52.8291 46.4221 53.0894 46.5965 53.3337C46.7647 53.5694 47.0141 53.7902 47.3445 53.9818C47.675 54.1734 48.0559 54.3179 48.4624 54.4154C48.8839 54.5165 49.3329 54.567 49.7819 54.567C50.2308 54.567 50.6798 54.5165 51.1013 54.4154C51.5078 54.3179 51.8887 54.1734 52.2192 53.9818C52.5496 53.7902 52.799 53.5694 52.9672 53.3337C53.1416 53.0894 53.2287 52.8291 53.2287 52.5688C53.2287 52.3086 53.1416 52.0483 52.9672 51.804C52.799 51.5683 52.5496 51.3475 52.2192 51.1559C51.8887 50.9643 51.5078 50.8198 51.1013 50.7223C50.6798 50.6212 50.2308 50.5706 49.7819 50.5706C49.3329 50.5706 48.8839 50.6212 48.4624 50.7223C48.0559 50.8198 47.675 50.9643 47.3445 51.1559C47.0141 51.3475 46.7647 51.5683 46.5965 51.804Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 51.7482C46.3481 51.9925 46.335 52.36 46.335 52.6203C46.335 52.8806 46.4221 53.1409 46.5965 53.3852C46.7647 53.6208 47.0141 53.8416 47.3445 54.0332C47.675 54.2248 48.0559 54.3694 48.4624 54.4669C48.8839 54.5679 49.3329 54.6185 49.7819 54.6185C50.2308 54.6185 50.6798 54.5679 51.1013 54.4669C51.5078 54.3694 51.8887 54.2248 52.2192 54.0332C52.5496 53.8416 52.799 53.6208 52.9672 53.3852C53.1416 53.1409 53.2287 52.8806 53.2287 52.6203C53.2287 52.36 53.2165 52.0035 53.0422 51.7592",
    stroke: "#141E28",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 51.7482C46.3481 51.9925 46.335 52.36 46.335 52.6203C46.335 52.8806 46.4221 53.1409 46.5965 53.3852C46.7647 53.6208 47.0141 53.8416 47.3445 54.0332C47.675 54.2248 48.0559 54.3694 48.4624 54.4669C48.8839 54.5679 49.3329 54.6185 49.7819 54.6185C50.2308 54.6185 50.6798 54.5679 51.1013 54.4669C51.5078 54.3694 51.8887 54.2248 52.2192 54.0332C52.5496 53.8416 52.799 53.6208 52.9672 53.3852C53.1416 53.1409 53.2287 52.8806 53.2287 52.6203C53.2287 52.36 53.2165 52.0035 53.0422 51.7592",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 64,
    width: 50,
    height: 41
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M49.75 94.829C49.75 94.913 49.7053 94.9907 49.6326 95.0328L33.6173 104.317C33.5442 104.359 33.4541 104.359 33.381 104.317L1.11487 85.612C1.04221 85.5699 0.997478 85.4923 0.997478 85.4083V74.3753C0.997478 74.2913 1.04221 74.2137 1.11487 74.1716L17.1302 64.8873C17.2033 64.845 17.2934 64.845 17.3664 64.8873L49.6326 83.5923C49.7053 83.6345 49.75 83.7121 49.75 83.7961V94.829Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_258_570)"
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2493 64.8174L49.751 83.6589L49.751 94.9633L33.5001 104.384L0.998459 85.5425V74.2381L17.2493 64.8174Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 37.5681,
    height: 11.3043,
    transform: "matrix(-0.86514 -0.501531 -2.19408e-08 1 33.5 93.0797)",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 11.3043,
    transform: "matrix(0.86514 -0.501531 2.19408e-08 1 33.5 93.0797)",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 37.5681,
    transform: "matrix(0.86514 -0.50153 -0.86514 -0.501531 33.5 93.0797)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M0.998326 85.5435L33.5 104.385",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5 104.384L49.75 94.9638",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1 74.2391L1 85.5435",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M49.75 83.6594L49.75 94.9638",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 93.0797V104.384",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0.998326 74.2391L33.5 93.0807",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 93.0797L49.75 83.6594",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 93.0797V104.384",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.998326 74.2391L33.5 93.0807",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 93.0797L49.75 83.6594",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 78,
    width: 34,
    height: 32
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M49.75 104.249C49.75 104.333 49.7947 104.411 49.8674 104.453L57.7569 109.026C57.8299 109.069 57.9201 109.069 57.9931 109.026L82.1339 95.0318C82.2065 94.9897 82.2513 94.9121 82.2513 94.8281V83.7951C82.2513 83.7111 82.2065 83.6335 82.1339 83.5914L74.2444 79.0177C74.1713 78.9754 74.0812 78.9754 74.0081 79.0177L49.8674 93.0124C49.7947 93.0545 49.75 93.1321 49.75 93.2161V104.249Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_258_570)"
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1263 78.9485L49.75 93.0797V104.384L57.875 109.094L82.2513 94.963V83.6587L74.1263 78.9485Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 28.1761,
    height: 11.3043,
    transform: "matrix(0.86514 -0.501531 2.19408e-08 1 57.875 97.7898)",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.39154,
    height: 11.3043,
    transform: "matrix(-0.86514 -0.501531 -2.19408e-08 1 57.875 97.7898)",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.39154,
    height: 28.1761,
    transform: "matrix(-0.86514 -0.50153 0.86514 -0.501531 57.875 97.7898)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M82.2513 94.9638L57.875 109.095",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M57.875 109.094L49.75 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M82.25 83.6594L82.25 94.9637",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M49.75 93.0797L49.75 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M57.875 97.7898V109.094",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2513 83.6594L57.875 97.7906",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M57.875 97.7898L49.75 93.0797",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.875 97.7898V109.094",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2513 83.6594L57.875 97.7906",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.875 97.7898L49.75 93.0797",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 79,
    width: 8,
    height: 7
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3422 84.4207C77.5166 84.1764 77.6037 83.9161 77.6037 83.6558V81.7717C77.6037 81.5114 77.5166 81.2512 77.3422 81.0069C77.174 80.7712 76.9246 80.5504 76.5942 80.3588C76.2637 80.1672 75.8828 80.0227 75.4763 79.9251C75.0548 79.8241 74.6058 79.7735 74.1569 79.7735C73.7079 79.7735 73.2589 79.8241 72.8374 79.9251C72.4309 80.0227 72.05 80.1672 71.7195 80.3588C71.3891 80.5504 71.1397 80.7712 70.9715 81.0069C70.7971 81.2512 70.71 81.5114 70.71 81.7717V83.6558C70.71 83.9161 70.7971 84.1764 70.9715 84.4207C71.1397 84.6563 71.3891 84.8771 71.7195 85.0687C72.05 85.2603 72.4309 85.4049 72.8374 85.5024C73.2589 85.6034 73.7079 85.654 74.1569 85.654C74.6058 85.654 75.0548 85.6034 75.4763 85.5024C75.8828 85.4049 76.2637 85.2603 76.5942 85.0687C76.9246 84.8771 77.174 84.6563 77.3422 84.4207Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_258_570)"
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3422 84.4207C77.5166 84.1764 77.6037 83.9161 77.6037 83.6558V81.7717C77.6037 81.5114 77.5166 81.2512 77.3422 81.0069C77.174 80.7712 76.9246 80.5504 76.5942 80.3588C76.2637 80.1672 75.8828 80.0227 75.4763 79.9251C75.0548 79.8241 74.6058 79.7735 74.1569 79.7735C73.7079 79.7735 73.2589 79.8241 72.8374 79.9251C72.4309 80.0227 72.05 80.1672 71.7195 80.3588C71.3891 80.5504 71.1397 80.7712 70.9715 81.0069C70.7971 81.2512 70.71 81.5114 70.71 81.7717V83.6558C70.71 83.9161 70.7971 84.1764 70.9715 84.4207C71.1397 84.6563 71.3891 84.8771 71.7195 85.0687C72.05 85.2603 72.4309 85.4049 72.8374 85.5024C73.2589 85.6034 73.7079 85.654 74.1569 85.654C74.6058 85.654 75.0548 85.6034 75.4763 85.5024C75.8828 85.4049 76.2637 85.2603 76.5942 85.0687C76.9246 84.8771 77.174 84.6563 77.3422 84.4207Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.3422 84.4243C77.5166 84.18 77.6037 83.9197 77.6037 83.6594V81.7753C77.6037 82.0356 77.5166 82.2959 77.3422 82.5402C77.174 82.7759 76.9246 82.9967 76.5942 83.1883C76.2637 83.3799 75.8828 83.5244 75.4763 83.6219C75.0548 83.723 74.6058 83.7735 74.1569 83.7735C73.7079 83.7735 73.2589 83.723 72.8374 83.6219C72.4309 83.5244 72.05 83.3799 71.7195 83.1883C71.3891 82.9967 71.1397 82.7759 70.9715 82.5402C70.7971 82.2959 70.71 82.0356 70.71 81.7753V83.6594C70.71 83.9197 70.7971 84.18 70.9715 84.4243C71.1397 84.66 71.3891 84.8808 71.7195 85.0723C72.05 85.2639 72.4309 85.4085 72.8374 85.506C73.2589 85.6071 73.7079 85.6576 74.1569 85.6576C74.6058 85.6576 75.0548 85.6071 75.4763 85.506C75.8828 85.4085 76.2637 85.2639 76.5942 85.0723C76.9246 84.8808 77.174 84.66 77.3422 84.4243Z",
    fill: "url(#paint17_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9715 81.0069C70.7971 81.2512 70.71 81.5114 70.71 81.7717C70.71 82.032 70.7971 82.2923 70.9715 82.5366C71.1397 82.7723 71.3891 82.9931 71.7195 83.1847C72.05 83.3762 72.4309 83.5208 72.8374 83.6183C73.2589 83.7194 73.7079 83.7699 74.1569 83.7699C74.6058 83.7699 75.0548 83.7194 75.4763 83.6183C75.8828 83.5208 76.2637 83.3762 76.5942 83.1847C76.9246 82.9931 77.174 82.7723 77.3422 82.5366C77.5166 82.2923 77.6037 82.032 77.6037 81.7717C77.6037 81.5114 77.5166 81.2512 77.3422 81.0069C77.174 80.7712 76.9246 80.5504 76.5942 80.3588C76.2637 80.1672 75.8828 80.0227 75.4763 79.9251C75.0548 79.8241 74.6058 79.7735 74.1569 79.7735C73.7079 79.7735 73.2589 79.8241 72.8374 79.9251C72.4309 80.0227 72.05 80.1672 71.7195 80.3588C71.3891 80.5504 71.1397 80.7712 70.9715 81.0069Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8975 80.9511C70.7231 81.1954 70.71 81.5629 70.71 81.8232C70.71 82.0835 70.7971 82.3438 70.9715 82.5881C71.1397 82.8237 71.3891 83.0445 71.7195 83.2361C72.05 83.4277 72.4309 83.5722 72.8374 83.6698C73.2589 83.7708 73.7079 83.8214 74.1569 83.8214C74.6058 83.8214 75.0548 83.7708 75.4763 83.6698C75.8828 83.5722 76.2637 83.4277 76.5942 83.2361C76.9246 83.0445 77.174 82.8237 77.3422 82.5881C77.5166 82.3438 77.6037 82.0835 77.6037 81.8232C77.6037 81.5629 77.5915 81.2064 77.4172 80.9621",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.8975 80.9511C70.7231 81.1954 70.71 81.5629 70.71 81.8232C70.71 82.0835 70.7971 82.3438 70.9715 82.5881C71.1397 82.8237 71.3891 83.0445 71.7195 83.2361C72.05 83.4277 72.4309 83.5722 72.8374 83.6698C73.2589 83.7708 73.7079 83.8214 74.1569 83.8214C74.6058 83.8214 75.0548 83.7708 75.4763 83.6698C75.8828 83.5722 76.2637 83.4277 76.5942 83.2361C76.9246 83.0445 77.174 82.8237 77.3422 82.5881C77.5166 82.3438 77.6037 82.0835 77.6037 81.8232C77.6037 81.5629 77.5915 81.2064 77.4172 80.9621",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 84,
    width: 8,
    height: 7
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2172 89.1308C69.3916 88.8865 69.4787 88.6262 69.4787 88.3659V86.4819C69.4787 86.2216 69.3916 85.9613 69.2172 85.717C69.049 85.4813 68.7996 85.2605 68.4692 85.0689C68.1387 84.8774 67.7578 84.7328 67.3513 84.6353C66.9298 84.5342 66.4808 84.4837 66.0319 84.4837C65.5829 84.4837 65.1339 84.5342 64.7124 84.6353C64.3059 84.7328 63.925 84.8774 63.5945 85.0689C63.2641 85.2605 63.0147 85.4813 62.8465 85.717C62.6721 85.9613 62.585 86.2216 62.585 86.4819V88.3659C62.585 88.6262 62.6721 88.8865 62.8465 89.1308C63.0147 89.3665 63.2641 89.5873 63.5945 89.7789C63.925 89.9704 64.3059 90.115 64.7124 90.2125C65.1339 90.3136 65.5829 90.3641 66.0319 90.3641C66.4808 90.3641 66.9298 90.3136 67.3513 90.2125C67.7578 90.115 68.1387 89.9704 68.4692 89.7789C68.7996 89.5873 69.049 89.3665 69.2172 89.1308Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_258_570)"
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2172 89.1308C69.3916 88.8865 69.4787 88.6262 69.4787 88.3659V86.4819C69.4787 86.2216 69.3916 85.9613 69.2172 85.717C69.049 85.4813 68.7996 85.2605 68.4692 85.0689C68.1387 84.8774 67.7578 84.7328 67.3513 84.6353C66.9298 84.5342 66.4808 84.4837 66.0319 84.4837C65.5829 84.4837 65.1339 84.5342 64.7124 84.6353C64.3059 84.7328 63.925 84.8774 63.5945 85.0689C63.2641 85.2605 63.0147 85.4813 62.8465 85.717C62.6721 85.9613 62.585 86.2216 62.585 86.4819V88.3659C62.585 88.6262 62.6721 88.8865 62.8465 89.1308C63.0147 89.3665 63.2641 89.5873 63.5945 89.7789C63.925 89.9704 64.3059 90.115 64.7124 90.2125C65.1339 90.3136 65.5829 90.3641 66.0319 90.3641C66.4808 90.3641 66.9298 90.3136 67.3513 90.2125C67.7578 90.115 68.1387 89.9704 68.4692 89.7789C68.7996 89.5873 69.049 89.3665 69.2172 89.1308Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.2172 89.1344C69.3916 88.8901 69.4787 88.6298 69.4787 88.3695V86.4855C69.4787 86.7458 69.3916 87.0061 69.2172 87.2504C69.049 87.486 68.7996 87.7068 68.4692 87.8984C68.1387 88.09 67.7578 88.2346 67.3513 88.3321C66.9298 88.4331 66.4808 88.4837 66.0319 88.4837C65.5829 88.4837 65.1339 88.4331 64.7124 88.3321C64.3059 88.2346 63.925 88.09 63.5945 87.8984C63.2641 87.7068 63.0147 87.486 62.8465 87.2504C62.6721 87.0061 62.585 86.7458 62.585 86.4855V88.3695C62.585 88.6298 62.6721 88.8901 62.8465 89.1344C63.0147 89.3701 63.2641 89.5909 63.5945 89.7825C63.925 89.9741 64.3059 90.1186 64.7124 90.2161C65.1339 90.3172 65.5829 90.3677 66.0319 90.3677C66.4808 90.3677 66.9298 90.3172 67.3513 90.2161C67.7578 90.1186 68.1387 89.9741 68.4692 89.7825C68.7996 89.5909 69.049 89.3701 69.2172 89.1344Z",
    fill: "url(#paint18_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8465 85.717C62.6721 85.9613 62.585 86.2216 62.585 86.4819C62.585 86.7422 62.6721 87.0024 62.8465 87.2467C63.0147 87.4824 63.2641 87.7032 63.5945 87.8948C63.925 88.0864 64.3059 88.2309 64.7124 88.3284C65.1339 88.4295 65.5829 88.4801 66.0319 88.4801C66.4808 88.4801 66.9298 88.4295 67.3513 88.3284C67.7578 88.2309 68.1387 88.0864 68.4692 87.8948C68.7996 87.7032 69.049 87.4824 69.2172 87.2467C69.3916 87.0024 69.4787 86.7422 69.4787 86.4819C69.4787 86.2216 69.3916 85.9613 69.2172 85.717C69.049 85.4813 68.7996 85.2605 68.4692 85.0689C68.1387 84.8774 67.7578 84.7328 67.3513 84.6353C66.9298 84.5342 66.4808 84.4837 66.0319 84.4837C65.5829 84.4837 65.1339 84.5342 64.7124 84.6353C64.3059 84.7328 63.925 84.8774 63.5945 85.0689C63.2641 85.2605 63.0147 85.4813 62.8465 85.717Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7725 85.6612C62.5981 85.9055 62.585 86.273 62.585 86.5333C62.585 86.7936 62.6721 87.0539 62.8465 87.2982C63.0147 87.5339 63.2641 87.7547 63.5945 87.9463C63.925 88.1378 64.3059 88.2824 64.7124 88.3799C65.1339 88.481 65.5829 88.5315 66.0319 88.5315C66.4808 88.5315 66.9298 88.481 67.3513 88.3799C67.7578 88.2824 68.1387 88.1378 68.4692 87.9463C68.7996 87.7547 69.049 87.5339 69.2172 87.2982C69.3916 87.0539 69.4787 86.7936 69.4787 86.5333C69.4787 86.273 69.4665 85.9166 69.2922 85.6722",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.7725 85.6612C62.5981 85.9055 62.585 86.273 62.585 86.5333C62.585 86.7936 62.6721 87.0539 62.8465 87.2982C63.0147 87.5339 63.2641 87.7547 63.5945 87.9463C63.925 88.1378 64.3059 88.2824 64.7124 88.3799C65.1339 88.481 65.5829 88.5315 66.0319 88.5315C66.4808 88.5315 66.9298 88.481 67.3513 88.3799C67.7578 88.2824 68.1387 88.1378 68.4692 87.9463C68.7996 87.7547 69.049 87.5339 69.2172 87.2982C69.3916 87.0539 69.4787 86.7936 69.4787 86.5333C69.4787 86.273 69.4665 85.9166 69.2922 85.6722",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 89,
    width: 8,
    height: 7
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0922 93.841C61.2666 93.5966 61.3537 93.3364 61.3537 93.0761V91.192C61.3537 90.9317 61.2666 90.6714 61.0922 90.4271C60.924 90.1915 60.6746 89.9707 60.3442 89.7791C60.0137 89.5875 59.6328 89.4429 59.2263 89.3454C58.8048 89.2444 58.3558 89.1938 57.9069 89.1938C57.4579 89.1938 57.0089 89.2444 56.5874 89.3454C56.1809 89.4429 55.8 89.5875 55.4695 89.7791C55.1391 89.9707 54.8897 90.1915 54.7215 90.4271C54.5471 90.6714 54.46 90.9317 54.46 91.192V93.0761C54.46 93.3364 54.5471 93.5966 54.7215 93.841C54.8897 94.0766 55.1391 94.2974 55.4695 94.489C55.8 94.6806 56.1809 94.8251 56.5874 94.9227C57.0089 95.0237 57.4579 95.0743 57.9069 95.0743C58.3558 95.0743 58.8048 95.0237 59.2263 94.9227C59.6328 94.8251 60.0137 94.6806 60.3442 94.489C60.6746 94.2974 60.924 94.0766 61.0922 93.841Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_258_570)"
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0922 93.841C61.2666 93.5966 61.3537 93.3364 61.3537 93.0761V91.192C61.3537 90.9317 61.2666 90.6714 61.0922 90.4271C60.924 90.1915 60.6746 89.9707 60.3442 89.7791C60.0137 89.5875 59.6328 89.4429 59.2263 89.3454C58.8048 89.2444 58.3558 89.1938 57.9069 89.1938C57.4579 89.1938 57.0089 89.2444 56.5874 89.3454C56.1809 89.4429 55.8 89.5875 55.4695 89.7791C55.1391 89.9707 54.8897 90.1915 54.7215 90.4271C54.5471 90.6714 54.46 90.9317 54.46 91.192V93.0761C54.46 93.3364 54.5471 93.5966 54.7215 93.841C54.8897 94.0766 55.1391 94.2974 55.4695 94.489C55.8 94.6806 56.1809 94.8251 56.5874 94.9227C57.0089 95.0237 57.4579 95.0743 57.9069 95.0743C58.3558 95.0743 58.8048 95.0237 59.2263 94.9227C59.6328 94.8251 60.0137 94.6806 60.3442 94.489C60.6746 94.2974 60.924 94.0766 61.0922 93.841Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.0922 93.8446C61.2666 93.6003 61.3537 93.34 61.3537 93.0797V91.1956C61.3537 91.4559 61.2666 91.7162 61.0922 91.9605C60.924 92.1962 60.6746 92.417 60.3442 92.6086C60.0137 92.8001 59.6328 92.9447 59.2263 93.0422C58.8048 93.1433 58.3558 93.1938 57.9069 93.1938C57.4579 93.1938 57.0089 93.1433 56.5874 93.0422C56.1809 92.9447 55.8 92.8001 55.4695 92.6086C55.1391 92.417 54.8897 92.1962 54.7215 91.9605C54.5471 91.7162 54.46 91.4559 54.46 91.1956V93.0797C54.46 93.34 54.5471 93.6003 54.7215 93.8446C54.8897 94.0802 55.1391 94.301 55.4695 94.4926C55.8 94.6842 56.1809 94.8288 56.5874 94.9263C57.0089 95.0273 57.4579 95.0779 57.9069 95.0779C58.3558 95.0779 58.8048 95.0273 59.2263 94.9263C59.6328 94.8288 60.0137 94.6842 60.3442 94.4926C60.6746 94.301 60.924 94.0802 61.0922 93.8446Z",
    fill: "url(#paint19_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7215 90.4271C54.5471 90.6714 54.46 90.9317 54.46 91.192C54.46 91.4523 54.5471 91.7126 54.7215 91.9569C54.8897 92.1926 55.1391 92.4134 55.4695 92.605C55.8 92.7965 56.1809 92.9411 56.5874 93.0386C57.0089 93.1397 57.4579 93.1902 57.9069 93.1902C58.3558 93.1902 58.8048 93.1397 59.2263 93.0386C59.6328 92.9411 60.0137 92.7965 60.3442 92.605C60.6746 92.4134 60.924 92.1926 61.0922 91.9569C61.2666 91.7126 61.3537 91.4523 61.3537 91.192C61.3537 90.9317 61.2666 90.6714 61.0922 90.4271C60.924 90.1915 60.6746 89.9707 60.3442 89.7791C60.0137 89.5875 59.6328 89.4429 59.2263 89.3454C58.8048 89.2444 58.3558 89.1938 57.9069 89.1938C57.4579 89.1938 57.0089 89.2444 56.5874 89.3454C56.1809 89.4429 55.8 89.5875 55.4695 89.7791C55.1391 89.9707 54.8897 90.1915 54.7215 90.4271Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6475 90.3714C54.4731 90.6157 54.46 90.9832 54.46 91.2435C54.46 91.5038 54.5471 91.764 54.7215 92.0083C54.8897 92.244 55.1391 92.4648 55.4695 92.6564C55.8 92.848 56.1809 92.9925 56.5874 93.09C57.0089 93.1911 57.4579 93.2417 57.9069 93.2417C58.3558 93.2417 58.8048 93.1911 59.2263 93.09C59.6328 92.9925 60.0137 92.848 60.3442 92.6564C60.6746 92.4648 60.924 92.244 61.0922 92.0083C61.2666 91.764 61.3537 91.5038 61.3537 91.2435C61.3537 90.9832 61.3415 90.6267 61.1672 90.3824",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.6475 90.3714C54.4731 90.6157 54.46 90.9832 54.46 91.2435C54.46 91.5038 54.5471 91.764 54.7215 92.0083C54.8897 92.244 55.1391 92.4648 55.4695 92.6564C55.8 92.848 56.1809 92.9925 56.5874 93.09C57.0089 93.1911 57.4579 93.2417 57.9069 93.2417C58.3558 93.2417 58.8048 93.1911 59.2263 93.09C59.6328 92.9925 60.0137 92.848 60.3442 92.6564C60.6746 92.4648 60.924 92.244 61.0922 92.0083C61.2666 91.764 61.3537 91.5038 61.3537 91.2435C61.3537 90.9832 61.3415 90.6267 61.1672 90.3824",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 83,
    width: 33,
    height: 27
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M66 104.249C66 104.333 66.0447 104.41 66.1174 104.453L74.0073 109.026C74.0804 109.069 74.1705 109.069 74.2435 109.026L82.1327 104.453C82.2058 104.411 82.2959 104.411 82.3689 104.453L90.2581 109.026C90.3312 109.069 90.4213 109.069 90.4944 109.026L98.3843 104.453C98.4569 104.41 98.5017 104.333 98.5017 104.249V93.2159C98.5017 93.1319 98.4569 93.0543 98.3843 93.0121L82.369 83.7279C82.2959 83.6855 82.2058 83.6855 82.1327 83.7279L66.1174 93.0121C66.0447 93.0543 66 93.1319 66 93.2159V104.249Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_258_570)"
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.1244 88.3688L65.999 93.0792L65.999 104.384L74.1244 109.094L82.2499 104.384L90.3753 109.094L98.5007 104.384V93.0792L90.3753 88.3688L82.2499 83.6584L74.1244 88.3688Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.5004 104.384L98.5004 93.0794L90.375 97.7898L90.375 109.094L98.5004 104.384Z",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2504 104.384L82.2504 93.0794L74.125 97.7898L74.125 109.094L82.2504 104.384Z",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2496 104.384L82.2496 93.0794L90.375 97.7898L90.375 109.094L82.2496 104.384Z",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9996 104.384L65.9996 93.0794L74.125 97.7898L74.125 109.094L65.9996 104.384Z",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.1246 97.7896L65.9992 93.0792L74.1246 88.3688L82.25 83.6584L90.3754 88.3688L98.5008 93.0792L90.3754 97.7896L82.25 93.0792L74.1246 97.7896Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M98.5 104.384L90.375 109.094",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M82.25 104.384L74.125 109.094",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M90.3742 109.094L82.25 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M74.1242 109.094L66 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M98.5 93.0797L98.5 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M66 93.0797L66 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M90.375 97.7898V109.094",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M74.125 97.7898V109.094",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5 93.0797L90.375 97.7898",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M82.25 93.0797L74.125 97.7898",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3742 97.7894L82.25 93.0797",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1242 97.7894L66 93.0797",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.375 97.7898V109.094",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.125 97.7898V109.094",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5 93.0797L90.375 97.7898",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25 93.0797L74.125 97.7898",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3742 97.7894L82.25 93.0797",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1242 97.7894L66 93.0797",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 84,
    width: 8,
    height: 7
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4672 89.1308C85.6416 88.8865 85.7287 88.6262 85.7287 88.3659V86.4819C85.7287 86.2216 85.6416 85.9613 85.4672 85.717C85.299 85.4813 85.0496 85.2605 84.7192 85.0689C84.3887 84.8774 84.0078 84.7328 83.6013 84.6353C83.1798 84.5342 82.7308 84.4837 82.2819 84.4837C81.8329 84.4837 81.3839 84.5342 80.9624 84.6353C80.5559 84.7328 80.175 84.8774 79.8445 85.0689C79.5141 85.2605 79.2647 85.4813 79.0965 85.717C78.9221 85.9613 78.835 86.2216 78.835 86.4819V88.3659C78.835 88.6262 78.9221 88.8865 79.0965 89.1308C79.2647 89.3665 79.5141 89.5873 79.8445 89.7789C80.175 89.9704 80.5559 90.115 80.9624 90.2125C81.3839 90.3136 81.8329 90.3641 82.2819 90.3641C82.7308 90.3641 83.1798 90.3136 83.6013 90.2125C84.0078 90.115 84.3887 89.9704 84.7192 89.7789C85.0496 89.5873 85.299 89.3665 85.4672 89.1308Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_258_570)"
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4672 89.1308C85.6416 88.8865 85.7287 88.6262 85.7287 88.3659V86.4819C85.7287 86.2216 85.6416 85.9613 85.4672 85.717C85.299 85.4813 85.0496 85.2605 84.7192 85.0689C84.3887 84.8774 84.0078 84.7328 83.6013 84.6353C83.1798 84.5342 82.7308 84.4837 82.2819 84.4837C81.8329 84.4837 81.3839 84.5342 80.9624 84.6353C80.5559 84.7328 80.175 84.8774 79.8445 85.0689C79.5141 85.2605 79.2647 85.4813 79.0965 85.717C78.9221 85.9613 78.835 86.2216 78.835 86.4819V88.3659C78.835 88.6262 78.9221 88.8865 79.0965 89.1308C79.2647 89.3665 79.5141 89.5873 79.8445 89.7789C80.175 89.9704 80.5559 90.115 80.9624 90.2125C81.3839 90.3136 81.8329 90.3641 82.2819 90.3641C82.7308 90.3641 83.1798 90.3136 83.6013 90.2125C84.0078 90.115 84.3887 89.9704 84.7192 89.7789C85.0496 89.5873 85.299 89.3665 85.4672 89.1308Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.4672 89.1344C85.6416 88.8901 85.7287 88.6298 85.7287 88.3695V86.4855C85.7287 86.7458 85.6416 87.0061 85.4672 87.2504C85.299 87.486 85.0496 87.7068 84.7192 87.8984C84.3887 88.09 84.0078 88.2346 83.6013 88.3321C83.1798 88.4331 82.7308 88.4837 82.2819 88.4837C81.8329 88.4837 81.3839 88.4331 80.9624 88.3321C80.5559 88.2346 80.175 88.09 79.8445 87.8984C79.5141 87.7068 79.2647 87.486 79.0965 87.2504C78.9221 87.0061 78.835 86.7458 78.835 86.4855V88.3695C78.835 88.6298 78.9221 88.8901 79.0965 89.1344C79.2647 89.3701 79.5141 89.5909 79.8445 89.7825C80.175 89.9741 80.5559 90.1186 80.9624 90.2161C81.3839 90.3172 81.8329 90.3677 82.2819 90.3677C82.7308 90.3677 83.1798 90.3172 83.6013 90.2161C84.0078 90.1186 84.3887 89.9741 84.7192 89.7825C85.0496 89.5909 85.299 89.3701 85.4672 89.1344Z",
    fill: "url(#paint20_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0965 85.717C78.9221 85.9613 78.835 86.2216 78.835 86.4819C78.835 86.7422 78.9221 87.0024 79.0965 87.2467C79.2647 87.4824 79.5141 87.7032 79.8445 87.8948C80.175 88.0864 80.5559 88.2309 80.9624 88.3284C81.3839 88.4295 81.8329 88.4801 82.2819 88.4801C82.7308 88.4801 83.1798 88.4295 83.6013 88.3284C84.0078 88.2309 84.3887 88.0864 84.7192 87.8948C85.0496 87.7032 85.299 87.4824 85.4672 87.2467C85.6416 87.0024 85.7287 86.7422 85.7287 86.4819C85.7287 86.2216 85.6416 85.9613 85.4672 85.717C85.299 85.4813 85.0496 85.2605 84.7192 85.0689C84.3887 84.8774 84.0078 84.7328 83.6013 84.6353C83.1798 84.5342 82.7308 84.4837 82.2819 84.4837C81.8329 84.4837 81.3839 84.5342 80.9624 84.6353C80.5559 84.7328 80.175 84.8774 79.8445 85.0689C79.5141 85.2605 79.2647 85.4813 79.0965 85.717Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0225 85.6612C78.8481 85.9055 78.835 86.273 78.835 86.5333C78.835 86.7936 78.9221 87.0539 79.0965 87.2982C79.2647 87.5339 79.5141 87.7547 79.8445 87.9463C80.175 88.1378 80.5559 88.2824 80.9624 88.3799C81.3839 88.481 81.8329 88.5315 82.2819 88.5315C82.7308 88.5315 83.1798 88.481 83.6013 88.3799C84.0078 88.2824 84.3887 88.1378 84.7192 87.9463C85.0496 87.7547 85.299 87.5339 85.4672 87.2982C85.6416 87.0539 85.7287 86.7936 85.7287 86.5333C85.7287 86.273 85.7165 85.9166 85.5422 85.6722",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.0225 85.6612C78.8481 85.9055 78.835 86.273 78.835 86.5333C78.835 86.7936 78.9221 87.0539 79.0965 87.2982C79.2647 87.5339 79.5141 87.7547 79.8445 87.9463C80.175 88.1378 80.5559 88.2824 80.9624 88.3799C81.3839 88.481 81.8329 88.5315 82.2819 88.5315C82.7308 88.5315 83.1798 88.481 83.6013 88.3799C84.0078 88.2824 84.3887 88.1378 84.7192 87.9463C85.0496 87.7547 85.299 87.5339 85.4672 87.2982C85.6416 87.0539 85.7287 86.7936 85.7287 86.5333C85.7287 86.273 85.7165 85.9166 85.5422 85.6722",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 89,
    width: 8,
    height: 7
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3422 93.841C77.5166 93.5966 77.6037 93.3364 77.6037 93.0761V91.192C77.6037 90.9317 77.5166 90.6714 77.3422 90.4271C77.174 90.1915 76.9246 89.9707 76.5942 89.7791C76.2637 89.5875 75.8828 89.4429 75.4763 89.3454C75.0548 89.2444 74.6058 89.1938 74.1569 89.1938C73.7079 89.1938 73.2589 89.2444 72.8374 89.3454C72.4309 89.4429 72.05 89.5875 71.7195 89.7791C71.3891 89.9707 71.1397 90.1915 70.9715 90.4271C70.7971 90.6714 70.71 90.9317 70.71 91.192V93.0761C70.71 93.3364 70.7971 93.5966 70.9715 93.841C71.1397 94.0766 71.3891 94.2974 71.7195 94.489C72.05 94.6806 72.4309 94.8251 72.8374 94.9227C73.2589 95.0237 73.7079 95.0743 74.1569 95.0743C74.6058 95.0743 75.0548 95.0237 75.4763 94.9227C75.8828 94.8251 76.2637 94.6806 76.5942 94.489C76.9246 94.2974 77.174 94.0766 77.3422 93.841Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_258_570)"
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3422 93.841C77.5166 93.5966 77.6037 93.3364 77.6037 93.0761V91.192C77.6037 90.9317 77.5166 90.6714 77.3422 90.4271C77.174 90.1915 76.9246 89.9707 76.5942 89.7791C76.2637 89.5875 75.8828 89.4429 75.4763 89.3454C75.0548 89.2444 74.6058 89.1938 74.1569 89.1938C73.7079 89.1938 73.2589 89.2444 72.8374 89.3454C72.4309 89.4429 72.05 89.5875 71.7195 89.7791C71.3891 89.9707 71.1397 90.1915 70.9715 90.4271C70.7971 90.6714 70.71 90.9317 70.71 91.192V93.0761C70.71 93.3364 70.7971 93.5966 70.9715 93.841C71.1397 94.0766 71.3891 94.2974 71.7195 94.489C72.05 94.6806 72.4309 94.8251 72.8374 94.9227C73.2589 95.0237 73.7079 95.0743 74.1569 95.0743C74.6058 95.0743 75.0548 95.0237 75.4763 94.9227C75.8828 94.8251 76.2637 94.6806 76.5942 94.489C76.9246 94.2974 77.174 94.0766 77.3422 93.841Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.3422 93.8446C77.5166 93.6003 77.6037 93.34 77.6037 93.0797V91.1956C77.6037 91.4559 77.5166 91.7162 77.3422 91.9605C77.174 92.1962 76.9246 92.417 76.5942 92.6086C76.2637 92.8001 75.8828 92.9447 75.4763 93.0422C75.0548 93.1433 74.6058 93.1938 74.1569 93.1938C73.7079 93.1938 73.2589 93.1433 72.8374 93.0422C72.4309 92.9447 72.05 92.8001 71.7195 92.6086C71.3891 92.417 71.1397 92.1962 70.9715 91.9605C70.7971 91.7162 70.71 91.4559 70.71 91.1956V93.0797C70.71 93.34 70.7971 93.6003 70.9715 93.8446C71.1397 94.0802 71.3891 94.301 71.7195 94.4926C72.05 94.6842 72.4309 94.8288 72.8374 94.9263C73.2589 95.0273 73.7079 95.0779 74.1569 95.0779C74.6058 95.0779 75.0548 95.0273 75.4763 94.9263C75.8828 94.8288 76.2637 94.6842 76.5942 94.4926C76.9246 94.301 77.174 94.0802 77.3422 93.8446Z",
    fill: "url(#paint21_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9715 90.4271C70.7971 90.6714 70.71 90.9317 70.71 91.192C70.71 91.4523 70.7971 91.7126 70.9715 91.9569C71.1397 92.1926 71.3891 92.4134 71.7195 92.605C72.05 92.7965 72.4309 92.9411 72.8374 93.0386C73.2589 93.1397 73.7079 93.1902 74.1569 93.1902C74.6058 93.1902 75.0548 93.1397 75.4763 93.0386C75.8828 92.9411 76.2637 92.7965 76.5942 92.605C76.9246 92.4134 77.174 92.1926 77.3422 91.9569C77.5166 91.7126 77.6037 91.4523 77.6037 91.192C77.6037 90.9317 77.5166 90.6714 77.3422 90.4271C77.174 90.1915 76.9246 89.9707 76.5942 89.7791C76.2637 89.5875 75.8828 89.4429 75.4763 89.3454C75.0548 89.2444 74.6058 89.1938 74.1569 89.1938C73.7079 89.1938 73.2589 89.2444 72.8374 89.3454C72.4309 89.4429 72.05 89.5875 71.7195 89.7791C71.3891 89.9707 71.1397 90.1915 70.9715 90.4271Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8975 90.3714C70.7231 90.6157 70.71 90.9832 70.71 91.2435C70.71 91.5038 70.7971 91.764 70.9715 92.0083C71.1397 92.244 71.3891 92.4648 71.7195 92.6564C72.05 92.848 72.4309 92.9925 72.8374 93.09C73.2589 93.1911 73.7079 93.2417 74.1569 93.2417C74.6058 93.2417 75.0548 93.1911 75.4763 93.09C75.8828 92.9925 76.2637 92.848 76.5942 92.6564C76.9246 92.4648 77.174 92.244 77.3422 92.0083C77.5166 91.764 77.6037 91.5038 77.6037 91.2435C77.6037 90.9832 77.5915 90.6267 77.4172 90.3824",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.8975 90.3714C70.7231 90.6157 70.71 90.9832 70.71 91.2435C70.71 91.5038 70.7971 91.764 70.9715 92.0083C71.1397 92.244 71.3891 92.4648 71.7195 92.6564C72.05 92.848 72.4309 92.9925 72.8374 93.09C73.2589 93.1911 73.7079 93.2417 74.1569 93.2417C74.6058 93.2417 75.0548 93.1911 75.4763 93.09C75.8828 92.9925 76.2637 92.848 76.5942 92.6564C76.9246 92.4648 77.174 92.244 77.3422 92.0083C77.5166 91.764 77.6037 91.5038 77.6037 91.2435C77.6037 90.9832 77.5915 90.6267 77.4172 90.3824",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 89,
    width: 8,
    height: 7
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5922 93.841C93.7666 93.5966 93.8537 93.3364 93.8537 93.0761V91.192C93.8537 90.9317 93.7666 90.6714 93.5922 90.4271C93.424 90.1915 93.1746 89.9707 92.8442 89.7791C92.5137 89.5875 92.1328 89.4429 91.7263 89.3454C91.3048 89.2444 90.8558 89.1938 90.4069 89.1938C89.9579 89.1938 89.5089 89.2444 89.0874 89.3454C88.6809 89.4429 88.3 89.5875 87.9695 89.7791C87.6391 89.9707 87.3897 90.1915 87.2215 90.4271C87.0471 90.6714 86.96 90.9317 86.96 91.192V93.0761C86.96 93.3364 87.0471 93.5966 87.2215 93.841C87.3897 94.0766 87.6391 94.2974 87.9695 94.489C88.3 94.6806 88.6809 94.8251 89.0874 94.9227C89.5089 95.0237 89.9579 95.0743 90.4069 95.0743C90.8558 95.0743 91.3048 95.0237 91.7263 94.9227C92.1328 94.8251 92.5137 94.6806 92.8442 94.489C93.1746 94.2974 93.424 94.0766 93.5922 93.841Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_258_570)"
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5922 93.841C93.7666 93.5966 93.8537 93.3364 93.8537 93.0761V91.192C93.8537 90.9317 93.7666 90.6714 93.5922 90.4271C93.424 90.1915 93.1746 89.9707 92.8442 89.7791C92.5137 89.5875 92.1328 89.4429 91.7263 89.3454C91.3048 89.2444 90.8558 89.1938 90.4069 89.1938C89.9579 89.1938 89.5089 89.2444 89.0874 89.3454C88.6809 89.4429 88.3 89.5875 87.9695 89.7791C87.6391 89.9707 87.3897 90.1915 87.2215 90.4271C87.0471 90.6714 86.96 90.9317 86.96 91.192V93.0761C86.96 93.3364 87.0471 93.5966 87.2215 93.841C87.3897 94.0766 87.6391 94.2974 87.9695 94.489C88.3 94.6806 88.6809 94.8251 89.0874 94.9227C89.5089 95.0237 89.9579 95.0743 90.4069 95.0743C90.8558 95.0743 91.3048 95.0237 91.7263 94.9227C92.1328 94.8251 92.5137 94.6806 92.8442 94.489C93.1746 94.2974 93.424 94.0766 93.5922 93.841Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M93.5922 93.8446C93.7666 93.6003 93.8537 93.34 93.8537 93.0797V91.1956C93.8537 91.4559 93.7666 91.7162 93.5922 91.9605C93.424 92.1962 93.1746 92.417 92.8442 92.6086C92.5137 92.8001 92.1328 92.9447 91.7263 93.0422C91.3048 93.1433 90.8558 93.1938 90.4069 93.1938C89.9579 93.1938 89.5089 93.1433 89.0874 93.0422C88.6809 92.9447 88.3 92.8001 87.9695 92.6086C87.6391 92.417 87.3897 92.1962 87.2215 91.9605C87.0471 91.7162 86.96 91.4559 86.96 91.1956V93.0797C86.96 93.34 87.0471 93.6003 87.2215 93.8446C87.3897 94.0802 87.6391 94.301 87.9695 94.4926C88.3 94.6842 88.6809 94.8288 89.0874 94.9263C89.5089 95.0273 89.9579 95.0779 90.4069 95.0779C90.8558 95.0779 91.3048 95.0273 91.7263 94.9263C92.1328 94.8288 92.5137 94.6842 92.8442 94.4926C93.1746 94.301 93.424 94.0802 93.5922 93.8446Z",
    fill: "url(#paint22_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2215 90.4271C87.0471 90.6714 86.96 90.9317 86.96 91.192C86.96 91.4523 87.0471 91.7126 87.2215 91.9569C87.3897 92.1926 87.6391 92.4134 87.9695 92.605C88.3 92.7965 88.6809 92.9411 89.0874 93.0386C89.5089 93.1397 89.9579 93.1902 90.4069 93.1902C90.8558 93.1902 91.3048 93.1397 91.7263 93.0386C92.1328 92.9411 92.5137 92.7965 92.8442 92.605C93.1746 92.4134 93.424 92.1926 93.5922 91.9569C93.7666 91.7126 93.8537 91.4523 93.8537 91.192C93.8537 90.9317 93.7666 90.6714 93.5922 90.4271C93.424 90.1915 93.1746 89.9707 92.8442 89.7791C92.5137 89.5875 92.1328 89.4429 91.7263 89.3454C91.3048 89.2444 90.8558 89.1938 90.4069 89.1938C89.9579 89.1938 89.5089 89.2444 89.0874 89.3454C88.6809 89.4429 88.3 89.5875 87.9695 89.7791C87.6391 89.9707 87.3897 90.1915 87.2215 90.4271Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1475 90.3714C86.9731 90.6157 86.96 90.9832 86.96 91.2435C86.96 91.5038 87.0471 91.764 87.2215 92.0083C87.3897 92.244 87.6391 92.4648 87.9695 92.6564C88.3 92.848 88.6809 92.9925 89.0874 93.09C89.5089 93.1911 89.9579 93.2417 90.4069 93.2417C90.8558 93.2417 91.3048 93.1911 91.7263 93.09C92.1328 92.9925 92.5137 92.848 92.8442 92.6564C93.1746 92.4648 93.424 92.244 93.5922 92.0083C93.7666 91.764 93.8537 91.5038 93.8537 91.2435C93.8537 90.9832 93.8415 90.6267 93.6672 90.3824",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.1475 90.3714C86.9731 90.6157 86.96 90.9832 86.96 91.2435C86.96 91.5038 87.0471 91.764 87.2215 92.0083C87.3897 92.244 87.6391 92.4648 87.9695 92.6564C88.3 92.848 88.6809 92.9925 89.0874 93.09C89.5089 93.1911 89.9579 93.2417 90.4069 93.2417C90.8558 93.2417 91.3048 93.1911 91.7263 93.09C92.1328 92.9925 92.5137 92.848 92.8442 92.6564C93.1746 92.4648 93.424 92.244 93.5922 92.0083C93.7666 91.764 93.8537 91.5038 93.8537 91.2435C93.8537 90.9832 93.8415 90.6267 93.6672 90.3824",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 83,
    width: 25,
    height: 31
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4987 104.249C33.4987 104.333 33.5435 104.41 33.6161 104.453L49.6315 113.737C49.7045 113.779 49.7946 113.779 49.8677 113.737L57.7576 109.163C57.8303 109.121 57.875 109.043 57.875 108.959V97.926C57.875 97.842 57.8303 97.7644 57.7576 97.7223L54.164 95.6389C54.0074 95.5482 54.0074 95.3222 54.164 95.2314L57.7576 93.1481C57.8303 93.106 57.875 93.0284 57.875 92.9444V88.5055C57.875 88.4215 57.8303 88.3439 57.7576 88.3017L49.8677 83.7279C49.7946 83.6855 49.7045 83.6855 49.6315 83.7279L33.6161 93.0121C33.5435 93.0543 33.4987 93.1319 33.4987 93.2159V104.249Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_258_570)"
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6251 88.3688L49.7506 83.6584L57.876 88.3688L49.7506 93.0792L57.876 97.7896L57.876 109.094L49.7506 113.804L33.4997 104.384V93.0792L41.6251 88.3688Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.75 102.5L41.6246 97.7896L33.4992 93.0792L33.4992 104.384L41.6246 109.094L49.75 113.804L49.75 102.5Z",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.75 102.5L49.75 113.804L57.8754 109.094L57.8754 97.7896L49.75 102.5Z",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.75 102.5L57.8754 97.7896L49.75 93.0792L57.8754 88.3688L49.75 83.6584L41.6246 88.3688L33.4992 93.0792L41.6246 97.7896L49.75 102.5Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5 104.384L49.75 113.804",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M49.808 113.771L57.875 109.094",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5 93.0797L33.5 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M57.875 97.7898L57.875 109.094",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M49.75 102.5V113.804",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 93.0797L49.75 102.5",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M49.808 102.466L57.875 97.7898",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.75 102.5V113.804",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 93.0797L49.75 102.5",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.808 102.466L57.875 97.7898",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 84,
    width: 8,
    height: 7
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 89.1308C53.1416 88.8865 53.2287 88.6262 53.2287 88.3659V86.4819C53.2287 86.2216 53.1416 85.9613 52.9672 85.717C52.799 85.4813 52.5496 85.2605 52.2192 85.0689C51.8887 84.8774 51.5078 84.7328 51.1013 84.6353C50.6798 84.5342 50.2308 84.4837 49.7819 84.4837C49.3329 84.4837 48.8839 84.5342 48.4624 84.6353C48.0559 84.7328 47.675 84.8774 47.3445 85.0689C47.0141 85.2605 46.7647 85.4813 46.5965 85.717C46.4221 85.9613 46.335 86.2216 46.335 86.4819V88.3659C46.335 88.6262 46.4221 88.8865 46.5965 89.1308C46.7647 89.3665 47.0141 89.5873 47.3445 89.7789C47.675 89.9704 48.0559 90.115 48.4624 90.2125C48.8839 90.3136 49.3329 90.3641 49.7819 90.3641C50.2308 90.3641 50.6798 90.3136 51.1013 90.2125C51.5078 90.115 51.8887 89.9704 52.2192 89.7789C52.5496 89.5873 52.799 89.3665 52.9672 89.1308Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_258_570)"
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 89.1308C53.1416 88.8865 53.2287 88.6262 53.2287 88.3659V86.4819C53.2287 86.2216 53.1416 85.9613 52.9672 85.717C52.799 85.4813 52.5496 85.2605 52.2192 85.0689C51.8887 84.8774 51.5078 84.7328 51.1013 84.6353C50.6798 84.5342 50.2308 84.4837 49.7819 84.4837C49.3329 84.4837 48.8839 84.5342 48.4624 84.6353C48.0559 84.7328 47.675 84.8774 47.3445 85.0689C47.0141 85.2605 46.7647 85.4813 46.5965 85.717C46.4221 85.9613 46.335 86.2216 46.335 86.4819V88.3659C46.335 88.6262 46.4221 88.8865 46.5965 89.1308C46.7647 89.3665 47.0141 89.5873 47.3445 89.7789C47.675 89.9704 48.0559 90.115 48.4624 90.2125C48.8839 90.3136 49.3329 90.3641 49.7819 90.3641C50.2308 90.3641 50.6798 90.3136 51.1013 90.2125C51.5078 90.115 51.8887 89.9704 52.2192 89.7789C52.5496 89.5873 52.799 89.3665 52.9672 89.1308Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 89.1344C53.1416 88.8901 53.2287 88.6298 53.2287 88.3695V86.4855C53.2287 86.7458 53.1416 87.0061 52.9672 87.2504C52.799 87.486 52.5496 87.7068 52.2192 87.8984C51.8887 88.09 51.5078 88.2346 51.1013 88.3321C50.6798 88.4331 50.2308 88.4837 49.7819 88.4837C49.3329 88.4837 48.8839 88.4331 48.4624 88.3321C48.0559 88.2346 47.675 88.09 47.3445 87.8984C47.0141 87.7068 46.7647 87.486 46.5965 87.2504C46.4221 87.0061 46.335 86.7458 46.335 86.4855V88.3695C46.335 88.6298 46.4221 88.8901 46.5965 89.1344C46.7647 89.3701 47.0141 89.5909 47.3445 89.7825C47.675 89.9741 48.0559 90.1186 48.4624 90.2161C48.8839 90.3172 49.3329 90.3677 49.7819 90.3677C50.2308 90.3677 50.6798 90.3172 51.1013 90.2161C51.5078 90.1186 51.8887 89.9741 52.2192 89.7825C52.5496 89.5909 52.799 89.3701 52.9672 89.1344Z",
    fill: "url(#paint23_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5965 85.717C46.4221 85.9613 46.335 86.2216 46.335 86.4819C46.335 86.7422 46.4221 87.0024 46.5965 87.2467C46.7647 87.4824 47.0141 87.7032 47.3445 87.8948C47.675 88.0864 48.0559 88.2309 48.4624 88.3284C48.8839 88.4295 49.3329 88.4801 49.7819 88.4801C50.2308 88.4801 50.6798 88.4295 51.1013 88.3284C51.5078 88.2309 51.8887 88.0864 52.2192 87.8948C52.5496 87.7032 52.799 87.4824 52.9672 87.2467C53.1416 87.0024 53.2287 86.7422 53.2287 86.4819C53.2287 86.2216 53.1416 85.9613 52.9672 85.717C52.799 85.4813 52.5496 85.2605 52.2192 85.0689C51.8887 84.8774 51.5078 84.7328 51.1013 84.6353C50.6798 84.5342 50.2308 84.4837 49.7819 84.4837C49.3329 84.4837 48.8839 84.5342 48.4624 84.6353C48.0559 84.7328 47.675 84.8774 47.3445 85.0689C47.0141 85.2605 46.7647 85.4813 46.5965 85.717Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 85.6612C46.3481 85.9055 46.335 86.273 46.335 86.5333C46.335 86.7936 46.4221 87.0539 46.5965 87.2982C46.7647 87.5339 47.0141 87.7547 47.3445 87.9463C47.675 88.1378 48.0559 88.2824 48.4624 88.3799C48.8839 88.481 49.3329 88.5315 49.7819 88.5315C50.2308 88.5315 50.6798 88.481 51.1013 88.3799C51.5078 88.2824 51.8887 88.1378 52.2192 87.9463C52.5496 87.7547 52.799 87.5339 52.9672 87.2982C53.1416 87.0539 53.2287 86.7936 53.2287 86.5333C53.2287 86.273 53.2165 85.9166 53.0422 85.6722",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 85.6612C46.3481 85.9055 46.335 86.273 46.335 86.5333C46.335 86.7936 46.4221 87.0539 46.5965 87.2982C46.7647 87.5339 47.0141 87.7547 47.3445 87.9463C47.675 88.1378 48.0559 88.2824 48.4624 88.3799C48.8839 88.481 49.3329 88.5315 49.7819 88.5315C50.2308 88.5315 50.6798 88.481 51.1013 88.3799C51.5078 88.2824 51.8887 88.1378 52.2192 87.9463C52.5496 87.7547 52.799 87.5339 52.9672 87.2982C53.1416 87.0539 53.2287 86.7936 53.2287 86.5333C53.2287 86.273 53.2165 85.9166 53.0422 85.6722",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 89,
    width: 8,
    height: 7
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 93.841C45.0166 93.5966 45.1037 93.3364 45.1037 93.0761V91.192C45.1037 90.9317 45.0166 90.6714 44.8422 90.4271C44.674 90.1915 44.4246 89.9707 44.0942 89.7791C43.7637 89.5875 43.3828 89.4429 42.9763 89.3454C42.5548 89.2444 42.1058 89.1938 41.6569 89.1938C41.2079 89.1938 40.7589 89.2444 40.3374 89.3454C39.9309 89.4429 39.55 89.5875 39.2195 89.7791C38.8891 89.9707 38.6397 90.1915 38.4715 90.4271C38.2971 90.6714 38.21 90.9317 38.21 91.192V93.0761C38.21 93.3364 38.2971 93.5966 38.4715 93.841C38.6397 94.0766 38.8891 94.2974 39.2195 94.489C39.55 94.6806 39.9309 94.8251 40.3374 94.9227C40.7589 95.0237 41.2079 95.0743 41.6569 95.0743C42.1058 95.0743 42.5548 95.0237 42.9763 94.9227C43.3828 94.8251 43.7637 94.6806 44.0942 94.489C44.4246 94.2974 44.674 94.0766 44.8422 93.841Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_258_570)"
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 93.841C45.0166 93.5966 45.1037 93.3364 45.1037 93.0761V91.192C45.1037 90.9317 45.0166 90.6714 44.8422 90.4271C44.674 90.1915 44.4246 89.9707 44.0942 89.7791C43.7637 89.5875 43.3828 89.4429 42.9763 89.3454C42.5548 89.2444 42.1058 89.1938 41.6569 89.1938C41.2079 89.1938 40.7589 89.2444 40.3374 89.3454C39.9309 89.4429 39.55 89.5875 39.2195 89.7791C38.8891 89.9707 38.6397 90.1915 38.4715 90.4271C38.2971 90.6714 38.21 90.9317 38.21 91.192V93.0761C38.21 93.3364 38.2971 93.5966 38.4715 93.841C38.6397 94.0766 38.8891 94.2974 39.2195 94.489C39.55 94.6806 39.9309 94.8251 40.3374 94.9227C40.7589 95.0237 41.2079 95.0743 41.6569 95.0743C42.1058 95.0743 42.5548 95.0237 42.9763 94.9227C43.3828 94.8251 43.7637 94.6806 44.0942 94.489C44.4246 94.2974 44.674 94.0766 44.8422 93.841Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.8422 93.8446C45.0166 93.6003 45.1037 93.34 45.1037 93.0797V91.1956C45.1037 91.4559 45.0166 91.7162 44.8422 91.9605C44.674 92.1962 44.4246 92.417 44.0942 92.6086C43.7637 92.8001 43.3828 92.9447 42.9763 93.0422C42.5548 93.1433 42.1058 93.1938 41.6569 93.1938C41.2079 93.1938 40.7589 93.1433 40.3374 93.0422C39.9309 92.9447 39.55 92.8001 39.2195 92.6086C38.8891 92.417 38.6397 92.1962 38.4715 91.9605C38.2971 91.7162 38.21 91.4559 38.21 91.1956V93.0797C38.21 93.34 38.2971 93.6003 38.4715 93.8446C38.6397 94.0802 38.8891 94.301 39.2195 94.4926C39.55 94.6842 39.9309 94.8288 40.3374 94.9263C40.7589 95.0273 41.2079 95.0779 41.6569 95.0779C42.1058 95.0779 42.5548 95.0273 42.9763 94.9263C43.3828 94.8288 43.7637 94.6842 44.0942 94.4926C44.4246 94.301 44.674 94.0802 44.8422 93.8446Z",
    fill: "url(#paint24_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4715 90.4271C38.2971 90.6714 38.21 90.9317 38.21 91.192C38.21 91.4523 38.2971 91.7126 38.4715 91.9569C38.6397 92.1926 38.8891 92.4134 39.2195 92.605C39.55 92.7965 39.9309 92.9411 40.3374 93.0386C40.7589 93.1397 41.2079 93.1902 41.6569 93.1902C42.1058 93.1902 42.5548 93.1397 42.9763 93.0386C43.3828 92.9411 43.7637 92.7965 44.0942 92.605C44.4246 92.4134 44.674 92.1926 44.8422 91.9569C45.0166 91.7126 45.1037 91.4523 45.1037 91.192C45.1037 90.9317 45.0166 90.6714 44.8422 90.4271C44.674 90.1915 44.4246 89.9707 44.0942 89.7791C43.7637 89.5875 43.3828 89.4429 42.9763 89.3454C42.5548 89.2444 42.1058 89.1938 41.6569 89.1938C41.2079 89.1938 40.7589 89.2444 40.3374 89.3454C39.9309 89.4429 39.55 89.5875 39.2195 89.7791C38.8891 89.9707 38.6397 90.1915 38.4715 90.4271Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3975 90.3714C38.2231 90.6157 38.21 90.9832 38.21 91.2435C38.21 91.5038 38.2971 91.764 38.4715 92.0083C38.6397 92.244 38.8891 92.4648 39.2195 92.6564C39.55 92.848 39.9309 92.9925 40.3374 93.09C40.7589 93.1911 41.2079 93.2417 41.6569 93.2417C42.1058 93.2417 42.5548 93.1911 42.9763 93.09C43.3828 92.9925 43.7637 92.848 44.0942 92.6564C44.4246 92.4648 44.674 92.244 44.8422 92.0083C45.0166 91.764 45.1037 91.5038 45.1037 91.2435C45.1037 90.9832 45.0915 90.6267 44.9172 90.3824",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.3975 90.3714C38.2231 90.6157 38.21 90.9832 38.21 91.2435C38.21 91.5038 38.2971 91.764 38.4715 92.0083C38.6397 92.244 38.8891 92.4648 39.2195 92.6564C39.55 92.848 39.9309 92.9925 40.3374 93.09C40.7589 93.1911 41.2079 93.2417 41.6569 93.2417C42.1058 93.2417 42.5548 93.1911 42.9763 93.09C43.3828 92.9925 43.7637 92.848 44.0942 92.6564C44.4246 92.4648 44.674 92.244 44.8422 92.0083C45.0166 91.764 45.1037 91.5038 45.1037 91.2435C45.1037 90.9832 45.0915 90.6267 44.9172 90.3824",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 93,
    width: 8,
    height: 7
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 98.5511C53.1416 98.3068 53.2287 98.0465 53.2287 97.7862V95.9022C53.2287 95.6419 53.1416 95.3816 52.9672 95.1373C52.799 94.9016 52.5496 94.6808 52.2192 94.4892C51.8887 94.2976 51.5078 94.1531 51.1013 94.0556C50.6798 93.9545 50.2308 93.904 49.7819 93.904C49.3329 93.904 48.8839 93.9545 48.4624 94.0556C48.0559 94.1531 47.675 94.2976 47.3445 94.4892C47.0141 94.6808 46.7647 94.9016 46.5965 95.1373C46.4221 95.3816 46.335 95.6419 46.335 95.9022V97.7862C46.335 98.0465 46.4221 98.3068 46.5965 98.5511C46.7647 98.7868 47.0141 99.0076 47.3445 99.1992C47.675 99.3907 48.0559 99.5353 48.4624 99.6328C48.8839 99.7339 49.3329 99.7844 49.7819 99.7844C50.2308 99.7844 50.6798 99.7339 51.1013 99.6328C51.5078 99.5353 51.8887 99.3907 52.2192 99.1992C52.5496 99.0076 52.799 98.7868 52.9672 98.5511Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_258_570)"
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 98.5511C53.1416 98.3068 53.2287 98.0465 53.2287 97.7862V95.9022C53.2287 95.6419 53.1416 95.3816 52.9672 95.1373C52.799 94.9016 52.5496 94.6808 52.2192 94.4892C51.8887 94.2976 51.5078 94.1531 51.1013 94.0556C50.6798 93.9545 50.2308 93.904 49.7819 93.904C49.3329 93.904 48.8839 93.9545 48.4624 94.0556C48.0559 94.1531 47.675 94.2976 47.3445 94.4892C47.0141 94.6808 46.7647 94.9016 46.5965 95.1373C46.4221 95.3816 46.335 95.6419 46.335 95.9022V97.7862C46.335 98.0465 46.4221 98.3068 46.5965 98.5511C46.7647 98.7868 47.0141 99.0076 47.3445 99.1992C47.675 99.3907 48.0559 99.5353 48.4624 99.6328C48.8839 99.7339 49.3329 99.7844 49.7819 99.7844C50.2308 99.7844 50.6798 99.7339 51.1013 99.6328C51.5078 99.5353 51.8887 99.3907 52.2192 99.1992C52.5496 99.0076 52.799 98.7868 52.9672 98.5511Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52.9672 98.5547C53.1416 98.3104 53.2287 98.0501 53.2287 97.7898V95.9058C53.2287 96.1661 53.1416 96.4263 52.9672 96.6707C52.799 96.9063 52.5496 97.1271 52.2192 97.3187C51.8887 97.5103 51.5078 97.6548 51.1013 97.7524C50.6798 97.8534 50.2308 97.904 49.7819 97.904C49.3329 97.904 48.8839 97.8534 48.4624 97.7524C48.0559 97.6548 47.675 97.5103 47.3445 97.3187C47.0141 97.1271 46.7647 96.9063 46.5965 96.6707C46.4221 96.4263 46.335 96.1661 46.335 95.9058V97.7898C46.335 98.0501 46.4221 98.3104 46.5965 98.5547C46.7647 98.7904 47.0141 99.0112 47.3445 99.2028C47.675 99.3944 48.0559 99.5389 48.4624 99.6364C48.8839 99.7375 49.3329 99.788 49.7819 99.788C50.2308 99.788 50.6798 99.7375 51.1013 99.6364C51.5078 99.5389 51.8887 99.3944 52.2192 99.2028C52.5496 99.0112 52.799 98.7904 52.9672 98.5547Z",
    fill: "url(#paint25_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5965 95.1373C46.4221 95.3816 46.335 95.6419 46.335 95.9022C46.335 96.1624 46.4221 96.4227 46.5965 96.667C46.7647 96.9027 47.0141 97.1235 47.3445 97.3151C47.675 97.5067 48.0559 97.6512 48.4624 97.7487C48.8839 97.8498 49.3329 97.9004 49.7819 97.9004C50.2308 97.9004 50.6798 97.8498 51.1013 97.7487C51.5078 97.6512 51.8887 97.5067 52.2192 97.3151C52.5496 97.1235 52.799 96.9027 52.9672 96.667C53.1416 96.4227 53.2287 96.1624 53.2287 95.9022C53.2287 95.6419 53.1416 95.3816 52.9672 95.1373C52.799 94.9016 52.5496 94.6808 52.2192 94.4892C51.8887 94.2976 51.5078 94.1531 51.1013 94.0556C50.6798 93.9545 50.2308 93.904 49.7819 93.904C49.3329 93.904 48.8839 93.9545 48.4624 94.0556C48.0559 94.1531 47.675 94.2976 47.3445 94.4892C47.0141 94.6808 46.7647 94.9016 46.5965 95.1373Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 95.0815C46.3481 95.3258 46.335 95.6933 46.335 95.9536C46.335 96.2139 46.4221 96.4742 46.5965 96.7185C46.7647 96.9542 47.0141 97.175 47.3445 97.3666C47.675 97.5581 48.0559 97.7027 48.4624 97.8002C48.8839 97.9013 49.3329 97.9518 49.7819 97.9518C50.2308 97.9518 50.6798 97.9013 51.1013 97.8002C51.5078 97.7027 51.8887 97.5581 52.2192 97.3666C52.5496 97.175 52.799 96.9542 52.9672 96.7185C53.1416 96.4742 53.2287 96.2139 53.2287 95.9536C53.2287 95.6933 53.2165 95.3368 53.0422 95.0925",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 95.0815C46.3481 95.3258 46.335 95.6933 46.335 95.9536C46.335 96.2139 46.4221 96.4742 46.5965 96.7185C46.7647 96.9542 47.0141 97.175 47.3445 97.3666C47.675 97.5581 48.0559 97.7027 48.4624 97.8002C48.8839 97.9013 49.3329 97.9518 49.7819 97.9518C50.2308 97.9518 50.6798 97.9013 51.1013 97.8002C51.5078 97.7027 51.8887 97.5581 52.2192 97.3666C52.5496 97.175 52.799 96.9542 52.9672 96.7185C53.1416 96.4742 53.2287 96.2139 53.2287 95.9536C53.2287 95.6933 53.2165 95.3368 53.0422 95.0925",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 53,
    width: 33,
    height: 31
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M1 74.1039C1 74.1879 1.04473 74.2655 1.11739 74.3077L17.1327 83.5919C17.2058 83.6343 17.2959 83.6343 17.369 83.5919L33.3843 74.3077C33.4569 74.2655 33.5017 74.1879 33.5017 74.1039V63.071C33.5017 62.987 33.4569 62.9093 33.3843 62.8672L17.369 53.583C17.2959 53.5406 17.2058 53.5406 17.1327 53.583L1.11739 62.8672C1.04473 62.9093 1 62.987 1 63.071V74.1039Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_258_570)"
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2499 53.5135L0.999024 62.9343L0.999023 74.2386L17.2499 83.6594L33.5007 74.2386V62.9343L17.2499 53.5135Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 11.3043,
    transform: "matrix(0.86514 -0.501531 2.19408e-08 1 17.25 72.3551)",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 11.3043,
    transform: "matrix(-0.86514 -0.501531 -2.19408e-08 1 17.25 72.3551)",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 18.7841,
    transform: "matrix(-0.86514 -0.50153 0.86514 -0.501531 17.25 72.3551)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5 74.2391L17.25 83.6594",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M17.25 83.6594L1 74.2391",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5 62.9348L33.5 74.2391",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1 62.9348L1 74.2391",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 72.3551V83.6594",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 62.9348L17.25 72.3551",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 72.3551L1 62.9348",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 72.3551V83.6594",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 62.9348L17.25 72.3551",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 72.3551L1 62.9348",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 54,
    width: 8,
    height: 7
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 58.9859C20.6416 58.7416 20.7287 58.4813 20.7287 58.221V56.337C20.7287 56.0767 20.6416 55.8164 20.4672 55.5721C20.299 55.3364 20.0496 55.1156 19.7192 54.924C19.3887 54.7324 19.0078 54.5879 18.6013 54.4904C18.1798 54.3893 17.7308 54.3388 17.2819 54.3388C16.8329 54.3388 16.3839 54.3893 15.9624 54.4904C15.5559 54.5879 15.175 54.7324 14.8445 54.924C14.5141 55.1156 14.2647 55.3364 14.0965 55.5721C13.9221 55.8164 13.835 56.0767 13.835 56.337V58.221C13.835 58.4813 13.9221 58.7416 14.0965 58.9859C14.2647 59.2216 14.5141 59.4424 14.8445 59.6339C15.175 59.8255 15.5559 59.9701 15.9624 60.0676C16.3839 60.1687 16.8329 60.2192 17.2819 60.2192C17.7308 60.2192 18.1798 60.1687 18.6013 60.0676C19.0078 59.9701 19.3887 59.8255 19.7192 59.6339C20.0496 59.4424 20.299 59.2216 20.4672 58.9859Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_258_570)"
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 58.9859C20.6416 58.7416 20.7287 58.4813 20.7287 58.221V56.337C20.7287 56.0767 20.6416 55.8164 20.4672 55.5721C20.299 55.3364 20.0496 55.1156 19.7192 54.924C19.3887 54.7324 19.0078 54.5879 18.6013 54.4904C18.1798 54.3893 17.7308 54.3388 17.2819 54.3388C16.8329 54.3388 16.3839 54.3893 15.9624 54.4904C15.5559 54.5879 15.175 54.7324 14.8445 54.924C14.5141 55.1156 14.2647 55.3364 14.0965 55.5721C13.9221 55.8164 13.835 56.0767 13.835 56.337V58.221C13.835 58.4813 13.9221 58.7416 14.0965 58.9859C14.2647 59.2216 14.5141 59.4424 14.8445 59.6339C15.175 59.8255 15.5559 59.9701 15.9624 60.0676C16.3839 60.1687 16.8329 60.2192 17.2819 60.2192C17.7308 60.2192 18.1798 60.1687 18.6013 60.0676C19.0078 59.9701 19.3887 59.8255 19.7192 59.6339C20.0496 59.4424 20.299 59.2216 20.4672 58.9859Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 58.9895C20.6416 58.7452 20.7287 58.4849 20.7287 58.2246V56.3406C20.7287 56.6008 20.6416 56.8611 20.4672 57.1054C20.299 57.3411 20.0496 57.5619 19.7192 57.7535C19.3887 57.9451 19.0078 58.0896 18.6013 58.1871C18.1798 58.2882 17.7308 58.3388 17.2819 58.3388C16.8329 58.3388 16.3839 58.2882 15.9624 58.1871C15.5559 58.0896 15.175 57.9451 14.8445 57.7535C14.5141 57.5619 14.2647 57.3411 14.0965 57.1054C13.9221 56.8611 13.835 56.6008 13.835 56.3406V58.2246C13.835 58.4849 13.9221 58.7452 14.0965 58.9895C14.2647 59.2252 14.5141 59.446 14.8445 59.6376C15.175 59.8291 15.5559 59.9737 15.9624 60.0712C16.3839 60.1723 16.8329 60.2228 17.2819 60.2228C17.7308 60.2228 18.1798 60.1723 18.6013 60.0712C19.0078 59.9737 19.3887 59.8291 19.7192 59.6376C20.0496 59.446 20.299 59.2252 20.4672 58.9895Z",
    fill: "url(#paint26_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0965 55.5721C13.9221 55.8164 13.835 56.0767 13.835 56.337C13.835 56.5972 13.9221 56.8575 14.0965 57.1018C14.2647 57.3375 14.5141 57.5583 14.8445 57.7499C15.175 57.9415 15.5559 58.086 15.9624 58.1835C16.3839 58.2846 16.8329 58.3351 17.2819 58.3351C17.7308 58.3351 18.1798 58.2846 18.6013 58.1835C19.0078 58.086 19.3887 57.9415 19.7192 57.7499C20.0496 57.5583 20.299 57.3375 20.4672 57.1018C20.6416 56.8575 20.7287 56.5972 20.7287 56.337C20.7287 56.0767 20.6416 55.8164 20.4672 55.5721C20.299 55.3364 20.0496 55.1156 19.7192 54.924C19.3887 54.7324 19.0078 54.5879 18.6013 54.4904C18.1798 54.3893 17.7308 54.3388 17.2819 54.3388C16.8329 54.3388 16.3839 54.3893 15.9624 54.4904C15.5559 54.5879 15.175 54.7324 14.8445 54.924C14.5141 55.1156 14.2647 55.3364 14.0965 55.5721Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0225 55.5163C13.8481 55.7606 13.835 56.1281 13.835 56.3884C13.835 56.6487 13.9221 56.909 14.0965 57.1533C14.2647 57.389 14.5141 57.6098 14.8445 57.8013C15.175 57.9929 15.5559 58.1375 15.9624 58.235C16.3839 58.3361 16.8329 58.3866 17.2819 58.3866C17.7308 58.3866 18.1798 58.3361 18.6013 58.235C19.0078 58.1375 19.3887 57.9929 19.7192 57.8013C20.0496 57.6098 20.299 57.389 20.4672 57.1533C20.6416 56.909 20.7287 56.6487 20.7287 56.3884C20.7287 56.1281 20.7165 55.7716 20.5422 55.5273",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.0225 55.5163C13.8481 55.7606 13.835 56.1281 13.835 56.3884C13.835 56.6487 13.9221 56.909 14.0965 57.1533C14.2647 57.389 14.5141 57.6098 14.8445 57.8013C15.175 57.9929 15.5559 58.1375 15.9624 58.235C16.3839 58.3361 16.8329 58.3866 17.2819 58.3866C17.7308 58.3866 18.1798 58.3361 18.6013 58.235C19.0078 58.1375 19.3887 57.9929 19.7192 57.8013C20.0496 57.6098 20.299 57.389 20.4672 57.1533C20.6416 56.909 20.7287 56.6487 20.7287 56.3884C20.7287 56.1281 20.7165 55.7716 20.5422 55.5273",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 59,
    width: 8,
    height: 6
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3422 63.696C12.5166 63.4517 12.6037 63.1914 12.6037 62.9312V61.0471C12.6037 60.7868 12.5166 60.5265 12.3422 60.2822C12.174 60.0465 11.9246 59.8257 11.5942 59.6342C11.2637 59.4426 10.8828 59.298 10.4763 59.2005C10.0548 59.0994 9.60585 59.0489 9.15685 59.0489C8.70786 59.0489 8.25886 59.0994 7.83744 59.2005C7.43089 59.298 7.05001 59.4426 6.71953 59.6342C6.38906 59.8257 6.13971 60.0465 5.97151 60.2822C5.79714 60.5265 5.70996 60.7868 5.70996 61.0471V62.9312C5.70996 63.1914 5.79714 63.4517 5.97151 63.696C6.13971 63.9317 6.38906 64.1525 6.71953 64.3441C7.05001 64.5357 7.43089 64.6802 7.83744 64.7777C8.25886 64.8788 8.70786 64.9294 9.15685 64.9294C9.60585 64.9294 10.0548 64.8788 10.4763 64.7777C10.8828 64.6802 11.2637 64.5357 11.5942 64.3441C11.9246 64.1525 12.174 63.9317 12.3422 63.696Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_258_570)"
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3422 63.696C12.5166 63.4517 12.6037 63.1914 12.6037 62.9312V61.0471C12.6037 60.7868 12.5166 60.5265 12.3422 60.2822C12.174 60.0465 11.9246 59.8257 11.5942 59.6342C11.2637 59.4426 10.8828 59.298 10.4763 59.2005C10.0548 59.0994 9.60585 59.0489 9.15685 59.0489C8.70786 59.0489 8.25886 59.0994 7.83744 59.2005C7.43089 59.298 7.05001 59.4426 6.71953 59.6342C6.38906 59.8257 6.13971 60.0465 5.97151 60.2822C5.79714 60.5265 5.70996 60.7868 5.70996 61.0471V62.9312C5.70996 63.1914 5.79714 63.4517 5.97151 63.696C6.13971 63.9317 6.38906 64.1525 6.71953 64.3441C7.05001 64.5357 7.43089 64.6802 7.83744 64.7777C8.25886 64.8788 8.70786 64.9294 9.15685 64.9294C9.60585 64.9294 10.0548 64.8788 10.4763 64.7777C10.8828 64.6802 11.2637 64.5357 11.5942 64.3441C11.9246 64.1525 12.174 63.9317 12.3422 63.696Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.3422 63.6996C12.5166 63.4553 12.6037 63.195 12.6037 62.9348V61.0507C12.6037 61.311 12.5166 61.5713 12.3422 61.8156C12.174 62.0513 11.9246 62.2721 11.5942 62.4636C11.2637 62.6552 10.8828 62.7998 10.4763 62.8973C10.0548 62.9984 9.60585 63.0489 9.15685 63.0489C8.70786 63.0489 8.25886 62.9984 7.83744 62.8973C7.43089 62.7998 7.05001 62.6552 6.71953 62.4636C6.38906 62.2721 6.13971 62.0513 5.97151 61.8156C5.79714 61.5713 5.70996 61.311 5.70996 61.0507V62.9348C5.70996 63.195 5.79714 63.4553 5.97151 63.6996C6.13971 63.9353 6.38906 64.1561 6.71953 64.3477C7.05001 64.5393 7.43089 64.6838 7.83744 64.7813C8.25886 64.8824 8.70786 64.933 9.15685 64.933C9.60585 64.933 10.0548 64.8824 10.4763 64.7813C10.8828 64.6838 11.2637 64.5393 11.5942 64.3477C11.9246 64.1561 12.174 63.9353 12.3422 63.6996Z",
    fill: "url(#paint27_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97151 60.2822C5.79714 60.5265 5.70996 60.7868 5.70996 61.0471C5.70996 61.3074 5.79714 61.5677 5.97151 61.812C6.13971 62.0477 6.38906 62.2685 6.71953 62.46C7.05001 62.6516 7.43089 62.7962 7.83744 62.8937C8.25886 62.9948 8.70786 63.0453 9.15685 63.0453C9.60585 63.0453 10.0548 62.9948 10.4763 62.8937C10.8828 62.7962 11.2637 62.6516 11.5942 62.46C11.9246 62.2685 12.174 62.0477 12.3422 61.812C12.5166 61.5677 12.6037 61.3074 12.6037 61.0471C12.6037 60.7868 12.5166 60.5265 12.3422 60.2822C12.174 60.0465 11.9246 59.8257 11.5942 59.6342C11.2637 59.4426 10.8828 59.298 10.4763 59.2005C10.0548 59.0994 9.60585 59.0489 9.15685 59.0489C8.70786 59.0489 8.25886 59.0994 7.83744 59.2005C7.43089 59.298 7.05001 59.4426 6.71953 59.6342C6.38906 59.8257 6.13971 60.0465 5.97151 60.2822Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89747 60.2264C5.72311 60.4707 5.70996 60.8383 5.70996 61.0985C5.70996 61.3588 5.79714 61.6191 5.97151 61.8634C6.13971 62.0991 6.38906 62.3199 6.71953 62.5115C7.05001 62.7031 7.43089 62.8476 7.83744 62.9451C8.25886 63.0462 8.70786 63.0967 9.15685 63.0967C9.60585 63.0967 10.0548 63.0462 10.4763 62.9451C10.8828 62.8476 11.2637 62.7031 11.5942 62.5115C11.9246 62.3199 12.174 62.0991 12.3422 61.8634C12.5166 61.6191 12.6037 61.3588 12.6037 61.0985C12.6037 60.8383 12.5915 60.4818 12.4172 60.2375",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.89747 60.2264C5.72311 60.4707 5.70996 60.8383 5.70996 61.0985C5.70996 61.3588 5.79714 61.6191 5.97151 61.8634C6.13971 62.0991 6.38906 62.3199 6.71953 62.5115C7.05001 62.7031 7.43089 62.8476 7.83744 62.9451C8.25886 63.0462 8.70786 63.0967 9.15685 63.0967C9.60585 63.0967 10.0548 63.0462 10.4763 62.9451C10.8828 62.8476 11.2637 62.7031 11.5942 62.5115C11.9246 62.3199 12.174 62.0991 12.3422 61.8634C12.5166 61.6191 12.6037 61.3588 12.6037 61.0985C12.6037 60.8383 12.5915 60.4818 12.4172 60.2375",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 59,
    width: 8,
    height: 6
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5922 63.696C28.7666 63.4517 28.8537 63.1914 28.8537 62.9312V61.0471C28.8537 60.7868 28.7666 60.5265 28.5922 60.2822C28.424 60.0465 28.1746 59.8257 27.8442 59.6342C27.5137 59.4426 27.1328 59.298 26.7263 59.2005C26.3048 59.0994 25.8558 59.0489 25.4069 59.0489C24.9579 59.0489 24.5089 59.0994 24.0874 59.2005C23.6809 59.298 23.3 59.4426 22.9695 59.6342C22.6391 59.8257 22.3897 60.0465 22.2215 60.2822C22.0471 60.5265 21.96 60.7868 21.96 61.0471V62.9312C21.96 63.1914 22.0471 63.4517 22.2215 63.696C22.3897 63.9317 22.6391 64.1525 22.9695 64.3441C23.3 64.5357 23.6809 64.6802 24.0874 64.7777C24.5089 64.8788 24.9579 64.9294 25.4069 64.9294C25.8558 64.9294 26.3048 64.8788 26.7263 64.7777C27.1328 64.6802 27.5137 64.5357 27.8442 64.3441C28.1746 64.1525 28.424 63.9317 28.5922 63.696Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_258_570)"
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5922 63.696C28.7666 63.4517 28.8537 63.1914 28.8537 62.9312V61.0471C28.8537 60.7868 28.7666 60.5265 28.5922 60.2822C28.424 60.0465 28.1746 59.8257 27.8442 59.6342C27.5137 59.4426 27.1328 59.298 26.7263 59.2005C26.3048 59.0994 25.8558 59.0489 25.4069 59.0489C24.9579 59.0489 24.5089 59.0994 24.0874 59.2005C23.6809 59.298 23.3 59.4426 22.9695 59.6342C22.6391 59.8257 22.3897 60.0465 22.2215 60.2822C22.0471 60.5265 21.96 60.7868 21.96 61.0471V62.9312C21.96 63.1914 22.0471 63.4517 22.2215 63.696C22.3897 63.9317 22.6391 64.1525 22.9695 64.3441C23.3 64.5357 23.6809 64.6802 24.0874 64.7777C24.5089 64.8788 24.9579 64.9294 25.4069 64.9294C25.8558 64.9294 26.3048 64.8788 26.7263 64.7777C27.1328 64.6802 27.5137 64.5357 27.8442 64.3441C28.1746 64.1525 28.424 63.9317 28.5922 63.696Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.5922 63.6996C28.7666 63.4553 28.8537 63.195 28.8537 62.9348V61.0507C28.8537 61.311 28.7666 61.5713 28.5922 61.8156C28.424 62.0513 28.1746 62.2721 27.8442 62.4636C27.5137 62.6552 27.1328 62.7998 26.7263 62.8973C26.3048 62.9984 25.8558 63.0489 25.4069 63.0489C24.9579 63.0489 24.5089 62.9984 24.0874 62.8973C23.6809 62.7998 23.3 62.6552 22.9695 62.4636C22.6391 62.2721 22.3897 62.0513 22.2215 61.8156C22.0471 61.5713 21.96 61.311 21.96 61.0507V62.9348C21.96 63.195 22.0471 63.4553 22.2215 63.6996C22.3897 63.9353 22.6391 64.1561 22.9695 64.3477C23.3 64.5393 23.6809 64.6838 24.0874 64.7813C24.5089 64.8824 24.9579 64.933 25.4069 64.933C25.8558 64.933 26.3048 64.8824 26.7263 64.7813C27.1328 64.6838 27.5137 64.5393 27.8442 64.3477C28.1746 64.1561 28.424 63.9353 28.5922 63.6996Z",
    fill: "url(#paint28_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2215 60.2822C22.0471 60.5265 21.96 60.7868 21.96 61.0471C21.96 61.3074 22.0471 61.5677 22.2215 61.812C22.3897 62.0477 22.6391 62.2685 22.9695 62.46C23.3 62.6516 23.6809 62.7962 24.0874 62.8937C24.5089 62.9948 24.9579 63.0453 25.4069 63.0453C25.8558 63.0453 26.3048 62.9948 26.7263 62.8937C27.1328 62.7962 27.5137 62.6516 27.8442 62.46C28.1746 62.2685 28.424 62.0477 28.5922 61.812C28.7666 61.5677 28.8537 61.3074 28.8537 61.0471C28.8537 60.7868 28.7666 60.5265 28.5922 60.2822C28.424 60.0465 28.1746 59.8257 27.8442 59.6342C27.5137 59.4426 27.1328 59.298 26.7263 59.2005C26.3048 59.0994 25.8558 59.0489 25.4069 59.0489C24.9579 59.0489 24.5089 59.0994 24.0874 59.2005C23.6809 59.298 23.3 59.4426 22.9695 59.6342C22.6391 59.8257 22.3897 60.0465 22.2215 60.2822Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1475 60.2264C21.9731 60.4707 21.96 60.8383 21.96 61.0985C21.96 61.3588 22.0471 61.6191 22.2215 61.8634C22.3897 62.0991 22.6391 62.3199 22.9695 62.5115C23.3 62.7031 23.6809 62.8476 24.0874 62.9451C24.5089 63.0462 24.9579 63.0967 25.4069 63.0967C25.8558 63.0967 26.3048 63.0462 26.7263 62.9451C27.1328 62.8476 27.5137 62.7031 27.8442 62.5115C28.1746 62.3199 28.424 62.0991 28.5922 61.8634C28.7666 61.6191 28.8537 61.3588 28.8537 61.0985C28.8537 60.8383 28.8415 60.4818 28.6672 60.2375",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1475 60.2264C21.9731 60.4707 21.96 60.8383 21.96 61.0985C21.96 61.3588 22.0471 61.6191 22.2215 61.8634C22.3897 62.0991 22.6391 62.3199 22.9695 62.5115C23.3 62.7031 23.6809 62.8476 24.0874 62.9451C24.5089 63.0462 24.9579 63.0967 25.4069 63.0967C25.8558 63.0967 26.3048 63.0462 26.7263 62.9451C27.1328 62.8476 27.5137 62.7031 27.8442 62.5115C28.1746 62.3199 28.424 62.0991 28.5922 61.8634C28.7666 61.6191 28.8537 61.3588 28.8537 61.0985C28.8537 60.8383 28.8415 60.4818 28.6672 60.2375",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 63,
    width: 8,
    height: 7
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 68.4062C20.6416 68.1619 20.7287 67.9016 20.7287 67.6413V65.7572C20.7287 65.497 20.6416 65.2367 20.4672 64.9924C20.299 64.7567 20.0496 64.5359 19.7192 64.3443C19.3887 64.1527 19.0078 64.0082 18.6013 63.9107C18.1798 63.8096 17.7308 63.759 17.2819 63.759C16.8329 63.759 16.3839 63.8096 15.9624 63.9107C15.5559 64.0082 15.175 64.1527 14.8445 64.3443C14.5141 64.5359 14.2647 64.7567 14.0965 64.9924C13.9221 65.2367 13.835 65.497 13.835 65.7572V67.6413C13.835 67.9016 13.9221 68.1619 14.0965 68.4062C14.2647 68.6419 14.5141 68.8627 14.8445 69.0542C15.175 69.2458 15.5559 69.3904 15.9624 69.4879C16.3839 69.589 16.8329 69.6395 17.2819 69.6395C17.7308 69.6395 18.1798 69.589 18.6013 69.4879C19.0078 69.3904 19.3887 69.2458 19.7192 69.0542C20.0496 68.8627 20.299 68.6419 20.4672 68.4062Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_258_570)"
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 68.4062C20.6416 68.1619 20.7287 67.9016 20.7287 67.6413V65.7572C20.7287 65.497 20.6416 65.2367 20.4672 64.9924C20.299 64.7567 20.0496 64.5359 19.7192 64.3443C19.3887 64.1527 19.0078 64.0082 18.6013 63.9107C18.1798 63.8096 17.7308 63.759 17.2819 63.759C16.8329 63.759 16.3839 63.8096 15.9624 63.9107C15.5559 64.0082 15.175 64.1527 14.8445 64.3443C14.5141 64.5359 14.2647 64.7567 14.0965 64.9924C13.9221 65.2367 13.835 65.497 13.835 65.7572V67.6413C13.835 67.9016 13.9221 68.1619 14.0965 68.4062C14.2647 68.6419 14.5141 68.8627 14.8445 69.0542C15.175 69.2458 15.5559 69.3904 15.9624 69.4879C16.3839 69.589 16.8329 69.6395 17.2819 69.6395C17.7308 69.6395 18.1798 69.589 18.6013 69.4879C19.0078 69.3904 19.3887 69.2458 19.7192 69.0542C20.0496 68.8627 20.299 68.6419 20.4672 68.4062Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 68.4098C20.6416 68.1655 20.7287 67.9052 20.7287 67.6449V65.7609C20.7287 66.0211 20.6416 66.2814 20.4672 66.5257C20.299 66.7614 20.0496 66.9822 19.7192 67.1738C19.3887 67.3654 19.0078 67.5099 18.6013 67.6074C18.1798 67.7085 17.7308 67.7591 17.2819 67.7591C16.8329 67.7591 16.3839 67.7085 15.9624 67.6074C15.5559 67.5099 15.175 67.3654 14.8445 67.1738C14.5141 66.9822 14.2647 66.7614 14.0965 66.5257C13.9221 66.2814 13.835 66.0211 13.835 65.7609V67.6449C13.835 67.9052 13.9221 68.1655 14.0965 68.4098C14.2647 68.6455 14.5141 68.8663 14.8445 69.0579C15.175 69.2494 15.5559 69.394 15.9624 69.4915C16.3839 69.5926 16.8329 69.6431 17.2819 69.6431C17.7308 69.6431 18.1798 69.5926 18.6013 69.4915C19.0078 69.394 19.3887 69.2494 19.7192 69.0579C20.0496 68.8663 20.299 68.6455 20.4672 68.4098Z",
    fill: "url(#paint29_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0965 64.9924C13.9221 65.2367 13.835 65.497 13.835 65.7572C13.835 66.0175 13.9221 66.2778 14.0965 66.5221C14.2647 66.7578 14.5141 66.9786 14.8445 67.1702C15.175 67.3618 15.5559 67.5063 15.9624 67.6038C16.3839 67.7049 16.8329 67.7554 17.2819 67.7554C17.7308 67.7554 18.1798 67.7049 18.6013 67.6038C19.0078 67.5063 19.3887 67.3618 19.7192 67.1702C20.0496 66.9786 20.299 66.7578 20.4672 66.5221C20.6416 66.2778 20.7287 66.0175 20.7287 65.7572C20.7287 65.497 20.6416 65.2367 20.4672 64.9924C20.299 64.7567 20.0496 64.5359 19.7192 64.3443C19.3887 64.1527 19.0078 64.0082 18.6013 63.9107C18.1798 63.8096 17.7308 63.759 17.2819 63.759C16.8329 63.759 16.3839 63.8096 15.9624 63.9107C15.5559 64.0082 15.175 64.1527 14.8445 64.3443C14.5141 64.5359 14.2647 64.7567 14.0965 64.9924Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0225 64.9366C13.8481 65.1809 13.835 65.5484 13.835 65.8087C13.835 66.069 13.9221 66.3293 14.0965 66.5736C14.2647 66.8092 14.5141 67.03 14.8445 67.2216C15.175 67.4132 15.5559 67.5578 15.9624 67.6553C16.3839 67.7563 16.8329 67.8069 17.2819 67.8069C17.7308 67.8069 18.1798 67.7563 18.6013 67.6553C19.0078 67.5578 19.3887 67.4132 19.7192 67.2216C20.0496 67.03 20.299 66.8092 20.4672 66.5736C20.6416 66.3293 20.7287 66.069 20.7287 65.8087C20.7287 65.5484 20.7165 65.1919 20.5422 64.9476",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.0225 64.9366C13.8481 65.1809 13.835 65.5484 13.835 65.8087C13.835 66.069 13.9221 66.3293 14.0965 66.5736C14.2647 66.8092 14.5141 67.03 14.8445 67.2216C15.175 67.4132 15.5559 67.5578 15.9624 67.6553C16.3839 67.7563 16.8329 67.8069 17.2819 67.8069C17.7308 67.8069 18.1798 67.7563 18.6013 67.6553C19.0078 67.5578 19.3887 67.4132 19.7192 67.2216C20.0496 67.03 20.299 66.8092 20.4672 66.5736C20.6416 66.3293 20.7287 66.069 20.7287 65.8087C20.7287 65.5484 20.7165 65.1919 20.5422 64.9476",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 52,
    width: 4,
    height: 11
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8813 60.3344C23.422 59.5768 24.2142 58.8652 25.258 58.2427C25.3301 58.1997 25.375 58.1222 25.375 58.0382L25.375 54.5415C25.375 54.4575 25.3303 54.3799 25.2576 54.3378L22.363 52.6597C22.206 52.5687 22.0093 52.682 22.0093 52.8635V62.8843C22.0093 62.0166 22.3 61.1488 22.8813 60.3344Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_258_570)"
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8813 60.3344C23.442 59.5487 24.2733 58.8126 25.375 58.1739L25.375 54.4058L22.0093 52.4547V62.8843C22.0093 62.0166 22.3 61.1488 22.8813 60.3344Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.8813 60.3851C23.442 59.5994 24.2733 58.8633 25.375 58.2246V54.4565C24.2733 55.0952 23.442 55.8313 22.8813 56.617C22.3 57.4314 22.0093 58.2992 22.0093 59.1669L22.0093 62.935C22.0093 62.0673 22.3 61.1995 22.8813 60.3851Z",
    fill: "#141E28",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M25.375 58.2246C24.2733 58.8633 23.442 59.5994 22.8813 60.3851C22.3 61.1996 22.0093 62.0673 22.0093 62.935C22.0093 63.8027 22.0645 64.6705 22.6458 65.4849C23.2065 66.2706 24.0378 67.0067 25.1395 67.6454",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M25.375 54.4565L25.375 58.2246",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 54.4565C24.2733 55.0952 23.442 55.8313 22.8813 56.617C22.3 57.4314 22.0093 58.2992 22.0093 59.1669C22.0093 60.0346 22.0645 60.9024 22.6458 61.7168C23.2065 62.5025 24.0378 63.2386 25.1395 63.8773",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.375 54.4565C24.2733 55.0952 23.442 55.8313 22.8813 56.617C22.3 57.4314 22.0093 58.2992 22.0093 59.1669C22.0093 60.0346 22.0645 60.9024 22.6458 61.7168C23.2065 62.5025 24.0378 63.2386 25.1395 63.8773",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 49,
    width: 16,
    height: 24
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5183 61.0144L10.5183 59.1304C10.5183 57.3949 11.0995 55.6594 12.2621 54.0305C13.3635 52.4874 14.9866 51.0398 17.1314 49.7785C17.2042 49.7357 17.2946 49.7357 17.3677 49.778L25.2576 54.3519C25.3303 54.394 25.375 54.4717 25.375 54.5557V56.9386C25.375 57.0206 25.3324 57.0967 25.2624 57.1395L22.0093 59.1304C22.0093 59.9981 22.3 60.8658 22.8813 61.6803C23.3455 62.3307 23.9951 62.9472 24.8301 63.5025C24.9677 63.594 25.1104 63.6839 25.258 63.772C25.3302 63.815 25.375 63.8924 25.375 63.9764L25.375 67.4731C25.375 67.5571 25.3303 67.6348 25.2576 67.6769L17.3677 72.2507C17.2946 72.2931 17.2042 72.2931 17.1315 72.2502C14.9866 70.989 13.3635 69.5414 12.2621 67.9983C11.5481 66.9979 11.0534 65.9573 10.7779 64.9012L10.7779 63.0474C10.7779 63.0273 10.7753 63.0073 10.7703 62.9879C10.6023 62.334 10.5183 61.6742 10.5183 61.0144Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_258_570)"
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2621 54.0673C13.3836 52.4959 15.0461 51.0237 17.2496 49.7464L25.375 54.4568C24.2733 55.0954 23.442 55.8315 22.8813 56.6172C22.3 57.4317 22.0093 58.2994 22.0093 59.1671C22.0093 60.0349 22.3 60.9026 22.8813 61.7171C23.442 62.5027 24.2733 63.2389 25.375 63.8775L17.2496 68.5879C15.0461 67.3106 13.3836 65.8384 12.2621 64.267C11.0995 62.6381 10.5183 60.9026 10.5183 59.1671C10.5183 57.4317 11.0995 55.6962 12.2621 54.0673Z",
    fill: "#141E28"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2621 68.0351C11.0995 66.4062 10.5183 64.6707 10.5183 62.9352L10.5183 59.1671C10.5183 60.9026 11.0995 62.6381 12.2621 64.267C13.3836 65.8384 15.0461 67.3106 17.2496 68.5879L25.375 63.8775L25.375 67.6456L17.2496 72.356C15.0461 71.0786 13.3836 69.6064 12.2621 68.0351Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.5187 62.9347C10.5187 64.6702 11.1 66.4057 12.2625 68.0346C13.3841 69.606 15.0466 71.0782 17.25 72.3555L17.25 68.5874C15.0465 67.3101 13.3841 65.8379 12.2625 64.2665C11.1 62.6376 10.5187 60.9021 10.5187 59.1667L10.5187 62.9347Z",
    fill: "#141E28",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.375 67.6449L17.2496 72.3553L17.2496 68.5872L25.375 63.8768L25.375 67.6449Z",
    fill: "#141E28",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2621 54.0673C13.3836 52.4959 15.0461 51.0237 17.2496 49.7464L25.375 54.4568C24.2733 55.0954 23.442 55.8315 22.8813 56.6172C22.3 57.4317 22.0093 58.2994 22.0093 59.1671C22.0093 60.0349 22.3 60.9026 22.8813 61.7171C23.442 62.5027 24.2733 63.2389 25.375 63.8775L17.2496 68.5879C15.0461 67.3106 13.3836 65.8384 12.2621 64.267C11.0995 62.6381 10.5183 60.9026 10.5183 59.1671C10.5183 57.4317 11.0995 55.6962 12.2621 54.0673Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M10.2828 62.817C10.2828 64.5525 11.0995 66.2879 12.2621 67.9168C13.3836 69.4882 15.0461 70.9604 17.2496 72.2378L25.375 67.5274",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 68.4692V72.2378",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2621 53.75C11.0995 55.3789 10.5183 57.3499 10.5183 59.0853C10.5183 60.8208 11.0995 62.5562 12.2621 64.1851C13.3836 65.7565 15.0461 67.2287 17.2496 68.5061L25.375 63.7957",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M25.375 54.3388C24.2733 54.9774 23.442 55.7135 22.8813 56.4992C22.3 57.3137 22.0093 58.1814 22.0093 59.0491C22.0093 59.9169 22.3 60.7846 22.8813 61.5991C23.442 62.3847 24.2733 62.8853 25.375 63.524",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 68.4692V72.2378",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2621 53.75C11.0995 55.3789 10.5183 57.3499 10.5183 59.0853C10.5183 60.8208 11.0995 62.5562 12.2621 64.1851C13.3836 65.7565 15.0461 67.2287 17.2496 68.5061L25.375 63.7957",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.375 54.3388C24.2733 54.9774 23.442 55.7135 22.8813 56.4992C22.3 57.3137 22.0093 58.1814 22.0093 59.0491C22.0093 59.9169 22.3 60.7846 22.8813 61.5991C23.442 62.3847 24.2733 62.8853 25.375 63.524",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 83,
    width: 33,
    height: 31
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1 104.249C1 104.333 1.04473 104.41 1.11739 104.453L17.1327 113.737C17.2058 113.779 17.2959 113.779 17.369 113.737L33.3843 104.453C33.4569 104.41 33.5017 104.333 33.5017 104.249V93.2159C33.5017 93.1319 33.4569 93.0543 33.3843 93.0121L17.369 83.7279C17.2959 83.6855 17.2058 83.6855 17.1327 83.7279L1.11739 93.0121C1.04473 93.0543 1 93.1319 1 93.2159V104.249Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_258_570)"
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2499 83.6584L0.999024 93.0792L0.999023 104.384L17.2499 113.804L33.5007 104.384V93.0792L17.2499 83.6584Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 11.3043,
    transform: "matrix(0.86514 -0.501531 2.19408e-08 1 17.25 102.5)",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 11.3043,
    transform: "matrix(-0.86514 -0.501531 -2.19408e-08 1 17.25 102.5)",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.7841,
    height: 18.7841,
    transform: "matrix(-0.86514 -0.50153 0.86514 -0.501531 17.25 102.5)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5 104.384L17.25 113.804",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M17.25 113.804L1 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M33.5 93.0797L33.5 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M1 93.0797L1 104.384",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 102.5V113.804",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 93.0797L17.25 102.5",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 102.5L1 93.0797",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 102.5V113.804",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 93.0797L17.25 102.5",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 102.5L1 93.0797",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 84,
    width: 8,
    height: 7
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 89.1308C20.6416 88.8865 20.7287 88.6262 20.7287 88.3659V86.4819C20.7287 86.2216 20.6416 85.9613 20.4672 85.717C20.299 85.4813 20.0496 85.2605 19.7192 85.0689C19.3887 84.8774 19.0078 84.7328 18.6013 84.6353C18.1798 84.5342 17.7308 84.4837 17.2819 84.4837C16.8329 84.4837 16.3839 84.5342 15.9624 84.6353C15.5559 84.7328 15.175 84.8774 14.8445 85.0689C14.5141 85.2605 14.2647 85.4813 14.0965 85.717C13.9221 85.9613 13.835 86.2216 13.835 86.4819V88.3659C13.835 88.6262 13.9221 88.8865 14.0965 89.1308C14.2647 89.3665 14.5141 89.5873 14.8445 89.7789C15.175 89.9704 15.5559 90.115 15.9624 90.2125C16.3839 90.3136 16.8329 90.3641 17.2819 90.3641C17.7308 90.3641 18.1798 90.3136 18.6013 90.2125C19.0078 90.115 19.3887 89.9704 19.7192 89.7789C20.0496 89.5873 20.299 89.3665 20.4672 89.1308Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_258_570)"
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 89.1308C20.6416 88.8865 20.7287 88.6262 20.7287 88.3659V86.4819C20.7287 86.2216 20.6416 85.9613 20.4672 85.717C20.299 85.4813 20.0496 85.2605 19.7192 85.0689C19.3887 84.8774 19.0078 84.7328 18.6013 84.6353C18.1798 84.5342 17.7308 84.4837 17.2819 84.4837C16.8329 84.4837 16.3839 84.5342 15.9624 84.6353C15.5559 84.7328 15.175 84.8774 14.8445 85.0689C14.5141 85.2605 14.2647 85.4813 14.0965 85.717C13.9221 85.9613 13.835 86.2216 13.835 86.4819V88.3659C13.835 88.6262 13.9221 88.8865 14.0965 89.1308C14.2647 89.3665 14.5141 89.5873 14.8445 89.7789C15.175 89.9704 15.5559 90.115 15.9624 90.2125C16.3839 90.3136 16.8329 90.3641 17.2819 90.3641C17.7308 90.3641 18.1798 90.3136 18.6013 90.2125C19.0078 90.115 19.3887 89.9704 19.7192 89.7789C20.0496 89.5873 20.299 89.3665 20.4672 89.1308Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 89.1344C20.6416 88.8901 20.7287 88.6298 20.7287 88.3695V86.4855C20.7287 86.7458 20.6416 87.0061 20.4672 87.2504C20.299 87.486 20.0496 87.7068 19.7192 87.8984C19.3887 88.09 19.0078 88.2346 18.6013 88.3321C18.1798 88.4331 17.7308 88.4837 17.2819 88.4837C16.8329 88.4837 16.3839 88.4331 15.9624 88.3321C15.5559 88.2346 15.175 88.09 14.8445 87.8984C14.5141 87.7068 14.2647 87.486 14.0965 87.2504C13.9221 87.0061 13.835 86.7458 13.835 86.4855V88.3695C13.835 88.6298 13.9221 88.8901 14.0965 89.1344C14.2647 89.3701 14.5141 89.5909 14.8445 89.7825C15.175 89.9741 15.5559 90.1186 15.9624 90.2161C16.3839 90.3172 16.8329 90.3677 17.2819 90.3677C17.7308 90.3677 18.1798 90.3172 18.6013 90.2161C19.0078 90.1186 19.3887 89.9741 19.7192 89.7825C20.0496 89.5909 20.299 89.3701 20.4672 89.1344Z",
    fill: "url(#paint30_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0965 85.717C13.9221 85.9613 13.835 86.2216 13.835 86.4819C13.835 86.7422 13.9221 87.0024 14.0965 87.2467C14.2647 87.4824 14.5141 87.7032 14.8445 87.8948C15.175 88.0864 15.5559 88.2309 15.9624 88.3284C16.3839 88.4295 16.8329 88.4801 17.2819 88.4801C17.7308 88.4801 18.1798 88.4295 18.6013 88.3284C19.0078 88.2309 19.3887 88.0864 19.7192 87.8948C20.0496 87.7032 20.299 87.4824 20.4672 87.2467C20.6416 87.0024 20.7287 86.7422 20.7287 86.4819C20.7287 86.2216 20.6416 85.9613 20.4672 85.717C20.299 85.4813 20.0496 85.2605 19.7192 85.0689C19.3887 84.8774 19.0078 84.7328 18.6013 84.6353C18.1798 84.5342 17.7308 84.4837 17.2819 84.4837C16.8329 84.4837 16.3839 84.5342 15.9624 84.6353C15.5559 84.7328 15.175 84.8774 14.8445 85.0689C14.5141 85.2605 14.2647 85.4813 14.0965 85.717Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0225 85.6612C13.8481 85.9055 13.835 86.273 13.835 86.5333C13.835 86.7936 13.9221 87.0539 14.0965 87.2982C14.2647 87.5339 14.5141 87.7547 14.8445 87.9463C15.175 88.1378 15.5559 88.2824 15.9624 88.3799C16.3839 88.481 16.8329 88.5315 17.2819 88.5315C17.7308 88.5315 18.1798 88.481 18.6013 88.3799C19.0078 88.2824 19.3887 88.1378 19.7192 87.9463C20.0496 87.7547 20.299 87.5339 20.4672 87.2982C20.6416 87.0539 20.7287 86.7936 20.7287 86.5333C20.7287 86.273 20.7165 85.9166 20.5422 85.6722",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.0225 85.6612C13.8481 85.9055 13.835 86.273 13.835 86.5333C13.835 86.7936 13.9221 87.0539 14.0965 87.2982C14.2647 87.5339 14.5141 87.7547 14.8445 87.9463C15.175 88.1378 15.5559 88.2824 15.9624 88.3799C16.3839 88.481 16.8329 88.5315 17.2819 88.5315C17.7308 88.5315 18.1798 88.481 18.6013 88.3799C19.0078 88.2824 19.3887 88.1378 19.7192 87.9463C20.0496 87.7547 20.299 87.5339 20.4672 87.2982C20.6416 87.0539 20.7287 86.7936 20.7287 86.5333C20.7287 86.273 20.7165 85.9166 20.5422 85.6722",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 89,
    width: 8,
    height: 7
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3422 93.841C12.5166 93.5966 12.6037 93.3364 12.6037 93.0761V91.192C12.6037 90.9317 12.5166 90.6714 12.3422 90.4271C12.174 90.1915 11.9246 89.9707 11.5942 89.7791C11.2637 89.5875 10.8828 89.4429 10.4763 89.3454C10.0548 89.2444 9.60585 89.1938 9.15685 89.1938C8.70786 89.1938 8.25886 89.2444 7.83744 89.3454C7.43089 89.4429 7.05001 89.5875 6.71953 89.7791C6.38906 89.9707 6.13971 90.1915 5.97151 90.4271C5.79714 90.6714 5.70996 90.9317 5.70996 91.192V93.0761C5.70996 93.3364 5.79714 93.5966 5.97151 93.841C6.13971 94.0766 6.38906 94.2974 6.71953 94.489C7.05001 94.6806 7.43089 94.8251 7.83744 94.9227C8.25886 95.0237 8.70786 95.0743 9.15685 95.0743C9.60585 95.0743 10.0548 95.0237 10.4763 94.9227C10.8828 94.8251 11.2637 94.6806 11.5942 94.489C11.9246 94.2974 12.174 94.0766 12.3422 93.841Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_258_570)"
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3422 93.841C12.5166 93.5966 12.6037 93.3364 12.6037 93.0761V91.192C12.6037 90.9317 12.5166 90.6714 12.3422 90.4271C12.174 90.1915 11.9246 89.9707 11.5942 89.7791C11.2637 89.5875 10.8828 89.4429 10.4763 89.3454C10.0548 89.2444 9.60585 89.1938 9.15685 89.1938C8.70786 89.1938 8.25886 89.2444 7.83744 89.3454C7.43089 89.4429 7.05001 89.5875 6.71953 89.7791C6.38906 89.9707 6.13971 90.1915 5.97151 90.4271C5.79714 90.6714 5.70996 90.9317 5.70996 91.192V93.0761C5.70996 93.3364 5.79714 93.5966 5.97151 93.841C6.13971 94.0766 6.38906 94.2974 6.71953 94.489C7.05001 94.6806 7.43089 94.8251 7.83744 94.9227C8.25886 95.0237 8.70786 95.0743 9.15685 95.0743C9.60585 95.0743 10.0548 95.0237 10.4763 94.9227C10.8828 94.8251 11.2637 94.6806 11.5942 94.489C11.9246 94.2974 12.174 94.0766 12.3422 93.841Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.3422 93.8446C12.5166 93.6003 12.6037 93.34 12.6037 93.0797V91.1956C12.6037 91.4559 12.5166 91.7162 12.3422 91.9605C12.174 92.1962 11.9246 92.417 11.5942 92.6086C11.2637 92.8001 10.8828 92.9447 10.4763 93.0422C10.0548 93.1433 9.60585 93.1938 9.15685 93.1938C8.70786 93.1938 8.25886 93.1433 7.83744 93.0422C7.43089 92.9447 7.05001 92.8001 6.71953 92.6086C6.38906 92.417 6.13971 92.1962 5.97151 91.9605C5.79714 91.7162 5.70996 91.4559 5.70996 91.1956V93.0797C5.70996 93.34 5.79714 93.6003 5.97151 93.8446C6.13971 94.0802 6.38906 94.301 6.71953 94.4926C7.05001 94.6842 7.43089 94.8288 7.83744 94.9263C8.25886 95.0273 8.70786 95.0779 9.15685 95.0779C9.60585 95.0779 10.0548 95.0273 10.4763 94.9263C10.8828 94.8288 11.2637 94.6842 11.5942 94.4926C11.9246 94.301 12.174 94.0802 12.3422 93.8446Z",
    fill: "url(#paint31_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97151 90.4271C5.79714 90.6714 5.70996 90.9317 5.70996 91.192C5.70996 91.4523 5.79714 91.7126 5.97151 91.9569C6.13971 92.1926 6.38906 92.4134 6.71953 92.605C7.05001 92.7965 7.43089 92.9411 7.83744 93.0386C8.25886 93.1397 8.70786 93.1902 9.15685 93.1902C9.60585 93.1902 10.0548 93.1397 10.4763 93.0386C10.8828 92.9411 11.2637 92.7965 11.5942 92.605C11.9246 92.4134 12.174 92.1926 12.3422 91.9569C12.5166 91.7126 12.6037 91.4523 12.6037 91.192C12.6037 90.9317 12.5166 90.6714 12.3422 90.4271C12.174 90.1915 11.9246 89.9707 11.5942 89.7791C11.2637 89.5875 10.8828 89.4429 10.4763 89.3454C10.0548 89.2444 9.60585 89.1938 9.15685 89.1938C8.70786 89.1938 8.25886 89.2444 7.83744 89.3454C7.43089 89.4429 7.05001 89.5875 6.71953 89.7791C6.38906 89.9707 6.13971 90.1915 5.97151 90.4271Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89747 90.3714C5.72311 90.6157 5.70996 90.9832 5.70996 91.2435C5.70996 91.5038 5.79714 91.764 5.97151 92.0083C6.13971 92.244 6.38906 92.4648 6.71953 92.6564C7.05001 92.848 7.43089 92.9925 7.83744 93.09C8.25886 93.1911 8.70786 93.2417 9.15685 93.2417C9.60585 93.2417 10.0548 93.1911 10.4763 93.09C10.8828 92.9925 11.2637 92.848 11.5942 92.6564C11.9246 92.4648 12.174 92.244 12.3422 92.0083C12.5166 91.764 12.6037 91.5038 12.6037 91.2435C12.6037 90.9832 12.5915 90.6267 12.4172 90.3824",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.89747 90.3714C5.72311 90.6157 5.70996 90.9832 5.70996 91.2435C5.70996 91.5038 5.79714 91.764 5.97151 92.0083C6.13971 92.244 6.38906 92.4648 6.71953 92.6564C7.05001 92.848 7.43089 92.9925 7.83744 93.09C8.25886 93.1911 8.70786 93.2417 9.15685 93.2417C9.60585 93.2417 10.0548 93.1911 10.4763 93.09C10.8828 92.9925 11.2637 92.848 11.5942 92.6564C11.9246 92.4648 12.174 92.244 12.3422 92.0083C12.5166 91.764 12.6037 91.5038 12.6037 91.2435C12.6037 90.9832 12.5915 90.6267 12.4172 90.3824",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 89,
    width: 8,
    height: 7
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5922 93.8409C28.7666 93.5966 28.8537 93.3364 28.8537 93.0761V91.192C28.8537 90.9317 28.7666 90.6714 28.5922 90.4271C28.424 90.1915 28.1746 89.9707 27.8442 89.7791C27.5137 89.5875 27.1328 89.4429 26.7263 89.3454C26.3048 89.2444 25.8558 89.1938 25.4069 89.1938C24.9579 89.1938 24.5089 89.2444 24.0874 89.3454C23.6809 89.4429 23.3 89.5875 22.9695 89.7791C22.6391 89.9707 22.3897 90.1915 22.2215 90.4271C22.0471 90.6714 21.96 90.9317 21.96 91.192V93.0761C21.96 93.3364 22.0471 93.5966 22.2215 93.8409C22.3897 94.0766 22.6391 94.2974 22.9695 94.489C23.3 94.6806 23.6809 94.8251 24.0874 94.9226C24.5089 95.0237 24.9579 95.0743 25.4069 95.0743C25.8558 95.0743 26.3048 95.0237 26.7263 94.9226C27.1328 94.8251 27.5137 94.6806 27.8442 94.489C28.1746 94.2974 28.424 94.0766 28.5922 93.8409Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_258_570)"
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5922 93.8409C28.7666 93.5966 28.8537 93.3364 28.8537 93.0761V91.192C28.8537 90.9317 28.7666 90.6714 28.5922 90.4271C28.424 90.1915 28.1746 89.9707 27.8442 89.7791C27.5137 89.5875 27.1328 89.4429 26.7263 89.3454C26.3048 89.2444 25.8558 89.1938 25.4069 89.1938C24.9579 89.1938 24.5089 89.2444 24.0874 89.3454C23.6809 89.4429 23.3 89.5875 22.9695 89.7791C22.6391 89.9707 22.3897 90.1915 22.2215 90.4271C22.0471 90.6714 21.96 90.9317 21.96 91.192V93.0761C21.96 93.3364 22.0471 93.5966 22.2215 93.8409C22.3897 94.0766 22.6391 94.2974 22.9695 94.489C23.3 94.6806 23.6809 94.8251 24.0874 94.9226C24.5089 95.0237 24.9579 95.0743 25.4069 95.0743C25.8558 95.0743 26.3048 95.0237 26.7263 94.9226C27.1328 94.8251 27.5137 94.6806 27.8442 94.489C28.1746 94.2974 28.424 94.0766 28.5922 93.8409Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.5922 93.8446C28.7666 93.6003 28.8537 93.34 28.8537 93.0797V91.1956C28.8537 91.4559 28.7666 91.7162 28.5922 91.9605C28.424 92.1962 28.1746 92.417 27.8442 92.6086C27.5137 92.8001 27.1328 92.9447 26.7263 93.0422C26.3048 93.1433 25.8558 93.1938 25.4069 93.1938C24.9579 93.1938 24.5089 93.1433 24.0874 93.0422C23.6809 92.9447 23.3 92.8001 22.9695 92.6086C22.6391 92.417 22.3897 92.1962 22.2215 91.9605C22.0471 91.7162 21.96 91.4559 21.96 91.1956V93.0797C21.96 93.34 22.0471 93.6003 22.2215 93.8446C22.3897 94.0802 22.6391 94.301 22.9695 94.4926C23.3 94.6842 23.6809 94.8287 24.0874 94.9263C24.5089 95.0273 24.9579 95.0779 25.4069 95.0779C25.8558 95.0779 26.3048 95.0273 26.7263 94.9263C27.1328 94.8287 27.5137 94.6842 27.8442 94.4926C28.1746 94.301 28.424 94.0802 28.5922 93.8446Z",
    fill: "url(#paint32_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2215 90.4271C22.0471 90.6714 21.96 90.9317 21.96 91.192C21.96 91.4523 22.0471 91.7126 22.2215 91.9569C22.3897 92.1926 22.6391 92.4134 22.9695 92.605C23.3 92.7965 23.6809 92.9411 24.0874 93.0386C24.5089 93.1397 24.9579 93.1902 25.4069 93.1902C25.8558 93.1902 26.3048 93.1397 26.7263 93.0386C27.1328 92.9411 27.5137 92.7965 27.8442 92.605C28.1746 92.4134 28.424 92.1926 28.5922 91.9569C28.7666 91.7126 28.8537 91.4523 28.8537 91.192C28.8537 90.9317 28.7666 90.6714 28.5922 90.4271C28.424 90.1915 28.1746 89.9707 27.8442 89.7791C27.5137 89.5875 27.1328 89.4429 26.7263 89.3454C26.3048 89.2444 25.8558 89.1938 25.4069 89.1938C24.9579 89.1938 24.5089 89.2444 24.0874 89.3454C23.6809 89.4429 23.3 89.5875 22.9695 89.7791C22.6391 89.9707 22.3897 90.1915 22.2215 90.4271Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1475 90.3713C21.9731 90.6157 21.96 90.9832 21.96 91.2435C21.96 91.5037 22.0471 91.764 22.2215 92.0083C22.3897 92.244 22.6391 92.4648 22.9695 92.6564C23.3 92.848 23.6809 92.9925 24.0874 93.09C24.5089 93.1911 24.9579 93.2417 25.4069 93.2417C25.8558 93.2417 26.3048 93.1911 26.7263 93.09C27.1328 92.9925 27.5137 92.848 27.8442 92.6564C28.1746 92.4648 28.424 92.244 28.5922 92.0083C28.7666 91.764 28.8537 91.5037 28.8537 91.2435C28.8537 90.9832 28.8415 90.6267 28.6672 90.3824",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.1475 90.3713C21.9731 90.6157 21.96 90.9832 21.96 91.2435C21.96 91.5037 22.0471 91.764 22.2215 92.0083C22.3897 92.244 22.6391 92.4648 22.9695 92.6564C23.3 92.848 23.6809 92.9925 24.0874 93.09C24.5089 93.1911 24.9579 93.2417 25.4069 93.2417C25.8558 93.2417 26.3048 93.1911 26.7263 93.09C27.1328 92.9925 27.5137 92.848 27.8442 92.6564C28.1746 92.4648 28.424 92.244 28.5922 92.0083C28.7666 91.764 28.8537 91.5037 28.8537 91.2435C28.8537 90.9832 28.8415 90.6267 28.6672 90.3824",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 93,
    width: 8,
    height: 7
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 98.5511C20.6416 98.3068 20.7287 98.0465 20.7287 97.7862V95.9022C20.7287 95.6419 20.6416 95.3816 20.4672 95.1373C20.299 94.9016 20.0496 94.6808 19.7192 94.4892C19.3887 94.2976 19.0078 94.1531 18.6013 94.0556C18.1798 93.9545 17.7308 93.904 17.2819 93.904C16.8329 93.904 16.3839 93.9545 15.9624 94.0556C15.5559 94.1531 15.175 94.2976 14.8445 94.4892C14.5141 94.6808 14.2647 94.9016 14.0965 95.1373C13.9221 95.3816 13.835 95.6419 13.835 95.9022V97.7862C13.835 98.0465 13.9221 98.3068 14.0965 98.5511C14.2647 98.7868 14.5141 99.0076 14.8445 99.1992C15.175 99.3907 15.5559 99.5353 15.9624 99.6328C16.3839 99.7339 16.8329 99.7844 17.2819 99.7844C17.7308 99.7844 18.1798 99.7339 18.6013 99.6328C19.0078 99.5353 19.3887 99.3907 19.7192 99.1992C20.0496 99.0076 20.299 98.7868 20.4672 98.5511Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_258_570)"
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 98.5511C20.6416 98.3068 20.7287 98.0465 20.7287 97.7862V95.9022C20.7287 95.6419 20.6416 95.3816 20.4672 95.1373C20.299 94.9016 20.0496 94.6808 19.7192 94.4892C19.3887 94.2976 19.0078 94.1531 18.6013 94.0556C18.1798 93.9545 17.7308 93.904 17.2819 93.904C16.8329 93.904 16.3839 93.9545 15.9624 94.0556C15.5559 94.1531 15.175 94.2976 14.8445 94.4892C14.5141 94.6808 14.2647 94.9016 14.0965 95.1373C13.9221 95.3816 13.835 95.6419 13.835 95.9022V97.7862C13.835 98.0465 13.9221 98.3068 14.0965 98.5511C14.2647 98.7868 14.5141 99.0076 14.8445 99.1992C15.175 99.3907 15.5559 99.5353 15.9624 99.6328C16.3839 99.7339 16.8329 99.7844 17.2819 99.7844C17.7308 99.7844 18.1798 99.7339 18.6013 99.6328C19.0078 99.5353 19.3887 99.3907 19.7192 99.1992C20.0496 99.0076 20.299 98.7868 20.4672 98.5511Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4672 98.5547C20.6416 98.3104 20.7287 98.0501 20.7287 97.7898V95.9058C20.7287 96.1661 20.6416 96.4263 20.4672 96.6707C20.299 96.9063 20.0496 97.1271 19.7192 97.3187C19.3887 97.5103 19.0078 97.6548 18.6013 97.7524C18.1798 97.8534 17.7308 97.904 17.2819 97.904C16.8329 97.904 16.3839 97.8534 15.9624 97.7524C15.5559 97.6548 15.175 97.5103 14.8445 97.3187C14.5141 97.1271 14.2647 96.9063 14.0965 96.6707C13.9221 96.4263 13.835 96.1661 13.835 95.9058V97.7898C13.835 98.0501 13.9221 98.3104 14.0965 98.5547C14.2647 98.7904 14.5141 99.0112 14.8445 99.2028C15.175 99.3944 15.5559 99.5389 15.9624 99.6364C16.3839 99.7375 16.8329 99.788 17.2819 99.788C17.7308 99.788 18.1798 99.7375 18.6013 99.6364C19.0078 99.5389 19.3887 99.3944 19.7192 99.2028C20.0496 99.0112 20.299 98.7904 20.4672 98.5547Z",
    fill: "url(#paint33_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0965 95.1373C13.9221 95.3816 13.835 95.6419 13.835 95.9022C13.835 96.1624 13.9221 96.4227 14.0965 96.667C14.2647 96.9027 14.5141 97.1235 14.8445 97.3151C15.175 97.5067 15.5559 97.6512 15.9624 97.7487C16.3839 97.8498 16.8329 97.9004 17.2819 97.9004C17.7308 97.9004 18.1798 97.8498 18.6013 97.7487C19.0078 97.6512 19.3887 97.5067 19.7192 97.3151C20.0496 97.1235 20.299 96.9027 20.4672 96.667C20.6416 96.4227 20.7287 96.1624 20.7287 95.9022C20.7287 95.6419 20.6416 95.3816 20.4672 95.1373C20.299 94.9016 20.0496 94.6808 19.7192 94.4892C19.3887 94.2976 19.0078 94.1531 18.6013 94.0556C18.1798 93.9545 17.7308 93.904 17.2819 93.904C16.8329 93.904 16.3839 93.9545 15.9624 94.0556C15.5559 94.1531 15.175 94.2976 14.8445 94.4892C14.5141 94.6808 14.2647 94.9016 14.0965 95.1373Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0225 95.0815C13.8481 95.3258 13.835 95.6933 13.835 95.9536C13.835 96.2139 13.9221 96.4742 14.0965 96.7185C14.2647 96.9542 14.5141 97.175 14.8445 97.3666C15.175 97.5581 15.5559 97.7027 15.9624 97.8002C16.3839 97.9013 16.8329 97.9518 17.2819 97.9518C17.7308 97.9518 18.1798 97.9013 18.6013 97.8002C19.0078 97.7027 19.3887 97.5581 19.7192 97.3666C20.0496 97.175 20.299 96.9542 20.4672 96.7185C20.6416 96.4742 20.7287 96.2139 20.7287 95.9536C20.7287 95.6933 20.7165 95.3368 20.5422 95.0925",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.0225 95.0815C13.8481 95.3258 13.835 95.6933 13.835 95.9536C13.835 96.2139 13.9221 96.4742 14.0965 96.7185C14.2647 96.9542 14.5141 97.175 14.8445 97.3666C15.175 97.5581 15.5559 97.7027 15.9624 97.8002C16.3839 97.9013 16.8329 97.9518 17.2819 97.9518C17.7308 97.9518 18.1798 97.9013 18.6013 97.8002C19.0078 97.7027 19.3887 97.5581 19.7192 97.3666C20.0496 97.175 20.299 96.9542 20.4672 96.7185C20.6416 96.4742 20.7287 96.2139 20.7287 95.9536C20.7287 95.6933 20.7165 95.3368 20.5422 95.0925",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 82,
    width: 24,
    height: 18
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07562 97.7396C10.1773 98.3783 11.4471 98.8602 12.8024 99.1853C13.025 99.2387 13.2499 99.2878 13.4768 99.3328C13.6209 99.3613 13.754 99.2502 13.754 99.1032V97.5013C13.4329 97.443 13.1154 97.3763 12.8024 97.3012C11.4471 96.9762 10.1773 96.4943 9.07562 95.8556C7.97389 95.2169 7.14265 94.4808 6.58189 93.6951C6.45351 93.5152 6.3393 93.3328 6.23927 93.1482V94.9726C6.23927 95.0118 6.24896 95.0504 6.26806 95.0846C6.36105 95.2513 6.46566 95.4163 6.58189 95.5792C7.14265 96.3649 7.97389 97.101 9.07562 97.7396Z",
    fill: "black"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3265 97.7396C26.4282 97.101 27.2594 96.3649 27.8202 95.5792C27.9354 95.4177 28.0392 95.2542 28.1316 95.089C28.1508 95.0547 28.1605 95.016 28.1605 94.9767V93.1525C28.061 93.3356 27.9476 93.5166 27.8202 93.6951C27.2594 94.4808 26.4282 95.2169 25.3265 95.8556C24.2247 96.4943 22.955 96.9762 21.5996 97.3012C21.2863 97.3764 20.9683 97.4432 20.6468 97.5016V99.1035C20.6468 99.2504 20.7799 99.3616 20.924 99.333C21.1513 99.288 21.3766 99.2388 21.5996 99.1853C22.955 98.8602 24.2247 98.3783 25.3265 97.7396Z",
    fill: "black"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3265 95.8556C26.4282 95.2169 27.2594 94.4808 27.8202 93.6951C27.9476 93.5166 28.061 93.3356 28.1605 93.1525C28.3502 92.8034 28.4892 92.447 28.5773 92.0872C28.6539 91.7749 28.6921 91.4601 28.6921 91.1452V89.2611C28.6921 88.913 28.6453 88.5649 28.5518 88.2202L28.5319 88.1493C28.3895 87.6592 28.1523 87.1765 27.8202 86.7112C27.2594 85.9255 26.4282 85.1894 25.3265 84.5507C24.2247 83.912 22.955 83.4302 21.5996 83.1051C20.1947 82.7681 18.6979 82.5996 17.201 82.5996C15.7042 82.5996 14.2074 82.7681 12.8024 83.1051C11.4471 83.4302 10.1773 83.912 9.07562 84.5507C7.9739 85.1894 7.14265 85.9255 6.58189 86.7112C6.24981 87.1765 6.01258 87.6592 5.87022 88.1493L5.85028 88.2202C5.75674 88.5649 5.70996 88.913 5.70996 89.2611V91.1452C5.70996 91.4601 5.74823 91.7749 5.82476 92.0872C5.91256 92.4455 6.05073 92.8005 6.23927 93.1482C6.3393 93.3328 6.45351 93.5152 6.58189 93.6951C7.14265 94.4808 7.97389 95.2169 9.07562 95.8556C10.1773 96.4943 11.4471 96.9762 12.8024 97.3012C13.1154 97.3763 13.4329 97.443 13.754 97.5013C14.8742 97.7049 16.0376 97.8067 17.201 97.8067C18.364 97.8067 19.527 97.705 20.6468 97.5016C20.9683 97.4432 21.2863 97.3764 21.5996 97.3012C22.955 96.9762 24.2247 96.4943 25.3265 95.8556Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_258_570)"
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58189 90.4793C6.42597 90.6978 6.29096 90.9201 6.17687 91.1452C5.8656 91.7593 5.70996 92.3943 5.70996 93.0292C5.70996 93.897 6.0006 94.7647 6.58189 95.5791C7.14265 96.3648 7.97389 97.1009 9.07562 97.7396C10.1773 98.3783 11.4471 98.8602 12.8024 99.1853C14.2074 99.5222 15.7042 99.6907 17.201 99.6907C18.6979 99.6907 20.1947 99.5222 21.5996 99.1853C22.955 98.8602 24.2247 98.3783 25.3265 97.7396C26.4282 97.1009 27.2594 96.3648 27.8202 95.5791C28.4015 94.7647 28.6921 93.897 28.6921 93.0292C28.6921 92.3943 28.5365 91.7593 28.2252 91.1452C28.1111 90.9201 27.9761 90.6978 27.8202 90.4793C27.2594 89.6936 26.4282 88.9575 25.3265 88.3188C24.2247 87.6802 22.955 87.1983 21.5996 86.8732C20.1947 86.5362 18.6979 86.3677 17.201 86.3677C15.7042 86.3677 14.2074 86.5362 12.8024 86.8732C11.4471 87.1983 10.1773 87.6802 9.07562 88.3188C7.9739 88.9575 7.14265 89.6936 6.58189 90.4793Z",
    fill: "#141E28"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58189 86.7112C6.0006 87.5257 5.70996 88.3934 5.70996 89.2611C5.70996 89.8961 5.8656 90.5311 6.17687 91.1452C6.29096 91.3703 6.42597 91.5926 6.58189 91.811C7.14265 92.5967 7.97389 93.3328 9.07562 93.9715C10.1773 94.6102 11.4471 95.0921 12.8024 95.4171C14.2074 95.7541 15.7042 95.9226 17.201 95.9226C18.6979 95.9226 20.1947 95.7541 21.5996 95.4171C22.955 95.0921 24.2247 94.6102 25.3265 93.9715C26.4282 93.3328 27.2594 92.5967 27.8202 91.811C27.9761 91.5926 28.1111 91.3703 28.2252 91.1452C28.5365 90.5311 28.6921 89.8961 28.6921 89.2611C28.6921 88.3934 28.4015 87.5257 27.8202 86.7112C27.2594 85.9255 26.4282 85.1894 25.3265 84.5507C24.2247 83.912 22.955 83.4302 21.5996 83.1051C20.1947 82.7681 18.6979 82.5996 17.201 82.5996C15.7042 82.5996 14.2074 82.7681 12.8024 83.1051C11.4471 83.4302 10.1773 83.912 9.07562 84.5507C7.9739 85.1894 7.14265 85.9255 6.58189 86.7112Z",
    fill: "#141E28"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70996 93.0292C5.70996 92.3943 5.8656 91.7593 6.17687 91.1452C5.8656 90.5311 5.70996 89.8961 5.70996 89.2611V93.0292Z",
    fill: "#141E28"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2252 91.1452C28.5365 91.7593 28.6921 92.3943 28.6921 93.0292V89.2611C28.6921 89.8961 28.5365 90.5311 28.2252 91.1452Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.58189 86.7112C6.0006 87.5257 5.70996 88.3934 5.70996 89.2611C5.70996 90.1288 6.0006 90.9966 6.58189 91.811C7.14265 92.5967 7.97389 93.3328 9.07562 93.9715C10.1773 94.6102 11.4471 95.0921 12.8024 95.4171C14.2074 95.7541 15.7042 95.9226 17.201 95.9226C18.6979 95.9226 20.1947 95.7541 21.5996 95.4171C22.955 95.0921 24.2247 94.6102 25.3265 93.9715C26.4282 93.3328 27.2594 92.5967 27.8202 91.811C28.4015 90.9966 28.6921 90.1288 28.6921 89.2611C28.6921 88.3934 28.4015 87.5257 27.8202 86.7112C27.2594 85.9255 26.4282 85.1894 25.3265 84.5507C24.2247 83.912 22.955 83.4302 21.5996 83.1051C20.1947 82.7681 18.6979 82.5996 17.201 82.5996C15.7042 82.5996 14.2074 82.7681 12.8024 83.1051C11.4471 83.4302 10.1773 83.912 9.07562 84.5507C7.9739 85.1894 7.14265 85.9255 6.58189 86.7112Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.8202 95.6296C28.4015 94.8152 28.6921 93.9474 28.6921 93.0797V92.1377V89.3116C28.6921 89.6264 28.6539 89.9413 28.5773 90.2536C28.4429 90.802 28.1906 91.3426 27.8202 91.8615C27.2594 92.6472 26.4282 93.3833 25.3265 94.022C24.2247 94.6606 22.955 95.1425 21.5996 95.4676C20.1947 95.8046 18.6979 95.9731 17.201 95.9731C15.7042 95.9731 14.2074 95.8046 12.8024 95.4676C11.4471 95.1425 10.1773 94.6606 9.07562 94.022C7.97389 93.3833 7.14265 92.6472 6.58189 91.8615C6.21152 91.3426 5.95915 90.802 5.82476 90.2536C5.74823 89.9413 5.70996 89.6264 5.70996 89.3116V93.0797C5.70996 93.9474 6.0006 94.8152 6.58189 95.6296C7.14265 96.4153 7.97389 97.1514 9.07562 97.7901C10.1773 98.4288 11.4471 98.9106 12.8024 99.2357C14.2074 99.5727 15.7042 99.7412 17.201 99.7412C18.6979 99.7412 20.1947 99.5727 21.5996 99.2357C22.955 98.9106 24.2247 98.4288 25.3265 97.7901C26.4282 97.1514 27.2594 96.4153 27.8202 95.6296Z",
    fill: "#141E28",
    fillOpacity: 0.08,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8202 95.6296C28.4015 94.8152 28.6921 93.9474 28.6921 93.0797V92.1377V89.3116C28.6921 89.6264 28.6539 89.9413 28.5773 90.2536C28.4429 90.802 28.1906 91.3426 27.8202 91.8615C27.2594 92.6472 26.4282 93.3833 25.3265 94.022C24.2247 94.6606 22.955 95.1425 21.5996 95.4676C20.1947 95.8046 18.6979 95.9731 17.201 95.9731C15.7042 95.9731 14.2074 95.8046 12.8024 95.4676C11.4471 95.1425 10.1773 94.6606 9.07562 94.022C7.97389 93.3833 7.14265 92.6472 6.58189 91.8615C6.21152 91.3426 5.95915 90.802 5.82476 90.2536C5.74823 89.9413 5.70996 89.6264 5.70996 89.3116V93.0797C5.70996 93.9474 6.0006 94.8152 6.58189 95.6296C7.14265 96.4153 7.97389 97.1514 9.07562 97.7901C10.1773 98.4288 11.4471 98.9106 12.8024 99.2357C14.2074 99.5727 15.7042 99.7412 17.201 99.7412C18.6979 99.7412 20.1947 99.5727 21.5996 99.2357C22.955 98.9106 24.2247 98.4288 25.3265 97.7901C26.4282 97.1514 27.2594 96.4153 27.8202 95.6296Z",
    fill: "url(#paint34_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M5.47461 93.0797C5.47461 93.9474 6.00076 94.8152 6.58205 95.6296C7.14281 96.4153 7.97405 97.1514 9.07578 97.7901C10.1775 98.4288 11.4473 98.9106 12.8026 99.2357C14.2075 99.5727 15.7044 99.7412 17.2012 99.7412C18.698 99.7412 20.1949 99.5727 21.5998 99.2357C22.9551 98.9106 24.2249 98.4288 25.3266 97.7901C26.4283 97.1514 27.2596 96.4153 27.8203 95.6296C28.4016 94.8152 28.9278 93.9474 28.9278 93.0797",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58189 86.4855C6.0006 87.2999 5.70996 88.4032 5.70996 89.2709C5.70996 90.1386 6.0006 91.0064 6.58189 91.8208C7.14265 92.6065 7.9739 93.3426 9.07562 93.9813C10.1773 94.62 11.4471 95.1019 12.8024 95.4269C14.2074 95.7639 15.7042 95.9324 17.201 95.9324C18.6979 95.9324 20.1947 95.7639 21.5996 95.4269C22.955 95.1019 24.2247 94.62 25.3265 93.9813C26.4282 93.3426 27.2594 92.6065 27.8202 91.8208C28.4015 91.0064 28.6921 90.1386 28.6921 89.2709C28.6921 88.4032 28.4015 87.2999 27.8202 86.4855",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.58189 86.4855C6.0006 87.2999 5.70996 88.4032 5.70996 89.2709C5.70996 90.1386 6.0006 91.0064 6.58189 91.8208C7.14265 92.6065 7.9739 93.3426 9.07562 93.9813C10.1773 94.62 11.4471 95.1019 12.8024 95.4269C14.2074 95.7639 15.7042 95.9324 17.201 95.9324C18.6979 95.9324 20.1947 95.7639 21.5996 95.4269C22.955 95.1019 24.2247 94.62 25.3265 93.9813C26.4282 93.3426 27.2594 92.6065 27.8202 91.8208C28.4015 91.0064 28.6921 90.1386 28.6921 89.2709C28.6921 88.4032 28.4015 87.2999 27.8202 86.4855",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 93,
    width: 17,
    height: 21
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M90.375 97.9255C90.375 97.8416 90.3303 97.7639 90.2576 97.7218L82.3681 93.1482C82.2951 93.1058 82.2049 93.1058 82.1319 93.1482L74.2424 97.7218C74.1697 97.7639 74.125 97.8416 74.125 97.9256V108.959C74.125 109.043 74.1697 109.12 74.2424 109.162L82.1319 113.736C82.2049 113.778 82.2951 113.778 82.3681 113.736L90.2576 109.162C90.3303 109.12 90.375 109.043 90.375 108.959V97.9255Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_258_570)"
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.125 97.7898L82.25 93.0797L90.375 97.7898L90.375 109.094L82.25 113.804L74.125 109.094V97.7898V97.7898L74.125 97.7898Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 9.39154,
    height: 11.3043,
    transform: "matrix(0.86514 -0.501531 2.19408e-08 1 82.25 102.5)",
    fill: "black",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.39154,
    height: 11.3043,
    transform: "matrix(-0.86514 -0.501531 -2.19408e-08 1 82.25 102.5)",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.39154,
    height: 9.39154,
    transform: "matrix(-0.86514 -0.50153 0.86514 -0.501531 82.25 102.5)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M90.375 109.094L82.25 113.804",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M82.25 113.804L74.125 109.094",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M90.375 97.7898L90.375 109.094",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M74.125 97.7898L74.125 109.094",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M82.25 102.5V113.804",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M90.375 97.7898L82.25 102.5",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M82.25 102.5L74.125 97.7901",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.25 102.5V113.804",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.375 97.7898L82.25 102.5",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25 102.5L74.125 97.7901",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 101,
    width: 7,
    height: 8
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3061 101.733C77.0073 101.705 76.7383 101.759 76.5129 101.889L74.8813 102.831C74.6558 102.962 74.474 103.167 74.3496 103.44C74.2296 103.704 74.1631 104.03 74.1624 104.412C74.1617 104.794 74.227 105.196 74.3458 105.597C74.469 106.013 74.6497 106.427 74.8742 106.816C75.0987 107.204 75.367 107.568 75.6652 107.882C75.9529 108.186 76.2686 108.443 76.5997 108.634C76.9309 108.824 77.2468 108.93 77.535 108.958C77.8337 108.986 78.1027 108.932 78.3281 108.802L79.9598 107.86C80.1852 107.729 80.367 107.524 80.4914 107.251C80.6114 106.987 80.678 106.661 80.6786 106.279C80.6793 105.897 80.6141 105.495 80.4952 105.094C80.3721 104.678 80.1913 104.264 79.9668 103.875C79.7423 103.487 79.4741 103.123 79.1758 102.809C78.8881 102.505 78.5725 102.248 78.2413 102.057C77.9102 101.867 77.5943 101.761 77.3061 101.733Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_258_570)"
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3061 101.733C77.0073 101.705 76.7383 101.759 76.5129 101.889L74.8813 102.831C74.6558 102.962 74.474 103.167 74.3496 103.44C74.2296 103.704 74.1631 104.03 74.1624 104.412C74.1617 104.794 74.227 105.196 74.3458 105.597C74.469 106.013 74.6497 106.427 74.8742 106.816C75.0987 107.204 75.367 107.568 75.6652 107.882C75.9529 108.186 76.2686 108.443 76.5997 108.634C76.9309 108.824 77.2468 108.93 77.535 108.958C77.8337 108.986 78.1027 108.932 78.3281 108.802L79.9598 107.86C80.1852 107.729 80.367 107.524 80.4914 107.251C80.6114 106.987 80.678 106.661 80.6786 106.279C80.6793 105.897 80.6141 105.495 80.4952 105.094C80.3721 104.678 80.1913 104.264 79.9668 103.875C79.7423 103.487 79.4741 103.123 79.1758 102.809C78.8881 102.505 78.5725 102.248 78.2413 102.057C77.9102 101.867 77.5943 101.761 77.3061 101.733Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.3422 101.79C77.0434 101.762 76.7744 101.816 76.549 101.946L74.9174 102.888C75.1428 102.758 75.4118 102.704 75.7105 102.733C75.9987 102.76 76.3146 102.866 76.6458 103.056C76.9769 103.247 77.2926 103.504 77.5803 103.808C77.8785 104.122 78.1468 104.486 78.3713 104.874C78.5958 105.263 78.7765 105.677 78.8997 106.093C79.0185 106.494 79.0838 106.896 79.0831 107.278C79.0824 107.66 79.0159 107.986 78.8959 108.25C78.7715 108.523 78.5897 108.729 78.3643 108.859L79.9959 107.917C80.2213 107.786 80.4031 107.581 80.5275 107.308C80.6475 107.044 80.7141 106.718 80.7148 106.336C80.7154 105.954 80.6502 105.552 80.5313 105.151C80.4082 104.735 80.2274 104.321 80.0029 103.932C79.7784 103.544 79.5102 103.18 79.2119 102.866C78.9242 102.562 78.6086 102.305 78.2774 102.114C77.9463 101.924 77.6304 101.818 77.3422 101.79Z",
    fill: "url(#paint35_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.535 108.958C77.8337 108.986 78.1027 108.932 78.3281 108.802C78.5536 108.671 78.7354 108.466 78.8598 108.193C78.9798 107.929 79.0463 107.603 79.047 107.221C79.0477 106.839 78.9824 106.437 78.8636 106.036C78.7404 105.62 78.5597 105.206 78.3352 104.817C78.1107 104.429 77.8424 104.065 77.5442 103.751C77.2565 103.447 76.9408 103.19 76.6097 102.999C76.2785 102.809 75.9626 102.703 75.6744 102.675C75.3757 102.647 75.1067 102.701 74.8813 102.831C74.6558 102.962 74.474 103.167 74.3496 103.44C74.2296 103.704 74.1631 104.03 74.1624 104.412C74.1617 104.794 74.227 105.196 74.3458 105.597C74.469 106.013 74.6497 106.427 74.8742 106.816C75.0987 107.204 75.367 107.568 75.6652 107.882C75.9529 108.186 76.2686 108.443 76.5997 108.634C76.9309 108.824 77.2468 108.93 77.535 108.958Z",
    fill: "black",
    fillOpacity: 0.08,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4463 109.05C77.745 109.078 78.0699 108.906 78.2953 108.776C78.5207 108.646 78.7026 108.44 78.8269 108.167C78.9469 107.903 79.0135 107.577 79.0142 107.195C79.0148 106.813 78.9496 106.411 78.8308 106.01C78.7076 105.595 78.5269 105.181 78.3024 104.792C78.0779 104.403 77.8096 104.039 77.5113 103.725C77.2236 103.422 76.908 103.164 76.5768 102.974C76.2457 102.783 75.9298 102.678 75.6416 102.65C75.3428 102.621 75.0738 102.676 74.8484 102.806C74.623 102.936 74.3204 103.125 74.196 103.398",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.4463 109.05C77.745 109.078 78.0699 108.906 78.2953 108.776C78.5207 108.646 78.7026 108.44 78.8269 108.167C78.9469 107.903 79.0135 107.577 79.0142 107.195C79.0148 106.813 78.9496 106.411 78.8308 106.01C78.7076 105.595 78.5269 105.181 78.3024 104.792C78.0779 104.403 77.8096 104.039 77.5113 103.725C77.2236 103.422 76.908 103.164 76.5768 102.974C76.2457 102.783 75.9298 102.678 75.6416 102.65C75.3428 102.621 75.0738 102.676 74.8484 102.806C74.623 102.936 74.3204 103.125 74.196 103.398",
    stroke: "white",
    strokeOpacity: 0.32,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 103,
    width: 5,
    height: 5
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2414 107.903C77.4406 107.922 77.6199 107.886 77.7702 107.799C77.9205 107.712 78.0417 107.575 78.1246 107.393C78.2046 107.217 78.249 107 78.2494 106.745C78.2499 106.49 78.2064 106.222 78.1271 105.955C78.045 105.678 77.9245 105.402 77.7749 105.143C77.6252 104.883 77.4464 104.641 77.2475 104.431C77.0557 104.229 76.8453 104.058 76.6245 103.931C76.4038 103.804 76.1932 103.733 76.001 103.715C75.8019 103.696 75.6225 103.732 75.4722 103.819C75.322 103.905 75.2008 104.043 75.1178 104.225C75.0378 104.4 74.9935 104.618 74.993 104.873C74.9926 105.127 75.0361 105.395 75.1153 105.663C75.1974 105.94 75.3179 106.216 75.4676 106.475C75.6172 106.734 75.7961 106.976 75.9949 107.186C76.1867 107.388 76.3971 107.56 76.6179 107.687C76.8387 107.814 77.0493 107.884 77.2414 107.903Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_258_570)"
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6138 102.813C77.4146 102.794 77.2353 102.83 77.085 102.917L75.4534 103.859C75.3031 103.946 75.1819 104.083 75.099 104.265C75.019 104.441 74.9746 104.658 74.9742 104.913C74.9737 105.168 75.0172 105.436 75.0964 105.703C75.1785 105.98 75.299 106.256 75.4487 106.515C75.5984 106.775 75.7772 107.017 75.976 107.227C76.1678 107.429 76.3783 107.6 76.599 107.727C76.8198 107.854 77.0304 107.925 77.2225 107.943C77.4217 107.963 77.601 107.926 77.7513 107.839L79.383 106.897C79.5332 106.811 79.6545 106.673 79.7374 106.491C79.8174 106.316 79.8617 106.098 79.8622 105.843C79.8626 105.589 79.8191 105.321 79.7399 105.053C79.6578 104.776 79.5373 104.5 79.3877 104.241C79.238 103.982 79.0591 103.74 78.8603 103.53C78.6685 103.328 78.4581 103.156 78.2373 103.029C78.0165 102.902 77.806 102.832 77.6138 102.813Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.8898 106.961C79.089 106.98 79.2683 106.944 79.4186 106.857C79.5689 106.77 79.6901 106.633 79.773 106.451C79.853 106.275 79.8974 106.058 79.8979 105.803C79.8983 105.548 79.8548 105.28 79.7756 105.013C79.6935 104.736 79.573 104.46 79.4233 104.201C79.2736 103.941 79.0948 103.699 78.896 103.489C78.7042 103.287 78.4937 103.116 78.273 102.989C78.0522 102.862 77.8416 102.791 77.6495 102.773C77.4503 102.753 77.271 102.79 77.1207 102.877C76.9704 102.963 76.8492 103.101 76.7663 103.283C76.6863 103.458 76.6419 103.676 76.6414 103.931C76.641 104.185 76.6845 104.453 76.7637 104.721C76.8458 104.998 76.9663 105.274 77.116 105.533C77.2657 105.792 77.4445 106.034 77.6433 106.244C77.8351 106.446 78.0456 106.618 78.2663 106.745C78.4871 106.872 78.6977 106.942 78.8898 106.961Z",
    fill: "black",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8542 107.001C79.0533 107.02 79.2327 106.984 79.383 106.897L77.7513 107.839C77.601 107.926 77.4217 107.963 77.2225 107.943C77.0304 107.925 76.8198 107.854 76.599 107.727C76.3783 107.6 76.1678 107.429 75.976 107.227C75.7772 107.017 75.5984 106.775 75.4487 106.515C75.299 106.256 75.1785 105.98 75.0964 105.703C75.0172 105.436 74.9737 105.168 74.9742 104.913C74.9746 104.658 75.019 104.441 75.099 104.265C75.1819 104.083 75.3031 103.946 75.4534 103.859L77.085 102.917C76.9348 103.004 76.8135 103.141 76.7306 103.323C76.6506 103.499 76.6062 103.716 76.6058 103.971C76.6053 104.226 76.6489 104.494 76.7281 104.761C76.8102 105.038 76.9307 105.314 77.0803 105.573C77.23 105.833 77.4088 106.075 77.6077 106.285C77.7995 106.487 78.0099 106.658 78.2307 106.785C78.4514 106.912 78.662 106.983 78.8542 107.001Z",
    fill: "url(#paint36_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5195 103.624C76.3203 103.605 76.0717 103.503 75.5135 103.825C75.3633 103.912 75.242 104.049 75.1591 104.231C75.0791 104.407 75.0347 104.624 75.0343 104.879C75.0338 105.133 75.0773 105.401 75.1566 105.669C75.2387 105.946 75.3592 106.222 75.5088 106.481C75.6585 106.74 75.8373 106.983 76.0362 107.192C76.228 107.394 76.4384 107.566 76.6592 107.693C76.8799 107.82 77.0905 107.89 77.2827 107.909C77.4818 107.928 77.6612 107.892 77.8115 107.805C78.4716 107.424 78.4015 107.21 78.4845 107.028",
    stroke: "#849FFF",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.5195 103.624C76.3203 103.605 76.0717 103.503 75.5135 103.825C75.3633 103.912 75.242 104.049 75.1591 104.231C75.0791 104.407 75.0347 104.624 75.0343 104.879C75.0338 105.133 75.0773 105.401 75.1566 105.669C75.2387 105.946 75.3592 106.222 75.5088 106.481C75.6585 106.74 75.8373 106.983 76.0362 107.192C76.228 107.394 76.4384 107.566 76.6592 107.693C76.8799 107.82 77.0905 107.89 77.2827 107.909C77.4818 107.928 77.6612 107.892 77.8115 107.805C78.4716 107.424 78.4015 107.21 78.4845 107.028",
    stroke: "white",
    strokeOpacity: 0.32,
    strokeWidth: 0.353261,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 78,
    y: 93,
    width: 8,
    height: 7
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4672 98.5511C85.6416 98.3068 85.7287 98.0465 85.7287 97.7862V95.9021C85.7287 95.6419 85.6416 95.3816 85.4672 95.1373C85.299 94.9016 85.0496 94.6808 84.7192 94.4892C84.3887 94.2976 84.0078 94.1531 83.6013 94.0556C83.1798 93.9545 82.7308 93.9039 82.2819 93.9039C81.8329 93.9039 81.3839 93.9545 80.9624 94.0556C80.5559 94.1531 80.175 94.2976 79.8445 94.4892C79.5141 94.6808 79.2647 94.9016 79.0965 95.1373C78.9221 95.3816 78.835 95.6419 78.835 95.9021V97.7862C78.835 98.0465 78.9221 98.3068 79.0965 98.5511C79.2647 98.7868 79.5141 99.0076 79.8445 99.1991C80.175 99.3907 80.5559 99.5353 80.9624 99.6328C81.3839 99.7339 81.8329 99.7844 82.2819 99.7844C82.7308 99.7844 83.1798 99.7339 83.6013 99.6328C84.0078 99.5353 84.3887 99.3907 84.7192 99.1991C85.0496 99.0076 85.299 98.7868 85.4672 98.5511Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_258_570)"
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4672 98.5511C85.6416 98.3068 85.7287 98.0465 85.7287 97.7862V95.9021C85.7287 95.6419 85.6416 95.3816 85.4672 95.1373C85.299 94.9016 85.0496 94.6808 84.7192 94.4892C84.3887 94.2976 84.0078 94.1531 83.6013 94.0556C83.1798 93.9545 82.7308 93.9039 82.2819 93.9039C81.8329 93.9039 81.3839 93.9545 80.9624 94.0556C80.5559 94.1531 80.175 94.2976 79.8445 94.4892C79.5141 94.6808 79.2647 94.9016 79.0965 95.1373C78.9221 95.3816 78.835 95.6419 78.835 95.9021V97.7862C78.835 98.0465 78.9221 98.3068 79.0965 98.5511C79.2647 98.7868 79.5141 99.0076 79.8445 99.1991C80.175 99.3907 80.5559 99.5353 80.9624 99.6328C81.3839 99.7339 81.8329 99.7844 82.2819 99.7844C82.7308 99.7844 83.1798 99.7339 83.6013 99.6328C84.0078 99.5353 84.3887 99.3907 84.7192 99.1991C85.0496 99.0076 85.299 98.7868 85.4672 98.5511Z",
    fill: "#849FFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.4672 98.5547C85.6416 98.3104 85.7287 98.0501 85.7287 97.7898V95.9058C85.7287 96.166 85.6416 96.4263 85.4672 96.6706C85.299 96.9063 85.0496 97.1271 84.7192 97.3187C84.3887 97.5103 84.0078 97.6548 83.6013 97.7523C83.1798 97.8534 82.7308 97.904 82.2819 97.904C81.8329 97.904 81.3839 97.8534 80.9624 97.7523C80.5559 97.6548 80.175 97.5103 79.8445 97.3187C79.5141 97.1271 79.2647 96.9063 79.0965 96.6706C78.9221 96.4263 78.835 96.166 78.835 95.9058V97.7898C78.835 98.0501 78.9221 98.3104 79.0965 98.5547C79.2647 98.7904 79.5141 99.0112 79.8445 99.2028C80.175 99.3943 80.5559 99.5389 80.9624 99.6364C81.3839 99.7375 81.8329 99.788 82.2819 99.788C82.7308 99.788 83.1798 99.7375 83.6013 99.6364C84.0078 99.5389 84.3887 99.3943 84.7192 99.2028C85.0496 99.0112 85.299 98.7904 85.4672 98.5547Z",
    fill: "url(#paint37_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0965 95.1373C78.9221 95.3816 78.835 95.6419 78.835 95.9021C78.835 96.1624 78.9221 96.4227 79.0965 96.667C79.2647 96.9027 79.5141 97.1235 79.8445 97.3151C80.175 97.5067 80.5559 97.6512 80.9624 97.7487C81.3839 97.8498 81.8329 97.9003 82.2819 97.9003C82.7308 97.9003 83.1798 97.8498 83.6013 97.7487C84.0078 97.6512 84.3887 97.5067 84.7192 97.3151C85.0496 97.1235 85.299 96.9027 85.4672 96.667C85.6416 96.4227 85.7287 96.1624 85.7287 95.9021C85.7287 95.6419 85.6416 95.3816 85.4672 95.1373C85.299 94.9016 85.0496 94.6808 84.7192 94.4892C84.3887 94.2976 84.0078 94.1531 83.6013 94.0556C83.1798 93.9545 82.7308 93.9039 82.2819 93.9039C81.8329 93.9039 81.3839 93.9545 80.9624 94.0556C80.5559 94.1531 80.175 94.2976 79.8445 94.4892C79.5141 94.6808 79.2647 94.9016 79.0965 95.1373Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "overlay"
    }
  }), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0225 95.0815C78.8481 95.3258 78.835 95.6933 78.835 95.9536C78.835 96.2139 78.9221 96.4742 79.0965 96.7185C79.2647 96.9542 79.5141 97.175 79.8445 97.3665C80.175 97.5581 80.5559 97.7027 80.9624 97.8002C81.3839 97.9013 81.8329 97.9518 82.2819 97.9518C82.7308 97.9518 83.1798 97.9013 83.6013 97.8002C84.0078 97.7027 84.3887 97.5581 84.7192 97.3665C85.0496 97.175 85.299 96.9542 85.4672 96.7185C85.6416 96.4742 85.7287 96.2139 85.7287 95.9536C85.7287 95.6933 85.7165 95.3368 85.5422 95.0925",
    stroke: "#849FFF",
    strokeWidth: 0.235507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M79.0225 95.0815C78.8481 95.3258 78.835 95.6933 78.835 95.9536C78.835 96.2139 78.9221 96.4742 79.0965 96.7185C79.2647 96.9542 79.5141 97.175 79.8445 97.3665C80.175 97.5581 80.5559 97.7027 80.9624 97.8002C81.3839 97.9013 81.8329 97.9518 82.2819 97.9518C82.7308 97.9518 83.1798 97.9013 83.6013 97.8002C84.0078 97.7027 84.3887 97.5581 84.7192 97.3665C85.0496 97.175 85.299 96.9542 85.4672 96.7185C85.6416 96.4742 85.7287 96.2139 85.7287 95.9536C85.7287 95.6933 85.7165 95.3368 85.5422 95.0925",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeWidth: 0.235507,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 114,
    y: 84,
    width: 17,
    height: 14
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M131 89.4473C131 89.3633 130.955 89.2857 130.883 89.2435L122.993 84.6699C122.92 84.6276 122.83 84.6276 122.757 84.6699L114.867 89.2435C114.795 89.2857 114.75 89.3633 114.75 89.4473V92.944C114.75 93.028 114.795 93.1056 114.867 93.1478L122.757 97.7214C122.83 97.7637 122.92 97.7637 122.993 97.7214L130.883 93.1478C130.955 93.1056 131 93.028 131 92.944V89.4473Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_258_570)"
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.875 84.6014L114.75 89.3116V93.0797L122.875 97.7898L131 93.0797L131 89.3116L122.875 84.6014Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 9.39154,
    height: 3.76812,
    transform: "matrix(0.86514 -0.501531 2.19408e-08 1 122.875 94.0217)",
    fill: "#141E28",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.39154,
    height: 3.76812,
    transform: "matrix(-0.86514 -0.501531 -2.19408e-08 1 122.875 94.0217)",
    fill: "#141E28",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_i_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.39154,
    height: 9.39154,
    transform: "matrix(-0.86514 -0.50153 0.86514 -0.501531 122.875 94.0217)",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M131 93.0797L122.875 97.7898",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M122.875 97.7898L114.75 93.0797",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M131 89.3116L131 93.0797",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M114.75 89.3116L114.75 93.0797",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M122.875 94.0217V97.7898",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M131 89.3116L122.875 94.0217",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M122.875 94.0217L114.75 89.3116",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.875 94.0217V97.7898",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 89.3116L122.875 94.0217",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.875 94.0217L114.75 89.3116",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_258_570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 108,
    y: 50,
    width: 13,
    height: 11
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M108.98 53.4302C108.98 52.9963 109.126 52.5625 109.416 52.1553C109.697 51.7625 110.112 51.3944 110.663 51.0751C111.214 50.7558 111.849 50.5149 112.527 50.3523C113.229 50.1839 113.977 50.0996 114.726 50.0996C115.474 50.0996 116.222 50.1839 116.925 50.3523C117.603 50.5149 118.237 50.7558 118.788 51.0751C119.339 51.3944 119.755 51.7625 120.035 52.1553C120.326 52.5625 120.471 52.9963 120.471 53.4302V57.1983C120.471 57.6321 120.326 58.066 120.035 58.4732C119.755 58.866 119.339 59.234 118.788 59.5534C118.237 59.8727 117.603 60.1136 116.925 60.2762C116.222 60.4446 115.474 60.5289 114.726 60.5289C113.977 60.5289 113.229 60.4446 112.527 60.2762C111.849 60.1136 111.214 59.8727 110.663 59.5534C110.112 59.234 109.697 58.866 109.416 58.4732C109.126 58.066 108.98 57.6321 108.98 57.1983L108.98 53.4302Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_258_570)"
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M108.98 53.4301C108.98 52.9963 109.126 52.5624 109.416 52.1552C109.697 51.7624 110.112 51.3944 110.663 51.075C111.214 50.7557 111.849 50.5148 112.527 50.3522C113.229 50.1838 113.977 50.0995 114.726 50.0995C115.474 50.0995 116.222 50.1838 116.925 50.3522C117.603 50.5148 118.237 50.7557 118.788 51.075C119.339 51.3944 119.755 51.7624 120.035 52.1552C120.326 52.5624 120.471 52.9963 120.471 53.4301V57.1982C120.471 57.632 120.326 58.0659 120.035 58.4731C119.755 58.8659 119.339 59.234 118.788 59.5533C118.237 59.8726 117.603 60.1135 116.925 60.2761C116.222 60.4445 115.474 60.5288 114.726 60.5288C113.977 60.5288 113.229 60.4445 112.527 60.2761C111.849 60.1135 111.214 59.8726 110.663 59.5533C110.112 59.234 109.697 58.8659 109.416 58.4731C109.126 58.0659 108.98 57.632 108.98 57.1982V53.4301Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.98 53.4302C108.98 52.9963 109.126 52.5625 109.416 52.1553C109.697 51.7625 110.112 51.3944 110.663 51.0751C111.214 50.7558 111.849 50.5149 112.527 50.3523C113.229 50.1839 113.977 50.0996 114.726 50.0996C115.474 50.0996 116.222 50.1839 116.925 50.3523C117.603 50.5149 118.237 50.7558 118.788 51.0751C119.339 51.3944 119.755 51.7625 120.035 52.1553C120.326 52.5625 120.471 52.9963 120.471 53.4302V57.1983C120.471 57.6321 120.326 58.066 120.035 58.4732C119.755 58.866 119.339 59.234 118.788 59.5534C118.237 59.8727 117.603 60.1136 116.925 60.2762C116.222 60.4446 115.474 60.5289 114.726 60.5289C113.977 60.5289 113.229 60.4446 112.527 60.2762C111.849 60.1136 111.214 59.8727 110.663 59.5534C110.112 59.234 109.697 58.866 109.416 58.4732C109.126 58.066 108.98 57.6321 108.98 57.1983V53.4302Z",
    fill: "url(#paint38_linear_258_570)",
    fillOpacity: 0.48,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M120.706 57.1648C120.706 57.5987 120.325 58.0325 120.034 58.4397C119.754 58.8325 119.338 59.2006 118.787 59.5199C118.237 59.8392 117.602 60.0801 116.924 60.2427C116.222 60.4112 115.473 60.4954 114.725 60.4954C113.977 60.4954 113.228 60.4112 112.526 60.2427C111.848 60.0801 111.213 59.8392 110.662 59.5199C110.112 59.2006 109.696 58.8325 109.416 58.4397C109.125 58.0325 108.744 57.5987 108.744 57.1648",
    stroke: "#141E28",
    strokeOpacity: 0.4,
    strokeWidth: 0.471014,
    strokeLinecap: "round"
  }), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M109.441 52.1218C109.15 52.529 109.005 52.9629 109.005 53.3967C109.005 53.8306 109.15 54.2644 109.441 54.6716C109.721 55.0644 110.137 55.4325 110.687 55.7518C111.238 56.0711 111.873 56.312 112.551 56.4746C113.253 56.643 114.002 56.7273 114.75 56.7273C115.498 56.7273 116.247 56.643 116.949 56.4746C117.627 56.312 118.262 56.0711 118.812 55.7518C119.363 55.4325 119.779 55.0644 120.059 54.6716C120.35 54.2644 120.495 53.8306 120.495 53.3967C120.495 52.9629 120.35 52.529 120.059 52.1218C119.779 51.729 119.363 51.361 118.812 51.0416C118.262 50.7223 117.627 50.4814 116.949 50.3189C116.247 50.1504 115.498 50.0661 114.75 50.0661C114.002 50.0661 113.253 50.1504 112.551 50.3189C111.873 50.4814 111.238 50.7223 110.687 51.0416C110.137 51.361 109.721 51.729 109.441 52.1218Z",
    fill: "#141E28"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_i_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.441 52.1218C109.15 52.529 109.005 52.9629 109.005 53.3967C109.005 53.8306 109.15 54.2644 109.441 54.6716C109.721 55.0644 110.137 55.4325 110.687 55.7518C111.238 56.0711 111.873 56.312 112.551 56.4746C113.253 56.643 114.002 56.7273 114.75 56.7273C115.498 56.7273 116.247 56.643 116.949 56.4746C117.627 56.312 118.262 56.0711 118.812 55.7518C119.363 55.4325 119.779 55.0644 120.059 54.6716C120.35 54.2644 120.495 53.8306 120.495 53.3967C120.495 52.9629 120.35 52.529 120.059 52.1218C119.779 51.729 119.363 51.361 118.812 51.0416C118.262 50.7223 117.627 50.4814 116.949 50.3189C116.247 50.1504 115.498 50.0661 114.75 50.0661C114.002 50.0661 113.253 50.1504 112.551 50.3189C111.873 50.4814 111.238 50.7223 110.687 51.0416C110.137 51.361 109.721 51.729 109.441 52.1218Z",
    fill: "white",
    fillOpacity: 0.24,
    style: {
      mixBlendMode: "overlay"
    }
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M109.416 51.7482C109.126 52.1554 108.98 52.9425 108.98 53.3763C108.98 53.8102 109.126 54.244 109.416 54.6512C109.697 55.044 110.112 55.4121 110.663 55.7314C111.214 56.0507 111.849 56.2916 112.527 56.4542C113.229 56.6226 113.977 56.7069 114.726 56.7069C115.474 56.7069 116.222 56.6226 116.925 56.4542C117.603 56.2916 118.237 56.0507 118.788 55.7314C119.339 55.4121 119.755 55.044 120.035 54.6512C120.326 54.244 120.471 53.8102 120.471 53.3763C120.471 52.9425 120.326 52.1554 120.035 51.7482",
    stroke: "#141E28",
    strokeWidth: 0.353261,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.416 51.7482C109.126 52.1554 108.98 52.9425 108.98 53.3763C108.98 53.8102 109.126 54.244 109.416 54.6512C109.697 55.044 110.112 55.4121 110.663 55.7314C111.214 56.0507 111.849 56.2916 112.527 56.4542C113.229 56.6226 113.977 56.7069 114.726 56.7069C115.474 56.7069 116.222 56.6226 116.925 56.4542C117.603 56.2916 118.237 56.0507 118.788 55.7314C119.339 55.4121 119.755 55.044 120.035 54.6512C120.326 54.244 120.471 53.8102 120.471 53.3763C120.471 52.9425 120.326 52.1554 120.035 51.7482",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.353261,
    strokeLinecap: "round",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.6348,
    y: 96.4869,
    width: 16.4094,
    height: 19.6199,
    rx: 2.72637,
    transform: "rotate(-31 53.6348 96.4869)",
    fill: "url(#paint39_linear_258_570)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.2599,
    y: 94.5313,
    width: 16.0277,
    height: 19.2382,
    rx: 2.53553,
    transform: "rotate(-31 57.2599 94.5313)",
    fill: "url(#paint40_linear_258_570)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.2599,
    y: 94.5313,
    width: 16.0277,
    height: 19.2382,
    rx: 2.53553,
    transform: "rotate(-31 57.2599 94.5313)",
    stroke: "url(#paint41_linear_258_570)",
    strokeWidth: 0.381692
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.2599,
    y: 94.5313,
    width: 16.0277,
    height: 19.2382,
    rx: 2.53553,
    transform: "rotate(-31 57.2599 94.5313)",
    stroke: "#849FFF",
    strokeWidth: 0.381692
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8269 100.802L68.5264 100.077L67.3784 97.3098C67.3784 97.3098 65.5079 98.6688 65.7406 99.9185L65.9276 100.37L67.6658 104.559L70.3247 102.772C70.6215 102.573 70.8916 102.348 71.1353 102.099C69.6398 102.533 68.8269 100.802 68.8269 100.802Z",
    fill: "url(#paint42_linear_258_570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.07 94.0487C69.0131 93.7415 67.9708 93.9336 66.9428 94.6244L63.7524 96.7681L64.5256 96.9932L65.7397 99.9185C65.5069 98.6688 67.3775 97.3098 67.3775 97.3098L67.9095 96.9523C68.3489 96.657 68.796 96.5754 69.2493 96.7067C69.7031 96.8385 70.0298 97.1448 70.229 97.6259C70.4288 98.1067 70.443 98.623 70.2727 99.1741C70.1024 99.7253 69.7971 100.148 69.3576 100.444L68.8256 100.801C68.8256 100.801 69.638 102.532 71.134 102.098C71.7354 101.485 72.178 100.723 72.4607 99.8096C72.8571 98.5258 72.8224 97.3214 72.3556 96.1962C71.8886 95.0719 71.1269 94.356 70.07 94.0487Z",
    fill: "url(#paint43_linear_258_570)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72.5244,
    y: 45.2144,
    width: 11.2528,
    height: 13.4544,
    rx: 1.86962,
    transform: "rotate(-15 72.5244 45.2144)",
    fill: "url(#paint44_linear_258_570)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2853,
    y: 44.6105,
    width: 10.991,
    height: 13.1926,
    rx: 1.73874,
    transform: "rotate(-15 75.2853 44.6105)",
    fill: "url(#paint45_linear_258_570)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2853,
    y: 44.6105,
    width: 10.991,
    height: 13.1926,
    rx: 1.73874,
    transform: "rotate(-15 75.2853 44.6105)",
    stroke: "url(#paint46_linear_258_570)",
    strokeWidth: 0.261746
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2853,
    y: 44.6105,
    width: 10.991,
    height: 13.1926,
    rx: 1.73874,
    transform: "rotate(-15 75.2853 44.6105)",
    stroke: "#F3F3F3",
    strokeWidth: 0.261746
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.9228 51.1995L81.8551 50.6671L81.5959 48.6342C81.5959 48.6342 80.1167 49.1941 80.0452 50.0608L80.0873 50.3922L80.4798 53.4697L82.5563 52.7696C82.7881 52.6914 83.0069 52.5917 83.2125 52.4712C82.1475 52.4882 81.9228 51.1995 81.9228 51.1995Z",
    fill: "url(#paint47_linear_258_570)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9602 46.9672C83.3181 46.574 82.5956 46.513 81.7927 46.7837L79.3012 47.6237L79.7709 47.9115L80.0451 50.0607C80.1167 49.1941 81.5959 48.6342 81.5959 48.6342L82.0114 48.4941C82.3545 48.3784 82.6643 48.4051 82.9398 48.5734C83.2155 48.7421 83.3759 49.0031 83.4207 49.3565C83.4659 49.7097 83.3823 50.053 83.1706 50.386C82.959 50.719 82.6813 50.9433 82.3381 51.059L81.9226 51.199C81.9226 51.199 82.1469 52.4879 83.2123 52.4707C83.7196 52.1746 84.149 51.7512 84.5001 51.1995C84.9929 50.4237 85.187 49.6227 85.0816 48.796C84.976 47.97 84.6023 47.3603 83.9602 46.9672Z",
    fill: "url(#paint48_linear_258_570)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5371,
    y: 78.4782,
    width: 16.9449,
    height: 15.6612,
    fill: "url(#pattern0)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8201 89.7595L17.1328 93.6615L21.1693 94.0217L27.4951 90.2398L23.8201 87.8985V89.7595Z",
    fill: "#091523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1031 93.6107L16.9436 93.7038L17.1276 93.7202L21.1641 94.0804L21.1831 94.0821L21.1995 94.0723L27.5253 90.2903L27.6072 90.2413L27.5268 90.1901L23.8518 87.8489L23.7612 87.7912V87.8985V89.7257L17.1031 93.6107Z",
    stroke: "#091523",
    strokeWidth: 0.117754
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.2598,
    y: 66.4399,
    width: 24.5893,
    height: 22.7264,
    transform: "rotate(-1.49929 88.2598 66.4399)",
    fill: "url(#pattern1)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.954 82.3006L98.4014 88.2149L104.271 88.5841L113.303 82.8577L107.883 79.601L107.954 82.3006Z",
    fill: "#4B68CD",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3565 88.1422L98.1286 88.2833L98.3961 88.3001L104.265 88.6694L104.293 88.6711L104.316 88.6563L113.349 82.9299L113.466 82.8557L113.347 82.7845L107.927 79.5278L107.794 79.4475L107.798 79.6032L107.867 82.2538L98.3565 88.1422Z",
    stroke: "#4B68CD",
    strokeOpacity: 0.7,
    strokeWidth: 0.170876
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4922,
    y: 98.2609,
    width: 20.3714,
    height: 18.8406,
    fill: "url(#pattern2)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.438 111.692L98.3828 116.644L103.245 117.101L110.865 112.301L106.438 109.33V111.692Z",
    fill: "#091523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.352 116.594L98.2019 116.686L98.3773 116.703L103.239 117.16L103.259 117.162L103.276 117.151L110.896 112.351L110.973 112.303L110.898 112.252L106.471 109.281L106.379 109.219V109.33V111.659L98.352 116.594Z",
    stroke: "#091523",
    strokeWidth: 0.117754
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 119.578,
    y: 85.5435,
    width: 8.24275,
    height: 7.6183,
    fill: "url(#pattern3)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_258_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.108 91.0305L122.992 92.9065L124.873 93.0797L127.82 91.2614L126.108 90.1359V91.0305Z",
    fill: "#091523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.962 92.8561L122.808 92.9487L122.987 92.9652L124.867 93.1383L124.887 93.1401L124.904 93.1298L127.851 91.3115L127.93 91.263L127.852 91.2122L126.14 90.0867L126.049 90.0267V90.1359V90.9973L122.962 92.8561Z",
    stroke: "#091523",
    strokeWidth: 0.117754
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d_258_570)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.9316,
    y: 5.00002,
    width: 22.1377,
    height: 22.1377,
    rx: 7.28424,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M534.781 36.85V5.00002L535.081 5.00002V36.6379L566.825 4.89394L567.037 5.10609L535.293 36.85H566.931V37.15H535.081V164.85H566.931V165.15H535.081V260.85H566.931V261.15H535.081V356.85H566.931V357.15H535.081V484.85H566.931V485.15H535.293L567.037 516.894L566.825 517.106L535.081 485.362V517H534.781V485.15H407.081V517H406.781V485.15H311.081V517H310.781V485.15H215.081V517H214.781V485.15H87.0813V517H86.7813L86.7813 485.362L55.0373 517.106L54.8252 516.894L86.5691 485.15H54.9313V484.85H86.7813L86.7813 357.15H54.9313V356.85H86.7813L86.7813 261.15H54.9313V260.85H86.7813L86.7812 165.15H54.9313V164.85H86.7812L86.7812 37.15H54.9313V36.85H86.5691L54.8252 5.10608L55.0373 4.89395L86.7812 36.6379L86.7812 5.00002L87.0812 5.00002V36.85H214.781V5.00002L215.081 5.00002V36.85H310.781V5.00002L311.081 5.00002V36.85H406.781V5.00002L407.081 5.00002V36.85H534.781ZM406.781 484.85H322.629C352.616 483.308 381.045 475.873 406.781 463.681V484.85ZM311.081 397.15V484.85C345.324 484.828 377.769 477.116 406.781 463.349V357.693C382.21 382.052 348.404 397.11 311.081 397.15ZM311.081 396.85V357.15H406.781V357.27C382.247 381.698 348.429 396.81 311.081 396.85ZM407.31 357.166C407.315 357.161 407.321 357.156 407.326 357.15H513.138C502.112 380.295 487.231 401.248 469.323 419.18L407.31 357.166ZM407.081 357.395C407.087 357.39 407.092 357.384 407.098 357.379L469.111 419.392C451.18 437.299 430.226 452.181 407.081 463.206V357.395ZM407.625 356.85C431.983 332.279 447.041 298.473 447.081 261.15H534.781C534.759 295.393 527.047 327.837 513.28 356.85H407.625ZM446.781 261.15C446.741 298.498 431.63 332.316 407.202 356.85H407.081V261.15H446.781ZM447.081 260.85H534.781C534.759 226.607 527.047 194.163 513.28 165.15H407.625C431.983 189.721 447.041 223.527 447.081 260.85ZM407.202 165.15C431.63 189.684 446.741 223.502 446.781 260.85H407.081V165.15H407.202ZM406.781 164.73V164.85H311.081V125.15C348.429 125.19 382.247 140.302 406.781 164.73ZM406.781 164.307C382.21 139.948 348.404 124.89 311.081 124.85V37.15C345.324 37.1725 377.769 44.8839 406.781 58.6511V164.307ZM407.098 164.621C407.092 164.616 407.087 164.61 407.081 164.605V58.7937C430.226 69.8188 451.18 84.7007 469.111 102.608L407.098 164.621ZM407.326 164.85C407.321 164.845 407.315 164.839 407.31 164.834L469.323 102.82C487.231 120.752 502.112 141.705 513.138 164.85H407.326ZM310.781 124.85L310.781 37.15C276.538 37.1725 244.094 44.8839 215.081 58.6511V164.307C239.653 139.948 273.458 124.89 310.781 124.85ZM214.553 164.834C214.547 164.839 214.542 164.845 214.536 164.85H108.725C119.75 141.705 134.632 120.752 152.539 102.82L214.553 164.834ZM214.781 164.605C214.776 164.61 214.77 164.616 214.765 164.621L152.752 102.608C170.683 84.7007 191.636 69.8189 214.781 58.7937L214.781 164.605ZM214.238 165.15C189.88 189.721 174.822 223.527 174.781 260.85H87.0813C87.1037 226.607 94.8151 194.163 108.582 165.15H214.238ZM175.081 260.85C175.122 223.502 190.233 189.684 214.661 165.15H214.781V260.85H175.081ZM174.781 261.15H87.0813C87.1037 295.393 94.8151 327.837 108.582 356.85H214.238C189.88 332.279 174.822 298.473 174.781 261.15ZM214.661 356.85C190.233 332.316 175.122 298.498 175.081 261.15H214.781V356.85H214.661ZM215.081 357.27V357.15H310.781V396.85C273.434 396.81 239.616 381.698 215.081 357.27ZM215.081 357.693C239.653 382.052 273.458 397.11 310.781 397.15L310.781 484.85C276.538 484.828 244.094 477.116 215.081 463.349V357.693ZM214.765 357.379C214.77 357.384 214.776 357.39 214.781 357.395L214.781 463.206C191.636 452.181 170.683 437.299 152.752 419.392L214.765 357.379ZM214.536 357.15C214.542 357.156 214.547 357.161 214.553 357.166L152.539 419.18C134.632 401.248 119.75 380.295 108.725 357.15H214.536ZM215.081 164.73C239.616 140.302 273.434 125.19 310.781 125.15V164.85H215.081V164.73ZM407.081 484.85V463.539C430.308 452.493 451.335 437.569 469.323 419.604L534.569 484.85H407.081ZM534.781 484.638L469.535 419.392C487.5 401.403 502.424 380.377 513.47 357.15H534.781V484.638ZM534.781 356.85H513.612C525.805 331.114 533.24 302.685 534.781 272.698V356.85ZM534.781 165.15V249.302C533.24 219.315 525.805 190.886 513.612 165.15H534.781ZM534.781 164.85H513.47C502.424 141.623 487.5 120.597 469.535 102.608L534.781 37.3622V164.85ZM534.569 37.15L469.323 102.396C451.335 84.4313 430.308 69.5074 407.081 58.4614V37.15H534.569ZM322.629 37.15C352.616 38.6917 381.045 46.1266 406.781 58.319V37.15H322.629ZM215.081 37.15H299.233C269.247 38.6917 240.817 46.1266 215.081 58.319V37.15ZM214.781 37.15V58.4614C191.554 69.5075 170.528 84.4313 152.539 102.396L87.2934 37.15H214.781ZM87.0812 37.3621L152.327 102.608C134.363 120.597 119.439 141.623 108.393 164.85H87.0812L87.0812 37.3621ZM87.0812 165.15H108.25C96.0578 190.886 88.6229 219.315 87.0813 249.302L87.0812 165.15ZM87.0813 356.85L87.0813 272.698C88.6229 302.685 96.0578 331.114 108.25 356.85H87.0813ZM87.0813 357.15H108.393C119.439 380.377 134.363 401.403 152.327 419.392L87.0813 484.638L87.0813 357.15ZM87.2934 484.85L152.539 419.604C170.528 437.569 191.554 452.493 214.781 463.539V484.85H87.2934ZM299.233 484.85C269.247 483.308 240.817 475.873 215.081 463.681V484.85H299.233ZM311.081 356.85C337.436 356.81 361.297 346.133 378.601 328.882L311.081 261.362V356.85ZM310.781 356.85V261.362L243.261 328.882C260.565 346.133 284.426 356.81 310.781 356.85ZM243.049 328.67L310.569 261.15H215.081C215.122 287.505 225.799 311.366 243.049 328.67ZM215.081 268.651C216.927 292.099 227.185 313.181 242.837 328.882L215.081 356.638V268.651ZM215.081 260.85H310.569L243.049 193.33C225.799 210.634 215.122 234.495 215.081 260.85ZM242.837 193.118C227.185 208.819 216.927 229.901 215.081 253.349V165.362L242.837 193.118ZM243.261 193.118L310.781 260.638V165.15C284.426 165.191 260.565 175.867 243.261 193.118ZM311.081 165.15C337.436 165.19 361.297 175.867 378.601 193.118L311.081 260.638V165.15ZM378.813 192.906C363.112 177.253 342.03 166.996 318.583 165.15H406.569L378.813 192.906ZM378.813 193.33L311.293 260.85H406.781C406.741 234.495 396.064 210.634 378.813 193.33ZM406.781 253.349C404.935 229.901 394.678 208.819 379.026 193.118L406.781 165.362V253.349ZM406.781 261.15C406.741 287.505 396.064 311.366 378.813 328.67L311.293 261.15H406.781ZM379.026 328.882C394.678 313.181 404.935 292.099 406.781 268.651V356.638L379.026 328.882ZM378.813 329.094L406.569 356.85H318.583C342.03 355.004 363.112 344.747 378.813 329.094ZM303.28 356.85H215.293L243.049 329.094C258.75 344.747 279.832 355.004 303.28 356.85ZM303.28 165.15C279.832 166.996 258.75 177.253 243.049 192.906L215.293 165.15H303.28Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_258_570)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1377,
    height: 22.1377,
    transform: "translate(54.9316 5.00002)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.9316,
    y: 5.00002,
    width: 22.1377,
    height: 22.1377,
    fill: "url(#paint49_radial_258_570)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_258_570)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-478-outside-1_258_570",
    maskUnits: "userSpaceOnUse",
    x: 56.8914,
    y: 7.64717,
    width: 16.6711,
    height: 15.27,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 56.8914,
    y: 7.64717,
    width: 16.6711,
    height: 15.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1923 12.3838C63.2783 12.3161 63.3245 12.2717 63.3736 12.2414C63.9689 11.8368 64.6362 11.6104 65.3321 11.4608C65.4081 11.4497 65.4794 11.4177 65.5382 11.3683C65.5969 11.319 65.6409 11.2543 65.665 11.1814C65.7612 10.9381 65.8212 10.6944 65.7728 10.4329C65.7544 10.364 65.7325 10.2962 65.7069 10.2297C65.3227 10.7076 64.8014 10.9229 64.2997 11.1642C63.798 11.4055 63.3224 11.6569 62.8999 12.0147C62.8669 12.035 62.8299 12.0482 62.7915 12.0534C62.7531 12.0586 62.714 12.0556 62.6768 12.0448C61.7846 11.7851 60.9442 11.9293 60.1615 12.4041C59.9938 12.5164 59.8542 12.6658 59.7537 12.8408C59.5046 13.2446 59.6291 13.6507 60.0549 13.925C60.5048 14.2141 61.0042 14.3605 61.5256 14.4453C61.6264 14.4514 61.7257 14.4731 61.8199 14.5096C61.8947 14.5478 61.943 14.6366 62.0027 14.7026C61.9377 14.7589 61.8777 14.8588 61.8041 14.8706C61.5634 14.9086 61.3206 14.9315 61.077 14.9391C60.3144 14.9697 59.7125 15.271 59.3295 15.953C59.3123 15.9832 59.3019 16.0159 59.2738 16.0808C59.351 16.0918 59.4289 16.0985 59.5069 16.1009C61.1221 16.0658 62.6988 16.2743 64.2242 16.8274C65.1831 17.1695 66.0895 17.6438 66.9173 18.2364C68.0327 19.0385 68.9589 20.0753 69.6307 21.2738C69.6587 21.3229 69.692 21.3691 69.7234 21.417L69.7717 21.4057C69.7553 21.1567 69.7484 20.9059 69.7206 20.6582C69.5637 19.2334 69.1666 17.8851 68.4175 16.6531C67.8112 15.6551 67.0086 14.8597 65.9541 14.3429C65.4314 14.0804 64.8685 13.9073 64.2886 13.8308C64.1835 13.8142 64.0844 13.7713 64.0004 13.706C63.9704 13.6804 63.9462 13.6488 63.9294 13.6131C63.9125 13.5775 63.9035 13.5386 63.9029 13.4992C63.907 13.4574 64.0147 13.3994 64.0802 13.3929C64.6717 13.3325 65.2624 13.2778 65.8548 13.2332C66.46 13.1877 67.0666 13.1722 67.6516 12.984C68.1686 12.8195 68.576 12.5249 68.7722 11.9948C68.7919 11.9416 68.802 11.8859 68.8254 11.8004C68.6411 11.8241 68.4902 11.8502 68.3395 11.8675C67.7872 11.9334 67.2459 11.8268 66.7093 11.7325C65.5634 11.5308 64.5008 11.7557 63.4846 12.2822C63.4217 12.3146 63.3579 12.3446 63.2934 12.3744C63.2601 12.3804 63.2263 12.3835 63.1923 12.3838ZM61.4426 12.6747C61.5311 12.6464 61.6279 12.5772 61.7057 12.5986C61.8323 12.6236 61.8905 12.7358 61.8533 12.8716C61.8488 12.898 61.8388 12.9232 61.8238 12.9454C61.8089 12.9677 61.7895 12.9865 61.7668 13.0007C61.7441 13.015 61.7186 13.0242 61.6921 13.0279C61.6655 13.0316 61.6385 13.0296 61.6128 13.0221C61.5018 12.9999 61.4252 12.8441 61.4426 12.6747Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.1923 12.3838C63.2783 12.3161 63.3245 12.2717 63.3736 12.2414C63.9689 11.8368 64.6362 11.6104 65.3321 11.4608C65.4081 11.4497 65.4794 11.4177 65.5382 11.3683C65.5969 11.319 65.6409 11.2543 65.665 11.1814C65.7612 10.9381 65.8212 10.6944 65.7728 10.4329C65.7544 10.364 65.7325 10.2962 65.7069 10.2297C65.3227 10.7076 64.8014 10.9229 64.2997 11.1642C63.798 11.4055 63.3224 11.6569 62.8999 12.0147C62.8669 12.035 62.8299 12.0482 62.7915 12.0534C62.7531 12.0586 62.714 12.0556 62.6768 12.0448C61.7846 11.7851 60.9442 11.9293 60.1615 12.4041C59.9938 12.5164 59.8542 12.6658 59.7537 12.8408C59.5046 13.2446 59.6291 13.6507 60.0549 13.925C60.5048 14.2141 61.0042 14.3605 61.5256 14.4453C61.6264 14.4514 61.7257 14.4731 61.8199 14.5096C61.8947 14.5478 61.943 14.6366 62.0027 14.7026C61.9377 14.7589 61.8777 14.8588 61.8041 14.8706C61.5634 14.9086 61.3206 14.9315 61.077 14.9391C60.3144 14.9697 59.7125 15.271 59.3295 15.953C59.3123 15.9832 59.3019 16.0159 59.2738 16.0808C59.351 16.0918 59.4289 16.0985 59.5069 16.1009C61.1221 16.0658 62.6988 16.2743 64.2242 16.8274C65.1831 17.1695 66.0895 17.6438 66.9173 18.2364C68.0327 19.0385 68.9589 20.0753 69.6307 21.2738C69.6587 21.3229 69.692 21.3691 69.7234 21.417L69.7717 21.4057C69.7553 21.1567 69.7484 20.9059 69.7206 20.6582C69.5637 19.2334 69.1666 17.8851 68.4175 16.6531C67.8112 15.6551 67.0086 14.8597 65.9541 14.3429C65.4314 14.0804 64.8685 13.9073 64.2886 13.8308C64.1835 13.8142 64.0844 13.7713 64.0004 13.706C63.9704 13.6804 63.9462 13.6488 63.9294 13.6131C63.9125 13.5775 63.9035 13.5386 63.9029 13.4992C63.907 13.4574 64.0147 13.3994 64.0802 13.3929C64.6717 13.3325 65.2624 13.2778 65.8548 13.2332C66.46 13.1877 67.0666 13.1722 67.6516 12.984C68.1686 12.8195 68.576 12.5249 68.7722 11.9948C68.7919 11.9416 68.802 11.8859 68.8254 11.8004C68.6411 11.8241 68.4902 11.8502 68.3395 11.8675C67.7872 11.9334 67.2459 11.8268 66.7093 11.7325C65.5634 11.5308 64.5008 11.7557 63.4846 12.2822C63.4217 12.3146 63.3579 12.3446 63.2934 12.3744C63.2601 12.3804 63.2263 12.3835 63.1923 12.3838ZM61.4426 12.6747C61.5311 12.6464 61.6279 12.5772 61.7057 12.5986C61.8323 12.6236 61.8905 12.7358 61.8533 12.8716C61.8488 12.898 61.8388 12.9232 61.8238 12.9454C61.8089 12.9677 61.7895 12.9865 61.7668 13.0007C61.7441 13.015 61.7186 13.0242 61.6921 13.0279C61.6655 13.0316 61.6385 13.0296 61.6128 13.0221C61.5018 12.9999 61.4252 12.8441 61.4426 12.6747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1923 12.3838L63.1995 13.3713C62.7774 13.3744 62.3999 13.1087 62.2603 12.7103C62.1207 12.3118 62.2499 11.8687 62.5817 11.6077L63.1923 12.3838ZM63.3736 12.2414L63.9287 13.0582C63.9168 13.0663 63.9048 13.0741 63.8925 13.0816L63.3736 12.2414ZM65.3321 11.4608L65.1246 10.4953C65.1459 10.4907 65.1674 10.4869 65.189 10.4837L65.3321 11.4608ZM65.665 11.1814L64.7274 10.8711C64.7333 10.8533 64.7397 10.8357 64.7466 10.8182L65.665 11.1814ZM65.7728 10.4329L66.7271 10.1791C66.7336 10.2035 66.7392 10.2281 66.7438 10.2529L65.7728 10.4329ZM65.7069 10.2297L64.9372 9.61093C65.1586 9.33551 65.5103 9.19938 65.8594 9.25395C66.2085 9.30852 66.5019 9.54549 66.6287 9.87533L65.7069 10.2297ZM62.8999 12.0147L63.5382 12.7683C63.5 12.8006 63.4594 12.83 63.4168 12.8562L62.8999 12.0147ZM62.6768 12.0448L62.4011 12.9931L62.4007 12.993L62.6768 12.0448ZM60.1615 12.4041L59.612 11.5835C59.6243 11.5753 59.6367 11.5674 59.6492 11.5598L60.1615 12.4041ZM59.7537 12.8408L60.61 13.3328C60.6049 13.3417 60.5996 13.3505 60.5942 13.3593L59.7537 12.8408ZM60.0549 13.925L59.5211 14.7558L59.52 14.7552L60.0549 13.925ZM61.5256 14.4453L61.466 15.4311C61.4328 15.4291 61.3997 15.4254 61.3669 15.4201L61.5256 14.4453ZM61.8199 14.5096L62.1766 13.5887C62.2083 13.601 62.2394 13.6149 62.2697 13.6304L61.8199 14.5096ZM62.0027 14.7026L62.7349 14.0399C62.9132 14.2369 63.0046 14.4975 62.9884 14.7627C62.9723 15.028 62.8499 15.2755 62.6489 15.4494L62.0027 14.7026ZM61.8041 14.8706L61.9594 15.8458L61.9582 15.846L61.8041 14.8706ZM61.077 14.9391L61.0374 13.9523L61.0462 13.952L61.077 14.9391ZM59.3295 15.953L60.1906 16.4366L60.1879 16.4413L59.3295 15.953ZM59.2738 16.0808L59.1352 17.0586C58.8301 17.0153 58.5627 16.8322 58.4121 16.5633C58.2616 16.2945 58.2451 15.9707 58.3677 15.688L59.2738 16.0808ZM59.5069 16.1009L59.5283 17.0882C59.5109 17.0886 59.4936 17.0885 59.4762 17.088L59.5069 16.1009ZM64.2242 16.8274L63.8923 17.7575L63.8876 17.7558L64.2242 16.8274ZM66.9173 18.2364L67.4921 17.4334L67.4938 17.4346L66.9173 18.2364ZM69.6307 21.2738L68.7728 21.763L68.7692 21.7566L69.6307 21.2738ZM69.7234 21.417L69.9473 22.3788C69.5438 22.4728 69.1245 22.3048 68.8974 21.9583L69.7234 21.417ZM69.7717 21.4057L70.7571 21.3411C70.7887 21.8235 70.4665 22.2579 69.9956 22.3675L69.7717 21.4057ZM69.7206 20.6582L68.7392 20.7684L68.739 20.7663L69.7206 20.6582ZM68.4175 16.6531L67.5737 17.1662L67.5735 17.1659L68.4175 16.6531ZM65.9541 14.3429L65.5195 15.2297L65.5109 15.2254L65.9541 14.3429ZM64.2886 13.8308L64.1594 14.8098C64.1513 14.8088 64.1432 14.8076 64.1351 14.8063L64.2886 13.8308ZM64.0004 13.706L63.3939 14.4853C63.3825 14.4765 63.3713 14.4674 63.3604 14.458L64.0004 13.706ZM63.9029 13.4992L62.9155 13.515C62.9149 13.478 62.9164 13.441 62.9199 13.4042L63.9029 13.4992ZM64.0802 13.3929L64.1805 14.3753L64.1781 14.3756L64.0802 13.3929ZM65.8548 13.2332L65.7806 12.2484L65.7807 12.2484L65.8548 13.2332ZM67.6516 12.984L67.3492 12.0439L67.3521 12.0429L67.6516 12.984ZM68.7722 11.9948L67.846 11.652L67.8464 11.651L68.7722 11.9948ZM68.8254 11.8004L68.6997 10.8209C69.0272 10.7788 69.354 10.9033 69.5707 11.1525C69.7873 11.4016 69.8651 11.7426 69.7779 12.0611L68.8254 11.8004ZM68.3395 11.8675L68.2224 10.8869L68.2269 10.8864L68.3395 11.8675ZM66.7093 11.7325L66.5385 12.7052L66.5381 12.7051L66.7093 11.7325ZM63.4846 12.2822L63.939 13.1591L63.9367 13.1603L63.4846 12.2822ZM63.2934 12.3744L63.7076 13.2709C63.6313 13.3062 63.5507 13.3315 63.468 13.3464L63.2934 12.3744ZM61.4426 12.6747L60.4603 12.5735C60.5005 12.1834 60.7677 11.854 61.1412 11.7343L61.4426 12.6747ZM61.7057 12.5986L61.5143 13.5674C61.4911 13.5628 61.468 13.5573 61.4451 13.5511L61.7057 12.5986ZM61.8533 12.8716L60.8798 12.7054C60.8853 12.6736 60.8923 12.642 60.9008 12.6109L61.8533 12.8716ZM61.6128 13.0221L61.8067 12.0538C61.8343 12.0593 61.8617 12.066 61.8888 12.0739L61.6128 13.0221ZM62.5817 11.6077C62.614 11.5822 62.6285 11.5695 62.6701 11.5353C62.7015 11.5096 62.7692 11.454 62.8546 11.4013L63.8925 13.0816C63.9129 13.069 63.9266 13.059 63.9312 13.0555C63.9349 13.0527 63.9342 13.0531 63.9234 13.0619C63.9183 13.0661 63.9127 13.0708 63.9046 13.0774C63.8971 13.0836 63.8877 13.0914 63.8776 13.0997C63.857 13.1167 63.8321 13.137 63.803 13.1599L62.5817 11.6077ZM62.8184 11.4247C63.5571 10.9226 64.3592 10.6599 65.1246 10.4953L65.5397 12.4263C64.9132 12.561 64.3806 12.751 63.9287 13.0582L62.8184 11.4247ZM65.189 10.4837C65.0836 10.4991 64.9847 10.5436 64.9032 10.6119L66.1731 12.1247C65.9741 12.2917 65.7326 12.4002 65.4753 12.4379L65.189 10.4837ZM64.9032 10.6119C64.8218 10.6803 64.7609 10.77 64.7274 10.8711L66.6025 11.4918C66.5208 11.7386 66.3721 11.9577 66.1731 12.1247L64.9032 10.6119ZM64.7466 10.8182C64.7802 10.7333 64.794 10.6815 64.7994 10.6493C64.804 10.6219 64.8019 10.6136 64.8017 10.6129L66.7438 10.2529C66.8416 10.7805 66.7077 11.2301 66.5833 11.5446L64.7466 10.8182ZM64.8184 10.6867C64.8091 10.6518 64.798 10.6176 64.7851 10.584L66.6287 9.87533C66.6669 9.97482 66.6998 10.0762 66.7271 10.1791L64.8184 10.6867ZM66.4766 10.8484C65.9208 11.5398 65.1526 11.8498 64.7277 12.0541L63.8716 10.2742C64.4502 9.99592 64.7245 9.87548 64.9372 9.61093L66.4766 10.8484ZM64.7277 12.0541C64.2395 12.289 63.8596 12.4961 63.5382 12.7683L62.2616 11.2612C62.7852 10.8177 63.3564 10.522 63.8716 10.2742L64.7277 12.0541ZM63.4168 12.8562C63.2665 12.9485 63.0984 13.0085 62.9234 13.0321L62.6596 11.0747C62.5614 11.0879 62.4672 11.1215 62.383 11.1733L63.4168 12.8562ZM62.9234 13.0321C62.7483 13.0557 62.5704 13.0423 62.4011 12.9931L62.9524 11.0965C62.8576 11.069 62.7579 11.0614 62.6596 11.0747L62.9234 13.0321ZM62.4007 12.993C61.7985 12.8177 61.2423 12.9035 60.6737 13.2485L59.6492 11.5598C60.6461 10.955 61.7707 10.7525 62.9528 11.0966L62.4007 12.993ZM60.7109 13.2247C60.6694 13.2525 60.6349 13.2895 60.61 13.3328L58.8974 12.3489C59.0736 12.0422 59.3182 11.7803 59.612 11.5835L60.7109 13.2247ZM60.5942 13.3593C60.5902 13.3658 60.6026 13.3478 60.6096 13.3061C60.617 13.2622 60.6152 13.2106 60.6008 13.1602C60.5716 13.0578 60.5209 13.0505 60.5898 13.0949L59.52 14.7552C59.1632 14.5252 58.8373 14.1777 58.7017 13.7027C58.5609 13.2099 58.6661 12.7229 58.9132 12.3224L60.5942 13.3593ZM60.5888 13.0942C60.884 13.2839 61.2383 13.398 61.6843 13.4706L61.3669 15.4201C60.7701 15.3229 60.1257 15.1444 59.5211 14.7558L60.5888 13.0942ZM61.5851 13.4596C61.7878 13.4718 61.9873 13.5154 62.1766 13.5887L61.4633 15.4305C61.4641 15.4308 61.4651 15.431 61.466 15.4311L61.5851 13.4596ZM62.2697 13.6304C62.4949 13.7457 62.6314 13.9096 62.6806 13.9695C62.7066 14.0013 62.7357 14.0394 62.7402 14.0453C62.7519 14.0604 62.7468 14.0531 62.7349 14.0399L61.2706 15.3654C61.2287 15.3192 61.1952 15.276 61.1787 15.2547C61.1742 15.2489 61.1698 15.2431 61.1665 15.239C61.163 15.2344 61.1605 15.2311 61.1582 15.2282C61.1536 15.2222 61.1525 15.221 61.1533 15.2219C61.1537 15.2224 61.1712 15.2441 61.2021 15.2725C61.2339 15.3019 61.2896 15.3476 61.3701 15.3888L62.2697 13.6304ZM62.6489 15.4494C62.6795 15.4229 62.6963 15.4032 62.6846 15.4161C62.6754 15.4261 62.6791 15.4222 62.6625 15.4405C62.6521 15.452 62.636 15.4697 62.6172 15.4891C62.5834 15.5242 62.5162 15.5913 62.4236 15.6562C62.3299 15.7218 62.1727 15.8119 61.9594 15.8458L61.6489 13.8953C61.4724 13.9234 61.3502 13.9966 61.2905 14.0384C61.2319 14.0795 61.1976 14.1159 61.196 14.1175C61.1934 14.1202 61.1933 14.1204 61.1989 14.1143C61.2017 14.1113 61.2043 14.1083 61.209 14.1031C61.2131 14.0986 61.2186 14.0924 61.2246 14.0858C61.2447 14.0638 61.2934 14.0105 61.3565 13.9559L62.6489 15.4494ZM61.9582 15.846C61.6767 15.8905 61.3927 15.9172 61.1079 15.9261L61.0462 13.952C61.2485 13.9457 61.4502 13.9267 61.6501 13.8951L61.9582 15.846ZM61.1166 15.9258C60.6354 15.9451 60.3777 16.1033 60.1905 16.4366L58.4684 15.4695C59.0473 14.4387 59.9934 13.9942 61.0374 13.9523L61.1166 15.9258ZM60.1879 16.4413C60.2006 16.419 60.2094 16.4007 60.2146 16.3895C60.2171 16.3841 60.2187 16.3803 60.2193 16.379C60.2198 16.3777 60.2198 16.3777 60.2188 16.3803C60.2176 16.383 60.2163 16.3863 60.2139 16.3922C60.2117 16.3976 60.2087 16.405 60.2054 16.413C60.1986 16.4295 60.1901 16.4498 60.1798 16.4736L58.3677 15.688C58.3771 15.6664 58.3787 15.6616 58.3927 15.6275C58.4033 15.6018 58.4298 15.5374 58.471 15.4648L60.1879 16.4413ZM59.4123 15.103C59.4539 15.1089 59.4957 15.1125 59.5375 15.1138L59.4762 17.088C59.362 17.0844 59.2481 17.0746 59.1352 17.0586L59.4123 15.103ZM59.4854 15.1136C61.2009 15.0763 62.902 15.2975 64.5609 15.8989L63.8876 17.7558C62.4957 17.2511 61.0433 17.0553 59.5283 17.0882L59.4854 15.1136ZM64.5562 15.8973C65.6015 16.2703 66.5897 16.7874 67.4921 17.4334L66.3424 19.0394C65.5893 18.5003 64.7646 18.0688 63.8923 17.7574L64.5562 15.8973ZM67.4938 17.4346C68.7264 18.321 69.7498 19.4666 70.4922 20.7909L68.7692 21.7566C68.168 20.684 67.3391 19.7561 66.3407 19.0382L67.4938 17.4346ZM70.4886 20.7846C70.486 20.7801 70.4869 20.7821 70.498 20.7988C70.5038 20.8075 70.5093 20.8156 70.5186 20.8294C70.5269 20.8418 70.5378 20.8581 70.5494 20.8757L68.8974 21.9583C68.8806 21.9326 68.8842 21.9389 68.8536 21.8929C68.8332 21.8623 68.8034 21.8166 68.7728 21.763L70.4886 20.7846ZM69.4994 20.4551L69.5477 20.4439L69.9956 22.3675L69.9473 22.3788L69.4994 20.4551ZM68.7862 21.4703C68.7665 21.1697 68.7638 20.9873 68.7392 20.7684L70.702 20.5481C70.733 20.8245 70.7442 21.1438 70.7571 21.3411L68.7862 21.4703ZM68.739 20.7663C68.5948 19.4562 68.2341 18.2524 67.5737 17.1662L69.2614 16.1401C70.0991 17.5178 70.5327 19.0106 70.7022 20.5501L68.739 20.7663ZM67.5735 17.1659C67.0504 16.3049 66.3808 15.6518 65.5195 15.2297L66.3887 13.4561C67.6363 14.0676 68.5719 15.0053 69.2615 16.1404L67.5735 17.1659ZM65.5109 15.2254C65.0867 15.0124 64.6299 14.8719 64.1594 14.8098L64.4178 12.8517C65.107 12.9426 65.7761 13.1484 66.3974 13.4604L65.5109 15.2254ZM64.1351 14.8063C63.8648 14.7638 63.6098 14.6533 63.3939 14.4853L64.607 12.9266C64.559 12.8893 64.5023 12.8647 64.4421 12.8552L64.1351 14.8063ZM63.3604 14.458C63.2236 14.3416 63.113 14.1972 63.0362 14.0345L64.8225 13.1918C64.7794 13.1003 64.7173 13.0193 64.6405 12.9539L63.3604 14.458ZM63.0362 14.0345C62.9594 13.8717 62.9183 13.6945 62.9155 13.515L64.8903 13.4835C64.8887 13.3827 64.8657 13.2833 64.8225 13.1918L63.0362 14.0345ZM62.9199 13.4042C62.9556 13.035 63.1768 12.8143 63.233 12.7594C63.3221 12.6724 63.4121 12.6137 63.4753 12.5772C63.587 12.5129 63.7663 12.4317 63.9823 12.4102L64.1781 14.3756C64.3286 14.3606 64.4213 14.3117 64.4617 14.2884C64.4893 14.2725 64.5475 14.2365 64.6132 14.1723C64.6467 14.1395 64.6989 14.0832 64.7492 14.0019C64.7979 13.923 64.8676 13.7837 64.8859 13.5943L62.9199 13.4042ZM63.9799 12.4104C64.5774 12.3494 65.1771 12.2939 65.7806 12.2484L65.9289 14.218C65.3476 14.2617 64.766 14.3155 64.1805 14.3753L63.9799 12.4104ZM65.7807 12.2484C66.4573 12.1975 66.9065 12.1863 67.3492 12.0439L67.954 13.9241C67.2267 14.158 66.4626 14.1778 65.9288 14.218L65.7807 12.2484ZM67.3521 12.0429C67.6735 11.9407 67.7856 11.8154 67.846 11.652L69.6984 12.3376C69.3664 13.2345 68.6637 13.6983 67.951 13.9251L67.3521 12.0429ZM67.8464 11.651C67.8369 11.6766 67.8338 11.692 67.84 11.6675C67.8414 11.6621 67.8429 11.656 67.845 11.6475C67.847 11.6395 67.8495 11.6294 67.8522 11.6187C67.8577 11.5968 67.8646 11.5701 67.8729 11.5397L69.7779 12.0611C69.7696 12.0917 69.7669 12.104 69.7548 12.1519C69.7452 12.1899 69.7272 12.2598 69.698 12.3385L67.8464 11.651ZM68.9511 12.7799C68.8521 12.7926 68.5811 12.8338 68.4521 12.8486L68.2269 10.8864C68.3993 10.8666 68.4301 10.8555 68.6997 10.8209L68.9511 12.7799ZM68.4566 12.8481C67.7296 12.9349 67.0302 12.7915 66.5385 12.7052L66.8801 10.7598C67.4616 10.862 67.8449 10.932 68.2224 10.8869L68.4566 12.8481ZM66.5381 12.7051C65.6409 12.5472 64.7973 12.7143 63.939 13.1591L63.0303 11.4054C64.2044 10.797 65.486 10.5144 66.8805 10.7599L66.5381 12.7051ZM63.9367 13.1603C63.854 13.2028 63.7744 13.24 63.7076 13.2709L62.8793 11.4779C62.9414 11.4492 62.9893 11.4265 63.0326 11.4042L63.9367 13.1603ZM63.468 13.3464C63.3794 13.3623 63.2896 13.3706 63.1995 13.3713L63.1852 11.3962C63.1629 11.3964 63.1407 11.3985 63.1189 11.4024L63.468 13.3464ZM61.1412 11.7343C61.1085 11.7448 61.0896 11.7541 61.1079 11.7459C61.11 11.745 61.1642 11.7202 61.2085 11.7023C61.2576 11.6824 61.3502 11.6474 61.4661 11.6261C61.5853 11.6042 61.7634 11.5905 61.9664 11.646L61.4451 13.5511C61.6092 13.596 61.7459 13.5828 61.8223 13.5688C61.8955 13.5554 61.9437 13.5354 61.9479 13.5337C61.9523 13.532 61.9531 13.5315 61.9461 13.5346C61.9427 13.5361 61.939 13.5378 61.933 13.5405C61.9277 13.5429 61.9202 13.5463 61.9123 13.5498C61.8852 13.5619 61.821 13.5905 61.7441 13.6151L61.1412 11.7343ZM61.8971 11.6297C62.2244 11.6944 62.5344 11.8958 62.7121 12.2284C62.881 12.5447 62.876 12.8758 62.8058 13.1323L60.9008 12.6109C60.8677 12.7316 60.8523 12.9387 60.9698 13.1587C61.0959 13.395 61.3136 13.5277 61.5143 13.5674L61.8971 11.6297ZM62.8268 13.0378C62.7988 13.2015 62.7366 13.3573 62.6443 13.4951L61.0034 12.3957C60.9409 12.489 60.8988 12.5945 60.8798 12.7054L62.8268 13.0378ZM62.6443 13.4951C62.5519 13.633 62.4314 13.7498 62.2907 13.8379L61.2428 12.1636C61.1475 12.2233 61.066 12.3024 61.0034 12.3957L62.6443 13.4951ZM62.2907 13.8379C62.1499 13.926 61.9922 13.9832 61.8279 14.0061L61.5562 12.0497C61.445 12.0652 61.3382 12.104 61.2428 12.1636L62.2907 13.8379ZM61.8279 14.0061C61.6636 14.0289 61.4963 14.0168 61.3368 13.9703L61.8888 12.0739C61.7807 12.0425 61.6674 12.0343 61.5562 12.0497L61.8279 14.0061ZM61.4189 13.9905C60.9571 13.898 60.7037 13.5644 60.5929 13.3384C60.4738 13.0956 60.4342 12.8264 60.4603 12.5735L62.425 12.776C62.4336 12.6924 62.4236 12.5858 62.3662 12.4688C62.3171 12.3686 62.1575 12.1241 61.8067 12.0538L61.4189 13.9905Z",
    fill: "#849FFF",
    mask: "url(#path-478-outside-1_258_570)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.2632 11.5588C60.7877 11.6272 61.2702 11.884 61.6186 12.2803C61.8368 12.5386 62.0338 12.8137 62.2078 13.1028C62.231 13.1553 62.2406 13.2125 62.2358 13.2693C62.2309 13.3261 62.2117 13.3807 62.1799 13.428C61.8937 13.6712 61.587 13.8722 61.1678 13.8611C61.037 13.8574 60.9091 13.8202 60.7967 13.753C60.6842 13.6859 60.591 13.5911 60.5262 13.4781C60.386 13.2512 60.2735 13.0088 60.1912 12.7561C60.1314 12.5903 60.0602 12.566 59.9118 12.6337C59.6409 12.76 59.3663 12.8719 59.0488 12.8274C59.0127 12.8326 58.9786 12.8462 58.949 12.867C58.9194 12.8878 58.8952 12.9152 58.8784 12.947L58.8749 12.6902C59.0215 12.0425 59.8243 11.5461 59.8243 11.5461C59.865 11.5293 59.9072 11.5162 59.9504 11.5071L59.9603 11.5531C60.0612 11.5485 60.1624 11.5504 60.2632 11.5588Z",
    fill: "#849FFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_258_570",
    x: 98.499,
    y: 64.8179,
    width: 32.502,
    height: 18.8416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_258_570",
    x: 106.624,
    y: 53.396,
    width: 24.376,
    height: 14.1312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_258_570",
    x: 33.499,
    y: 64.8176,
    width: 40.627,
    height: 23.5519,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_258_570",
    x: 33.5,
    y: 53.396,
    width: 24.376,
    height: 14.1312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_258_570",
    x: 44.0049,
    y: 51.1259,
    width: 11.4902,
    height: 6.66115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_258_570",
    x: 0.998047,
    y: 64.8174,
    width: 48.7529,
    height: 28.2623,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_258_570",
    x: 49.75,
    y: 78.9485,
    width: 32.501,
    height: 18.8413,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_258_570",
    x: 65.999,
    y: 83.6584,
    width: 32.502,
    height: 14.1312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_258_570",
    x: 33.499,
    y: 83.6584,
    width: 24.376,
    height: 18.8416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_258_570",
    x: 0.999023,
    y: 53.5135,
    width: 32.502,
    height: 18.8416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_258_570",
    x: 10.5186,
    y: 49.7464,
    width: 14.8564,
    height: 18.8416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_258_570",
    x: 0.999023,
    y: 83.6584,
    width: 32.502,
    height: 18.8416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_258_570",
    x: 5.70996,
    y: 82.5996,
    width: 22.9824,
    height: 13.323,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_i_258_570",
    x: 74.125,
    y: 93.0797,
    width: 16.25,
    height: 9.42029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_i_258_570",
    x: 114.75,
    y: 84.6014,
    width: 16.25,
    height: 9.42029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_i_258_570",
    x: 109.005,
    y: 50.0661,
    width: 11.4902,
    height: 6.66115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "shape",
    result: "effect1_innerShadow_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_258_570",
    x: 54.6494,
    y: 87.0289,
    width: 35.3962,
    height: 43.8662,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.88768,
    dy: 14.6014
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.00181
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0857639 0 0 0 0 0.33427 0 0 0 0 0.791667 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_258_570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_258_570",
    x: 62.3251,
    y: 93.1935,
    width: 11.8362,
    height: 13.5055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.71345
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.71345
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_258_570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_258_570",
    x: 72.9443,
    y: 42.0253,
    width: 27.6728,
    height: 37.4397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.81504,
    dy: 18.9289
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37275
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_258_570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_258_570",
    x: 79.0653,
    y: 46.5003,
    width: 6.27961,
    height: 7.32261,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.117754
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117754
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_258_570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_258_570",
    transform: "scale(0.00252525 0.00273224)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_258_570",
    x: 16.6371,
    y: 87.5661,
    width: 11.2004,
    height: 6.69401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0588768,
    result: "effect1_foregroundBlur_258_570"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_258_570",
    transform: "scale(0.00252525 0.00273224)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_258_570",
    x: 97.6846,
    y: 79.1232,
    width: 16.1152,
    height: 9.80579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0854378,
    result: "effect1_foregroundBlur_258_570"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_258_570",
    transform: "translate(-0.000331686) scale(0.00252693 0.00273224)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_258_570",
    x: 97.9028,
    y: 108.991,
    width: 13.2961,
    height: 8.3491,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0588768,
    result: "effect1_foregroundBlur_258_570"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_258_570",
    transform: "scale(0.00252525 0.00273224)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_258_570",
    x: 122.506,
    y: 89.7998,
    width: 5.65055,
    height: 3.51854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0588768,
    result: "effect1_foregroundBlur_258_570"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_258_570",
    x: 50.2215,
    y: 0.28987,
    width: 31.558,
    height: 31.558,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.516667 0 0 0 0 0.623 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_258_570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_258_570",
    x: 58.2861,
    y: 9.24208,
    width: 13.6491,
    height: 14.3389,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.705396,
    dy: 0.705396
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.235507
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.270833 0 0 0 0 0.541667 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_258_570"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_258_570",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_258_570",
    x1: 111.335,
    y1: 67.6449,
    x2: 118.229,
    y2: 67.6449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_258_570",
    x1: 103.21,
    y1: 72.3551,
    x2: 110.104,
    y2: 72.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_258_570",
    x1: 119.46,
    y1: 72.3551,
    x2: 126.354,
    y2: 72.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_258_570",
    x1: 111.335,
    y1: 77.0652,
    x2: 118.229,
    y2: 77.0652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_258_570",
    x1: 111.335,
    y1: 56.2228,
    x2: 118.229,
    y2: 56.2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_258_570",
    x1: 119.46,
    y1: 60.933,
    x2: 126.354,
    y2: 60.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_258_570",
    x1: 46.335,
    y1: 67.6449,
    x2: 53.2287,
    y2: 67.6449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_258_570",
    x1: 54.46,
    y1: 72.3551,
    x2: 61.3537,
    y2: 72.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_258_570",
    x1: 62.585,
    y1: 77.0652,
    x2: 69.4787,
    y2: 77.0652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_258_570",
    x1: 38.21,
    y1: 72.3551,
    x2: 45.1037,
    y2: 72.3551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_258_570",
    x1: 46.335,
    y1: 77.0652,
    x2: 53.2287,
    y2: 77.0652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_258_570",
    x1: 54.46,
    y1: 81.7753,
    x2: 61.3537,
    y2: 81.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_258_570",
    x1: 46.335,
    y1: 56.2228,
    x2: 53.2287,
    y2: 56.2228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_258_570",
    x1: 38.21,
    y1: 60.933,
    x2: 45.1037,
    y2: 60.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_258_570",
    x1: 45.2754,
    y1: 53.75,
    x2: 54.1804,
    y2: 53.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_258_570",
    x1: 43.9805,
    y1: 43.6232,
    x2: 55.471,
    y2: 43.6232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_258_570",
    x1: 46.335,
    y1: 52.5725,
    x2: 53.2287,
    y2: 52.5725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_258_570",
    x1: 70.71,
    y1: 81.7753,
    x2: 77.6037,
    y2: 81.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_258_570",
    x1: 62.585,
    y1: 86.4855,
    x2: 69.4787,
    y2: 86.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_258_570",
    x1: 54.46,
    y1: 91.1956,
    x2: 61.3537,
    y2: 91.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_258_570",
    x1: 78.835,
    y1: 86.4855,
    x2: 85.7287,
    y2: 86.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_258_570",
    x1: 70.71,
    y1: 91.1956,
    x2: 77.6037,
    y2: 91.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_258_570",
    x1: 86.96,
    y1: 91.1956,
    x2: 93.8537,
    y2: 91.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_258_570",
    x1: 46.335,
    y1: 86.4855,
    x2: 53.2287,
    y2: 86.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_258_570",
    x1: 38.21,
    y1: 91.1956,
    x2: 45.1037,
    y2: 91.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_258_570",
    x1: 46.335,
    y1: 95.9058,
    x2: 53.2287,
    y2: 95.9058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_258_570",
    x1: 13.835,
    y1: 56.3406,
    x2: 20.7287,
    y2: 56.3406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_258_570",
    x1: 5.70996,
    y1: 61.0507,
    x2: 12.6037,
    y2: 61.0507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_258_570",
    x1: 21.96,
    y1: 61.0507,
    x2: 28.8537,
    y2: 61.0507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_258_570",
    x1: 13.835,
    y1: 65.7609,
    x2: 20.7287,
    y2: 65.7609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_258_570",
    x1: 13.835,
    y1: 86.4855,
    x2: 20.7287,
    y2: 86.4855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_258_570",
    x1: 5.70996,
    y1: 91.1956,
    x2: 12.6037,
    y2: 91.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_258_570",
    x1: 21.96,
    y1: 91.1956,
    x2: 28.8537,
    y2: 91.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_258_570",
    x1: 13.835,
    y1: 95.9058,
    x2: 20.7287,
    y2: 95.9058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_258_570",
    x1: 5.70996,
    y1: 91.1956,
    x2: 28.6921,
    y2: 91.1956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_258_570",
    x1: 78.3643,
    y1: 108.859,
    x2: 74.9174,
    y2: 102.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_258_570",
    x1: 76.5977,
    y1: 108.505,
    x2: 74.2997,
    y2: 104.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_258_570",
    x1: 78.835,
    y1: 95.9058,
    x2: 85.7287,
    y2: 95.9058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_258_570",
    x1: 108.98,
    y1: 42.5634,
    x2: 120.471,
    y2: 42.5634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_258_570",
    x1: 56.9693,
    y1: 96.44,
    x2: 56.7915,
    y2: 116.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#849FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#849FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758565,
    stopColor: "#477AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833789,
    stopColor: "#4D78E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91676,
    stopColor: "#5777E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F6DD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_258_570",
    x1: 65.2027,
    y1: 94.466,
    x2: 65.2027,
    y2: 114.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#849FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831735,
    stopColor: "#89A3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_258_570",
    x1: 72.004,
    y1: 95.0856,
    x2: 58.5604,
    y2: 113.584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.670529,
    stopColor: "#6785EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925805,
    stopColor: "#4968D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_258_570",
    x1: 65.9852,
    y1: 98.2459,
    x2: 69.4197,
    y2: 103.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_258_570",
    x1: 70.6155,
    y1: 92.4232,
    x2: 70.1075,
    y2: 102.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703953,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_258_570",
    x1: 74.8111,
    y1: 45.1823,
    x2: 74.6892,
    y2: 58.6945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758565,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833789,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91676,
    stopColor: "#CACACA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_258_570",
    x1: 80.7514,
    y1: 44.518,
    x2: 80.7514,
    y2: 57.9723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831735,
    stopColor: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_258_570",
    x1: 85.4153,
    y1: 44.9429,
    x2: 76.1964,
    y2: 57.6285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.670529,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925805,
    stopColor: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_258_570",
    x1: 80.5079,
    y1: 49.0011,
    x2: 81.8457,
    y2: 53.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6382F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#5C79E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.380208,
    stopColor: "#849FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#849FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#849FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_258_570",
    x1: 84.6129,
    y1: 45.9927,
    x2: 82.5521,
    y2: 52.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#849FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#708BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#849FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E7DE9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_258_570",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.4108 7.41396) rotate(58.847) scale(21.3963)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#6184FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F50EC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_258_570"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.9316,
    y: 5.00002,
    width: 22.1377,
    height: 22.1377,
    rx: 7.28424,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_258_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1377,
    height: 22.1377,
    fill: "white",
    transform: "translate(54.9316 5.00002)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_258_570",
    width: 396,
    height: 366,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBunnyEmpty);
export default __webpack_public_path__ + "static/media/bunnyEmpty.7ea7a92ae0a1b5934ae35931e3a9e48f.svg";
export { ForwardRef as ReactComponent };